import {
  formattedMessageForPricelog,
  generateAuthorSocialDataLink,
  generateBookDetailLink,
  generateCampaignLinkNew,
  textColorStatus,
} from '../utils/Helper';
import unescape from 'lodash/unescape';
import { _formatDate, FormatDateString, FormatDateTime, isValidDateFormat } from '../utils/DateTimeHelper';
import ormToast, { TOAST_TYPE } from '../utils/ormToast';
import {
  displayAuthorLink,
  dateColumnConfig,
  dateColumnWithTimeConfig,
  displayUserName,
  displayHtmlContent,
  displayTitleLink,
  getActionColumns,
} from '../utils/columnHelper';
import { BuildServerlessBookCoverImageUrl } from '../utils/ImageHelper';
import IMAGESIZES from './IMAGESIZES';
import { Markup } from 'interweave';
import {
  Box,
  Chip,
  IconButton,
  List,
  ListItem,
  MenuItem,
  Select,
  Stack,
  Switch,
  Tooltip,
  Typography,
  capitalize,
} from '@mui/material';
import { Link } from 'react-router';
import React from 'react';
import {
  getDestinationInfoText,
  getDLPDestinationInfoText,
  getFrequencyInfoText,
  renderTriggerHistoryCell,
} from 'src/components/TriggerTitles/triggerTitleHelper';
import { STRING_OPERATOR } from 'src/components/Shared/NominationConstants';
import TransactionTableItem from 'src/components/Activation/ServiceRequests/TransactionTableItem';
import { getNumericOperators, getSingleSelectIsOperator } from 'src/components/Shared/Table/Filters/operators';
import { renderURLCell } from 'src/utils/tableValueGetter';
import { ArrowDownward, ArrowUpward, ExpandCircleDown, Remove } from '@mui/icons-material';
import PricelogStatusStepper from 'src/components/PriceLogViewer/PricelogStatusStepper';
import PopoverWithStatus from 'src/components/PriceLogViewer/PopoverWithStatus';
import {
  pricelogEntryMessage,
  renderPricelogEntryMessage,
} from 'src/components/PriceLogViewer/renderPricelogEntryMessage';
import { LENDING_DEALS_PRIORITY_TYPE_OPTIONS } from './options';
import { RichTextEditorCell } from 'src/components/Shared/UI/RichTextEditorCell';
import { RETAILERS } from './const';
import { getBookImage } from 'src/components/Nomination/NominationResultHelper';
import { getPromotionLabelHexColor } from 'src/utils/promotionLabelColor';
import { getPromotionLabelTextColor } from 'src/utils/promotionLabelHelper';
import { formatDuration } from 'src/utils/Helper';
import { DARK_WARNING_TEXT_COLOR, getWarningChipSx } from 'src/utils/synchronizerWarningChipStyles';

export const displayError = ({ value }) => (
  <div className={String(value)?.includes('[[ERROR]]') ? 'error-message' : ''}>
    {value ? String(value).replace('[[ERROR]]', '') : ''}
  </div>
);

const formatTrendPercent = value => {
  if (value === null || value === undefined || value === '') return 'n/a';
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return 'n/a';
  return `${Math.round(numeric * 100)}%`;
};

const formatTrendRelative = value => {
  if (value === null || value === undefined || value === '') return 'n/a';
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return 'n/a';
  return `${numeric.toFixed(2)}x`;
};

const buildTrendTooltip = row => {
  const summary = row?.trendSummary;
  const label = row?.trendLabel || summary?.trendLabel || 'Insufficient Data';
  if (!summary || summary.trendDirection === 'insufficient_data') {
    return `${label}: not enough eligible completed months yet.`;
  }

  return [
    `${label}: ${summary.trendExplanation || ''}`.trim(),
    `Recent 3 months: ${formatTrendPercent(summary.recentHitRate)} hit rate, ${formatTrendRelative(
      summary.recentAvgPerformanceRelativeToTarget
    )} avg relative-to-target.`,
    `Prior 3 months: ${formatTrendPercent(summary.priorHitRate)} hit rate, ${formatTrendRelative(
      summary.priorAvgPerformanceRelativeToTarget
    )} avg relative-to-target.`,
  ].join(' ');
};

const TREND_VISUALS = {
  strong_up: { icon: ArrowUpward, color: 'success.main' },
  up: { icon: ArrowUpward, color: 'success.main' },
  emerging_opportunity: { icon: ArrowUpward, color: 'info.main' },
  improving_consistency: { icon: ArrowUpward, color: 'info.main' },
  mixed_consistent_lower_magnitude: { icon: Remove, color: DARK_WARNING_TEXT_COLOR },
  softening: { icon: ArrowDownward, color: DARK_WARNING_TEXT_COLOR },
  declining_consistency: { icon: ArrowDownward, color: DARK_WARNING_TEXT_COLOR },
  down: { icon: ArrowDownward, color: 'error.main' },
  flat: { icon: Remove, color: 'text.disabled' },
  insufficient_data: { icon: Remove, color: 'text.disabled' },
};
export const SYNCHRONIZER_TREND_FILTER_OPTIONS = [
  { value: 'strong_up', label: 'Strong Up' },
  { value: 'up', label: 'Up' },
  { value: 'emerging_opportunity', label: 'Emerging Opportunity' },
  { value: 'improving_consistency', label: 'Improving Consistency' },
  { value: 'flat', label: 'Flat' },
  { value: 'mixed_consistent_lower_magnitude', label: 'Mixed: More Consistent, Lower Magnitude' },
  { value: 'softening', label: 'Softening' },
  { value: 'declining_consistency', label: 'Declining Consistency' },
  { value: 'down', label: 'Down' },
  { value: 'insufficient_data', label: 'Insufficient Data' },
];
const TREND_LABEL_BY_DIRECTION = new Map(SYNCHRONIZER_TREND_FILTER_OPTIONS.map(option => [option.value, option.label]));
const getTrendFilterOptionValue = option => option?.value || '';
const getTrendFilterOptionLabel = option => option?.label || String(option?.value || '');

const getComparableCampaignDate = value => {
  if (!value || value === 'N/A') return null;
  const parsedDate = value instanceof Date ? value : new Date(value);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

const displayDateError = ({ value }) => {
  if (!value) return '';
  if (String(value)?.includes('[[ERROR]]')) {
    return <div className={'error-message'}>{value ? String(value).replace('[[ERROR]]', '') : ''}</div>;
  } else return <div>{FormatDateTime(value).format('MM/DD/YYYY')}</div>;
};

const renderStatus = ({ value }) => {
  if ((value && value === 'Fail') || value === 'Bad') {
    return (
      <span>
        <strong style={{ color: 'red' }}>{value}</strong>
      </span>
    );
  } else if ((value && value === 'Success') || value === 'Good') {
    return (
      <span>
        <strong style={{ color: 'green' }}>{value}</strong>
      </span>
    );
  } else {
    return <span>{value}</span>;
  }
};

export const renderBooleanStatus = ({ value }) => {
  if (!value || value === 'false' || value === 'False') {
    return <span>False</span>;
  } else
    return (
      <span>
        <strong style={{ color: 'green' }}>{'True'}</strong>
      </span>
    );
};

export const AUDIO_CONTRACT_DEFAULT_COLUMNS = [
  { field: 'audioPublisher', headerName: 'Audio Publisher', width: 130, type: 'string' },
  {
    field: 'title',
    headerName: 'Title',
    width: 170,
    renderCell: ({ row }) => displayTitleLink(row.primary_isbn, row.title),
    type: 'string',
  },
  { field: 'primaryIsbn', headerName: 'ISBN', width: 130 },
  { field: 'authordisplayname', headerName: 'Author Name', width: 130, type: 'string' },
  { field: 'agent', headerName: 'Agent', width: 100, type: 'string' },
  { field: 'pub_date', headerName: 'Publish Date', width: 100, ...dateColumnConfig },
  { field: 'imprint', headerName: 'Imprint', width: 130, type: 'string' },
  { field: 'bisacs', headerName: 'Bisacs', width: 200, valueGetter: value => value?.join(', '), type: 'string' },
  { field: 'dlp', headerName: 'DLP', width: 60, type: 'number', headerAlign: 'left', align: 'left' },
  { field: 'frontlist', headerName: 'FrontList', width: 80, type: 'string' },
  { field: 'territorydesc', headerName: 'Territory', width: 130, type: 'string' },
  { field: 'language', headerName: 'Language', width: 100, type: 'string' },
  { field: 'ormContractDate', headerName: 'ORM Contract Date', width: 100, ...dateColumnConfig },
  { field: 'ormAudioExpiration', headerName: 'ORM Audio Expiration', width: 100, ...dateColumnConfig },
  { field: 'ormAutoRenew', headerName: 'ORM Auto Renew', width: 70, type: 'string' },
  {
    field: 'ormAutoRenewTerm',
    headerName: 'ORM Auto Renew Term',
    type: 'number',
    headerAlign: 'left',
    align: 'left',
    width: 70,
  },
  { field: 'ormContractStatus', headerName: 'ORM Contract Status', width: 80, type: 'string' },
  { field: 'audioPublisherContractDate', headerName: 'Audio Publisher Contract Date', width: 100, ...dateColumnConfig },
  { field: 'audioPublisherExpiration', headerName: 'Audio Publisher Expiration', width: 100, ...dateColumnConfig },
  { field: 'audioPublisherAutoRenew', headerName: 'Audio Publisher Auto Renew', width: 70, type: 'string' },
  {
    field: 'audioPublisherAutoRenewTerm',
    headerName: 'Audio Publisher Auto Renew Term',
    width: 70,
    type: 'number',
    headerAlign: 'left',
    align: 'left',
  },
  { field: 'audioPublisherContractStatus', headerName: 'Audio Publisher Contract Status', width: 80, type: 'string' },
  { field: 'audioBookPubDate', headerName: 'Audio Book Pub Date', width: 80, ...dateColumnConfig },
  { field: 'advance', headerName: 'Advance', width: 80, type: 'number', headerAlign: 'left', align: 'left' },
  { field: 'physicalRoyalties', headerName: 'Royalties on Physical', width: 70, type: 'string' },
  { field: 'digitalRoyalties', headerName: 'Royalties on Digital', width: 70, type: 'string' },
  { field: 'paySchedule', headerName: 'Pay Schedule', width: 100, type: 'string' },
  { field: 'comment', headerName: 'Comments', width: 100, type: 'string' },
];

export const FAILED_TITLES_COLUMNS = [
  { field: 'title', headerName: 'Title', flex: 1, type: 'string' },
  { field: 'error', headerName: 'Error', flex: 1, type: 'string' },
];

export const serviceRequestErrorColumns = [
  {
    field: 'Service Type',
    headerName: 'Service Type',
    flex: 1,
    type: 'string',
    renderCell: displayError,
  },
  {
    field: 'Title',
    headerName: 'Title',
    flex: 1,
    type: 'string',
    renderCell: displayError,
  },
  {
    field: 'Authors',
    headerName: 'Authors',
    flex: 1,
    type: 'string',
    renderCell: displayError,
  },
  {
    field: 'ISBN',
    headerName: 'ISBN',
    flex: 1,
    renderCell: displayError,
  },
  {
    field: 'ASIN',
    headerName: 'Asin',
    flex: 1,
    type: 'string',
    renderCell: displayError,
  },
  {
    field: 'Audible ASIN',
    headerName: 'Audible ASIN',
    flex: 1,
    type: 'string',
    renderCell: displayError,
  },
  {
    field: 'DLP',
    headerName: 'DLP',
    flex: 1,
    renderCell: displayError,
  },
  {
    field: 'SaleDLP',
    headerName: 'Sale DLP',
    flex: 1,
    renderCell: displayError,
  },
  {
    field: 'Product Type',
    headerName: 'Product Type',
    flex: 1,
    type: 'string',
    renderCell: displayError,
  },
  {
    field: 'BusUnit',
    headerName: 'Business Unit',
    flex: 1,
    type: 'string',
    renderCell: displayError,
  },
  {
    field: 'Countries',
    headerName: 'Countries',
    flex: 1,
    type: 'string',
    renderCell: displayError,
  },
  {
    field: 'Campaign Name',
    headerName: 'Campaign Name',
    flex: 1,
    type: 'string',
    renderCell: displayError,
  },
  {
    field: 'Retailers',
    headerName: 'Retailers',
    flex: 1,
    type: 'string',
    renderCell: displayError,
  },
  {
    field: 'Url',
    headerName: 'Url',
    flex: 1,
    type: 'string',
    renderCell: displayError,
  },
  {
    field: 'Display Ads Type',
    headerName: 'Display Ads Type',
    flex: 1,
    type: 'string',
    renderCell: displayError,
  },
  {
    field: 'Start Date',
    headerName: 'Start Date',
    flex: 1,
    valueGetter: value => (value && isValidDateFormat(value) ? new Date(value) : value),
    renderCell: displayDateError,
  },
  {
    field: 'End Date',
    headerName: 'End Date',
    flex: 1,
    valueGetter: value => (value && isValidDateFormat(value) ? new Date(value) : value),
    renderCell: displayDateError,
  },
];

export const serviceRequestStatusColumns = [
  {
    field: 'serviceType',
    headerName: 'Service Type',
    width: 130,
    type: 'string',
  },
  {
    field: 'title',
    headerName: 'Title',
    width: 130,
    type: 'string',
  },
  { field: 'primaryIsbn', headerName: 'ISBN', width: 120 },
  { field: 'asin', headerName: 'Asin', width: 120, type: 'string' },
  { field: 'audible_asin', headerName: 'Audible ASIN', width: 120, type: 'string' },
  { field: 'authors', headerName: 'Authors', width: 120, type: 'string' },
  {
    field: 'dlp',
    headerName: 'DLP',
    width: 75,
    type: 'number',
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'saleDlp',
    headerName: 'Sale DLP',
    width: 75,
    type: 'number',
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'productType',
    headerName: 'Product Type',
    width: 100,
    type: 'string',
  },
  {
    field: 'startDate',
    headerName: 'Start Date',
    width: 100,
    ...dateColumnConfig,
  },
  {
    field: 'endDate',
    headerName: 'End Date',
    width: 100,
    ...dateColumnConfig,
  },
  {
    field: 'runDate',
    headerName: 'Run Date',
    width: 100,
    ...dateColumnConfig,
  },
  { field: 'businessUnit', headerName: 'Business Unit', width: 75, type: 'string' },
  { field: 'countries', headerName: 'Countries', width: 100, type: 'string' },
  { field: 'campaignName', headerName: 'Campaign Name', width: 75, type: 'string' },
  { field: 'displayAdsType', headerName: 'Display Ads Type', width: 105, type: 'string' },
  { field: 'url', headerName: 'URL', width: 150, type: 'string' },
  {
    field: 'pubDate',
    headerName: 'Pub Date',
    width: 100,
    renderCell: renderStatus,
  },
  {
    field: 'bookcover',
    headerName: 'Fetch BookCover (Amazon)',
    width: 75,
    renderCell: renderStatus,
  },
  {
    field: 'savebook',
    headerName: 'Save Book',
    width: 75,
    renderCell: renderStatus,
  },
  {
    field: 'generateservicereq',
    headerName: 'Generate Service Req',
    width: 75,
    renderCell: renderStatus,
  },
  {
    field: 'emailnotification',
    headerName: 'Notify Marketing Team',
    width: 75,
    renderCell: renderStatus,
  },
  {
    field: 'message',
    headerName: 'Reason',
    width: 115,
    renderCell: renderStatus,
  },
];

export const MASTER_SERVICE_REQUEST_TABLE_COLUMNS = [
  { field: 'transactionName', headerName: 'Transaction Name', type: 'string', flex: 1 },
  {
    field: 'clientInfo',
    headerName: 'Client',
    valueGetter: value => value?.name || '',
    type: 'string',
    flex: 0.7,
  },
  { field: 'cost', headerName: 'Cost', type: 'number', flex: 0.5, align: 'left', headerAlign: 'left' },
  { field: 'source', headerName: 'Source', type: 'string', flex: 0.5 },
  { field: 'paymentStatus', headerName: 'Payment Status', type: 'string', flex: 0.5 },
  {
    field: 'createdbyname',
    headerName: 'Created By',
    width: 100,
    valueGetter: value => {
      if (value) {
        if (value.first_name || value.last_name) {
          return value.first_name + ' ' + value.last_name;
        } else return value.email;
      } else return '';
    },
    type: 'string',
    flex: 1,
  },
  {
    field: 'transactionId',
    headerName: 'Total Services',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    valueGetter: (_, row) => row?.childData?.length,
    flex: 0.5,
  },
];

export const MASTER_SERVICE_REQUEST_CHILD_TABLE_COLUMNS = [
  { field: 'serviceType', headerName: 'Service Type', width: 140, type: 'string' },
  { field: 'title', headerName: 'Title', width: 180, type: 'string' },
  { field: 'primaryIsbn', headerName: 'ISBN', width: 130, type: 'string' },
  { field: 'asin', headerName: 'ASIN', width: 130, type: 'string' },
  { field: 'audible_asin', headerName: 'Audible ASIN', width: 130, type: 'string' },
  { field: 'authors', headerName: 'Authors', width: 130, type: 'string' },
  {
    field: 'campaign',
    headerName: 'Campaign',
    renderCell: ({ row }) => generateCampaignLinkNew(row?.campaign?._id, row?.campaign?.name),
    type: 'string',
  },
  { field: 'runDate', headerName: 'Run Date', ...dateColumnConfig },

  { field: 'dlp', headerName: 'DLP', type: 'number', headerAlign: 'left', align: 'left' },
  { field: 'saleDlp', headerName: 'Sale DLP', type: 'number', headerAlign: 'left', align: 'left' },
  { field: 'businessUnit', headerName: 'Business Unit', type: 'string' },
  {
    field: 'countries',
    headerName: 'Countries',
    width: 150,
    type: 'string',
    valueGetter: value => {
      if (Array.isArray(value)) {
        return value.join(', ');
      }
      return value || '';
    },
  },
  {
    field: 'url',
    headerName: 'Url',
    width: 250,
    type: 'string',
    renderCell: ({ row, value }) => {
      const copyFeedUrl = url => {
        var textField = document.createElement('textarea');
        textField.innerText = url;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        textField.remove();
        ormToast('URL copied!', TOAST_TYPE.INFO);
      };
      let url = value;
      if (url && row.trackingId) {
        if (url.includes('?')) url += `&trackingId=${row.trackingId}`;
        else url += `?trackingId=${row.trackingId}`;
      }
      return (
        <div style={{ color: 'rgb(13, 110, 253)' }} onClick={() => copyFeedUrl(url)} title='Click to copy url'>
          {url}
        </div>
      );
    },
  },
  { field: 'displayAdsType', headerName: 'Display Ads Type', width: 100, type: 'string' },
  { field: 'startDate', headerName: 'Start Date', ...dateColumnConfig },
  { field: 'endDate', headerName: 'End Date', ...dateColumnConfig },
  { field: 'serviceStatus', headerName: 'Service Status', type: 'string' },
];

export const EXTERNAL_SUBMISSION_PARENT_COLUMNS = [
  { field: 'name', headerName: 'Submission Name', flex: 1, type: 'string' },
  {
    field: 'campaigntype',
    headerName: 'Campaign Type',
    flex: 1,
    type: 'string',

    renderCell: ({ row }) => {
      return row.campaigntypename ? row.campaigntypename : '';
    },
    valueGetter: (_, row) => row.campaigntypename,
  },
  {
    field: 'startdate',
    headerName: 'Start Date',
    flex: 0.5,
    ...dateColumnConfig,
  },
  {
    field: 'enddate',
    headerName: 'End Date',
    flex: 0.5,
    ...dateColumnConfig,
  },
  // { field: 'promotedtitles', headerName: 'Titles', flex: 1 },
  {
    field: 'createdbyname',
    headerName: 'Created By',
    flex: 1,
    type: 'string',
    renderCell: ({ row }) => {
      return row.createdbyname !== ''
        ? `${row.createdbyname || ''} ${row.createdbylastname || ''}`
        : row.createdbyemail;
    },
  },
  { field: 'createdat', headerName: 'Created At', width: 200, ...dateColumnConfig },
];

export const EXTERNAL_SUBMISSION_CHILD_COLUMNS = [
  { field: 'title', headerName: 'Title', flex: 1, type: 'string' },
  { field: 'primary_isbn', headerName: 'Primary ISBN', flex: 1, type: 'string' },

  {
    field: 'promo_price',
    headerName: 'Promo Price (USD)',
    flex: 1,
    type: 'number',
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'promo_price_eur',
    headerName: 'Promo Price (EUR)',
    flex: 1,
    type: 'number',
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'country',
    headerName: 'Countries',
    flex: 1,
    valueGetter: (_, row) => row?.country?.map(x => x).join(', '),
  },
  {
    field: 'businessarea',
    headerName: 'Business Area',
    width: 150,
    type: 'String',
  },
  // { field: 'country', headerName: 'Country', flex: 1 },
  { field: 'authors', headerName: 'Authors', flex: 1, type: 'string' },
  { field: 'bookbubcategory', headerName: 'Bookbub Category', flex: 1, type: 'string' },
  { field: 'alternatecategory', headerName: 'Alternate Category', flex: 1, type: 'string' },
  { field: 'publisher', headerName: 'Publisher', flex: 1, type: 'string' },
  // { field: 'notes', headerName: 'Notes', flex: 1 },
];

export const APPROVED_SUBMISSION_CHILD_COLUMNS = [
  { field: 'title', headerName: 'Title', flex: 1, type: 'string' },
  { field: 'primary_isbn', headerName: 'Primary ISBN', width: 150, type: 'string' },
  { field: 'asin', headerName: 'ASIN', width: 150, type: 'string' },
  {
    field: 'startdate',
    headerName: 'Start Date',
    flex: 0.5,
    ...dateColumnConfig,
  },
  {
    field: 'enddate',
    headerName: 'End Date',
    flex: 0.5,
    ...dateColumnConfig,
  },
  {
    field: 'differenceSubmissionApproval',
    headerName: 'Difference',
    width: 250,
    type: 'string',
    renderCell: displayHtmlContent,
  },
  {
    field: 'action',
    headerName: 'Action',
    width: 250,
    type: 'string',
    renderCell: displayHtmlContent,
  },
  {
    field: 'promo_price',
    headerName: 'Promo Price (USD)',
    width: 100,
    type: 'number',
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'promo_price_eur',
    headerName: 'Promo Price (EUR)',
    width: 100,
    type: 'number',
    headerAlign: 'left',
    align: 'left',
  },
  {
    field: 'country',
    headerName: 'Countries',
    flex: 1,
    valueGetter: (_, row) => row?.country?.map(x => x).join(', '),
  },
  {
    field: 'businessarea',
    headerName: 'Business Area',
    width: 150,
    type: 'String',
  },
  { field: 'notes', headerName: 'Notes 1', flex: 1, type: 'string' },
  { field: 'authors', headerName: 'Authors', flex: 1, type: 'string' },
  { field: 'submissionName', headerName: 'Submission Name', flex: 1, type: 'string' },
  { field: 'bookbubcategory', headerName: 'Bookbub Category', flex: 1, type: 'string' },
  { field: 'campaignName', headerName: 'Deal Team Notes', flex: 1, type: 'string' },
];

export const SCHEDULE_CAMPAIGN_CHILD_COLUMNS = [
  { field: 'title', headerName: 'Title', flex: 1, type: 'string' },
  { field: 'customcategorieNames', headerName: 'Custom Category', flex: 1, type: 'string' },
  { field: 'awardName', headerName: 'Awards', flex: 1, type: 'string' },
  { field: 'rank', headerName: 'Amazon Rank', flex: 1 },
];

export const SCHEDULE_CAMPAIGN_COLUMNS = [
  { field: 'ruleType', headerName: 'Rule Type', flex: 1, type: 'string' },
  { field: 'ruleSetValue', headerName: 'Values', flex: 1.5, type: 'string' },
  { field: 'campaignname', headerName: 'Campaign Name', flex: 1, type: 'string' },
  { field: 'postSiteId', headerName: 'Promote To', flex: 1, type: 'string' },
  { field: 'postSlug', headerName: 'Slug', flex: 1, type: 'string' },
  { field: 'promotedTitles', headerName: 'Title Count', flex: 0.5 },
  { field: 'promotedDateAndTime', headerName: 'Published Date and Time', ...dateColumnWithTimeConfig },
  { field: 'processed', headerName: 'Post Updated', width: 100, valueGetter: value => (value ? 'Yes' : 'No') },
  getActionColumns([{ name: 'Delete', callbackFunction: onDeleteClick }]),
];

export const SCHEDULE_CAMPAIGN_COLUMNS_WITHOUT_ACTION = [
  { field: 'ruleType', headerName: 'Rule Type', flex: 1, type: 'string' },
  { field: 'ruleSetValue', headerName: 'Values', flex: 1.5, type: 'string' },
  { field: 'campaignname', headerName: 'Campaign Name', flex: 1, type: 'string' },
  { field: 'postSiteId', headerName: 'Promote To', flex: 1, type: 'string' },
  { field: 'postSlug', headerName: 'Slug', flex: 1, type: 'string' },
  { field: 'promotedTitles', headerName: 'Title Count', flex: 0.5 },
  { field: 'promotedDateAndTime', headerName: 'Published Date and Time', ...dateColumnWithTimeConfig },
  { field: 'processed', headerName: 'Post Updated', width: 100, valueGetter: value => (value ? 'Yes' : 'No') },
];

function onDeleteClick(row) {
  row?.handleDelete(row.id);
}

export const FRONT_LIST_TITLE_WIDGET_COLUMNS = [
  {
    field: 'title',
    headerName: 'Title',
    flex: 1,
    type: 'string',
    renderCell: ({ row }) => displayTitleLink(row.primary_isbn, row.title),
  },
  {
    field: 'authordetails',
    headerName: 'Author',
    flex: 1,
    type: 'string',
    renderCell: displayAuthorLink,
    valueGetter: value => value?.map(value => value.name).join(''),
  },
  { field: 'onsaledate', headerName: 'Sale Date', flex: 1, ...dateColumnConfig },
  { field: 'customcategories', headerName: 'Custom Categories', flex: 1, type: 'string' },
  { field: 'publisher', headerName: 'Publisher', flex: 1, type: 'string' },
  { field: 'frontlist', headerName: 'Frontlist', flex: 1, type: 'string' },
  { field: 'nextCampaignTypeName', headerName: 'Next Campaign Type', flex: 1, type: 'string' },
  { field: 'nextCampaignStartDate', headerName: 'Next Campaign Date', flex: 1, ...dateColumnConfig },
];

//Ignition Batch Widget Parent Table Columns
export const IGNITION_BATCH_WIDGET_COLUMNS = [
  { field: 'publisher', headerName: 'Publisher', flex: 1.5, type: 'string' },
  { field: 'batch', headerName: 'Batch', flex: 1, type: 'string' },
  { field: 'count', headerName: 'Title Count', flex: 0.5 },
  { field: 'onsaledate', headerName: 'Sale Date', flex: 0.5, ...dateColumnConfig },
];

//Ignition Batch Widget Child Table Columns
export const IGNITION_BATCH_WIDGET_CHILD_COLUMNS = [
  {
    field: 'title',
    headerName: 'Title',
    flex: 1,
    type: 'string',
    renderCell: ({ row }) => displayTitleLink(row.primary_isbn, row.title),
  },
  {
    field: 'customCategories',
    headerName: 'Custom Categories',
    type: 'string',
    flex: 1,
    minWidth: 200,
  },
  { field: 'authordisplayname', headerName: 'Authors', width: 150, type: 'string' },
  {
    field: 'latestRating',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    headerName: 'Amazon Rating',
    width: 100,
  },
  {
    field: 'latestReviews',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    headerName: 'Amazon Review',
    width: 120,
  },
  { field: 'awards', headerName: 'Awards', flex: 1, type: 'string' },
  { field: 'bookbubFollowerCount', headerName: 'BB Author Follower Count', flex: 1 },
  { field: 'nextCampaignStartDate', headerName: 'Next Campaign Start Date', flex: 0.5, ...dateColumnConfig },
  { field: 'nextCampaignTypeName', headerName: 'Next Campaign Type', flex: 0.5, type: 'string' },
];

export const TITLE_COUNT_WIDGET_COLUMNS = [
  { field: 'month', headerName: 'Month', flex: 1, type: 'string' },
  { field: 'year', headerName: 'Year', flex: 1 },
  { field: 'campaigncount', headerName: 'Total Campaign', flex: 1 },
  { field: 'titlecount', headerName: 'Title Count', flex: 1 },
];

export const ORION_SCHEDULAR_CAMPAIGN_COLUMNS = [
  { field: 'ruleType', headerName: 'Rule Type', flex: 1, type: 'string' },
  { field: 'ruleSetValue', headerName: 'Values', flex: 1.5, type: 'string' },
  { field: 'campaignname', headerName: 'Campaign Name', flex: 1, type: 'string' },
  { field: 'postSiteId', headerName: 'Promote To', flex: 1, type: 'string' },
  { field: 'postSlug', headerName: 'Slug', flex: 1, type: 'string' },
  { field: 'promotedTitles', headerName: 'Title Count', flex: 0.5 },
  { field: 'promotedDateAndTime', headerName: 'Published Date and Time', editable: true, ...dateColumnWithTimeConfig },
  { field: 'processed', headerName: 'Post Updated', width: 100, valueGetter: value => (value ? 'Yes' : 'No') },
];

// CampOps retailer status -> text colour in the Retailers hover. Light shades, to read on the dark tooltip.
const RETAILER_STATUS_COLOR = {
  Success: 'success.light',
  'Partial Success': 'warning.light',
  Failed: 'error.light',
};

/** The child table's Retailers cell: on hover, every retailer CampOps checked, coloured by status. */
const RetailerStatusCell = ({ value, retailerStatuses }) => {
  if (!retailerStatuses?.length) return value || '';
  return (
    <Tooltip
      arrow
      placement='top'
      title={
        <Stack spacing={0.25}>
          {retailerStatuses.map(({ retailer, status }) => (
            <Typography key={retailer} variant='caption' sx={{ color: RETAILER_STATUS_COLOR[status], fontWeight: 600 }}>
              {retailer}
            </Typography>
          ))}
        </Stack>
      }
    >
      <span>{value}</span>
    </Tooltip>
  );
};

export const CAMPAIGN_HOME_CHILD_COLUMNS = [
  {
    field: 'image',
    headerName: 'Book Image',
    renderCell: ({ row }) => {
      let bookCoverUrl = BuildServerlessBookCoverImageUrl(IMAGESIZES.BC_THUMBNAIL, row.image);
      return (
        <a href={`/book/${row.primary_isbn}`} rel='noreferrer' target='_blank'>
          <img style={{ width: '50px' }} alt='' src={bookCoverUrl} />
        </a>
      );
    },
    width: 50,
  },
  { field: 'title', headerName: 'Title', width: 150, type: 'string' },
  {
    field: 'productType',
    headerName: 'Product Type',
    width: 120,
    type: 'string',
    // Titles saved before productType existed have no value, so guard the
    // capitalize call rather than letting it throw on undefined.
    valueGetter: value => (value ? capitalize(value) : ''),
  },
  { field: 'authors', headerName: 'Authors', width: 150, type: 'string' },
  { field: 'primary_isbn', headerName: 'Primary ISBN', width: 130, type: 'string' },
  { field: 'amazon_isbn13', headerName: 'Amazon ISBN', width: 130, type: 'string' },
  { field: 'asin', headerName: 'ASIN', width: 130, type: 'string' },
  { field: 'publisher', headerName: 'Publisher', width: 150, type: 'string' },
  { field: 'batch', headerName: 'Batch', width: 150, type: 'string' },
  { field: 'dlp', headerName: 'DLP', type: 'number', headerAlign: 'left', align: 'left', width: 100 },
  { field: 'promoprice', headerName: 'Promo Price', type: 'number', headerAlign: 'left', align: 'left', width: 100 },
  { field: 'categories', headerName: 'Categories', width: 200, type: 'string' },
  { field: 'bisac', headerName: 'Bisacs', width: 200, type: 'string' },
  {
    field: 'retailers',
    headerName: 'Retailers',
    width: 100,
    type: 'string',
    renderCell: ({ row, value }) => <RetailerStatusCell value={value} retailerStatuses={row.retailerStatuses} />,
  },
  { field: 'countries', headerName: 'Countries', width: 100, type: 'string' },
  {
    field: 'titleLevelMonthlyBaseline',
    headerName: 'Monthly Title Level Baseline',
    width: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'titleLevelMonthlyProratedUplift',
    headerName: 'Prorated Monthly Title-Level Uplift',
    width: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'businessarea',
    headerName: 'Business Area',
    width: 150,
    type: 'String',
  },
  {
    field: 'amazonTopReviewPotentialLabel',
    headerName: 'Potential Label',
    width: 240,
    type: 'string',
  },
  {
    field: 'promoRecoOrganic',
    headerName: 'Synchronizer Promotional Label - HIST18',
    width: 280,
    type: 'string',
  },
  {
    field: 'promoRecoOrganicMTD',
    headerName: 'Synchronizer Promotional Label - MTD',
    width: 280,
    type: 'string',
  },
  { field: 'notes1', headerName: 'Notes 1', width: 100 },
  { field: 'notes2', headerName: 'Notes 2', width: 100 },
  { field: 'attribute', headerName: 'Attribute', width: 100 },
  {
    field: 'triggerName',
    headerName: 'Trigger Title',
    width: 100,
  },
  { field: 'adUnit', headerName: 'Ad Unit', flex: 100, renderCell: renderBooleanStatus },
  { field: 'isFreeBook', headerName: 'Free', width: 100, renderCell: renderBooleanStatus },
  { field: 'isTop100', headerName: 'Top 100', width: 100, renderCell: renderBooleanStatus },
  {
    field: 'isActivation',
    headerName: 'Activation',
    width: 100,
    renderCell: renderBooleanStatus,
  },
  {
    field: 'isBusinessPriority',
    headerName: 'Business Priority',
    width: 100,
    renderCell: renderBooleanStatus,
  },
];

export const CAMPAIGN_CREATE_TITLE_COLUMNS = [
  { field: 'sequence', headerName: 'Seq', width: 20, minWidth: 50, type: 'number' },
  {
    field: 'title',
    headerName: 'Book Title',
    resizable: true,
    width: 200,
    minWidth: 200,
    valueGetter: value => (value ? unescape(value) : ''),
    flex: 1,
    type: 'string',
  },
  {
    field: 'productType',
    headerName: 'Product Type',
    flex: 0.5,
    minWidth: 120,
    type: 'string',
    // Titles saved before productType existed have no value, so guard the
    // capitalize call rather than letting it throw on undefined.
    valueGetter: value => (value ? capitalize(value) : ''),
  },
  { field: 'dlp', headerName: 'Price', flex: 0.5, minWidth: 100, type: 'number', align: 'left', headerAlign: 'left' },
  {
    field: 'promoprice',
    headerName: 'Promo Price',
    flex: 0.5,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'retailers',
    headerName: 'Retailers',
    resizable: true,
    valueGetter: value => value?.join(', '),
    flex: 1,
    minWidth: 160,
    type: 'string',
  },
  {
    field: 'countries',
    headerName: 'Countries',
    valueGetter: value => value?.join(', '),
    flex: 1,
    minWidth: 140,
    type: 'string',
  },
  {
    field: 'titleLevelMonthlyBaseline',
    headerName: 'Monthly Title Level Baseline',
    width: 100,
    minWidth: 180,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'titleLevelMonthlyProratedUplift',
    headerName: 'Prorated Monthly Title-Level Uplift',
    width: 100,
    minWidth: 220,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'businessarea',
    headerName: 'Business Area',
    width: 150,
    minWidth: 150,
    type: 'string',
    hide: true,
  },
  {
    field: 'amazonTopReviewPotentialLabel',
    headerName: 'Potential Label',
    width: 240,
    minWidth: 200,
    type: 'string',
    valueGetter: (_, row) => {
      const val = row.amazonTopReviewPotentialLabel ?? row.book?.amazonTopReviewPotentialLabel;
      return typeof val === 'string' ? val : '';
    },
  },
  {
    field: 'promoRecoOrganic',
    headerName: 'Synchronizer Promotional Label - HIST18',
    width: 280,
    minWidth: 200,
    type: 'string',
    valueGetter: (_, row) => {
      const val = row.promoRecoOrganic ?? row.book?.promoRecoOrganic;
      return typeof val === 'string' ? val : '';
    },
  },
  {
    field: 'promoRecoOrganicMTD',
    headerName: 'Synchronizer Promotional Label - MTD',
    width: 280,
    minWidth: 200,
    type: 'string',
    valueGetter: (_, row) => {
      const val = row.promoRecoOrganicMTD ?? row.book?.promoRecoOrganicMTD;
      return typeof val === 'string' ? val : '';
    },
  },
  { field: 'notes1', headerName: 'Note1', flex: 0.5, minWidth: 120, type: 'string' },
  { field: 'notes2', headerName: 'Note2', flex: 0.5, minWidth: 120, type: 'string' },
  { field: 'attribute', headerName: 'Attribute', flex: 0.5, minWidth: 120, type: 'string' },
  { field: 'triggerName', headerName: 'Trigger Title', flex: 1, minWidth: 140, type: 'string' },
  { field: 'adUnit', headerName: 'Ad Unit', flex: 0.5, minWidth: 90, renderCell: renderBooleanStatus, type: 'string' },
  { field: 'isFreeBook', headerName: 'Free', flex: 0.5, minWidth: 80, renderCell: renderBooleanStatus, type: 'string' },
  {
    field: 'isActivation',
    headerName: 'Activation',
    flex: 0.5,
    minWidth: 100,
    renderCell: renderBooleanStatus,
    type: 'string',
  },
  {
    field: 'isBusinessPriority',
    headerName: 'Business Priority',
    flex: 0.5,
    minWidth: 130,
    renderCell: renderBooleanStatus,
    type: 'string',
  },
];

export const CAMPAIGN_TITLE_HISTORY_COLUMNS = [
  { field: 'action', headerName: 'Action', width: 100, minWidth: 100, type: 'string' },
  { field: 'sequence', headerName: 'Seq', width: 50, minWidth: 50, type: 'number' },
  { field: 'title', headerName: 'Book Title', resizable: true, flex: 1, minWidth: 150, type: 'string' },
  { field: 'dlp', headerName: 'Price', width: 80, minWidth: 80, type: 'number' },
  { field: 'promoprice', headerName: 'Promo Price', width: 80, minWidth: 100, type: 'number' },
  {
    field: 'retailers',
    headerName: 'Retailers',
    type: 'string',
    valueGetter: value => value?.join(', '),
    width: 100,
    minWidth: 120,
  },
  {
    field: 'countries',
    headerName: 'Countries',
    type: 'string',
    valueGetter: value => value?.join(', '),
    width: 100,
    minWidth: 120,
  },
  { field: 'notes1', headerName: 'Note1', width: 100, minWidth: 110, type: 'string' },
  { field: 'notes2', headerName: 'Note2', width: 100, minWidth: 110, type: 'string' },
  { field: 'reason', headerName: 'Reason', flex: 1, minWidth: 150, type: 'string' },
];

export const BLAST_CONFIGURATION_COLUMN = [
  {
    headerName: 'Blast Name',
    field: 'name',
    type: 'string',
    flex: 1,
  },
];

export const AMAZON_ELIGIBILITY_CONFIGURATION_COLUMN = [
  {
    headerName: 'Configuration Name',
    field: 'name',
    type: 'string',
    flex: 1,
  },
  {
    headerName: 'Type',
    field: 'configurationType',
    type: 'string',
    flex: 1,
    valueFormatter: value => {
      if (value === 'theme') return 'Amazon Theme';
      if (value === 'eligibility') return 'Amazon Eligibility';
      if (value === 'top_review_label') return 'Amazon Top Review';
      return value || '-';
    },
  },
];

export const haloRecommendationColumns = campTypes => [
  { field: 'authors', headerName: 'Authors', width: 150, type: 'string' },
  {
    field: 'series_name',
    headerName: 'Series Name',
    width: 150,
    type: 'string',
    renderCell: displayHtmlContent,
  },
  { field: 'volume', type: 'number', align: 'left', headerAlign: 'left', headerName: 'Series Volume', width: 100 },
  {
    field: 'title',
    headerName: 'Title',
    width: 200,
    type: 'string',
    renderCell: ({ row }) => displayTitleLink(row.primaryisbn, row.title),
  },
  { field: 'primaryisbn', headerName: 'Primary ISBN', width: 120, type: 'string' },
  { field: 'asin', headerName: 'ASIN', width: 120, type: 'string' },
  { field: 'dlp', type: 'number', align: 'left', headerAlign: 'left', headerName: 'US DLP', width: 100 },
  {
    field: 'promoPriceHalo',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    headerName: 'Promo Price',
    width: 100,
  },
  { field: 'bundle', headerName: 'Bundle', width: 100, type: 'string' },
  {
    field: 'latestRating',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    headerName: 'Amazon Rating',
    width: 100,
  },
  {
    field: 'latestReviews',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    headerName: 'Amazon Review',
    width: 100,
  },
  { field: 'rank', type: 'number', align: 'left', headerAlign: 'left', headerName: 'Amazon Rank', width: 100 },
  {
    field: 'last30consumerPrice',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    headerName: 'Average Consumer Price over the previous 30 days',
    width: 100,
  },
  {
    field: 'unitSalesOf30Days',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    headerName: 'Units sold previous 30 days (All retailers)',
    width: 100,
  },
  {
    field: 'lastSameCampaignName',
    headerName: 'Same Campaign Type last Campaign name',
    width: 100,
    type: 'string',
  },
  {
    field: 'lastCampaignEndDate',
    headerName: 'Same Campaign Type last Campaign end date',
    ...dateColumnConfig,
  },
  {
    field: 'duringProceeds',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    headerName: 'Same Campaign: Proceeds for last run date',
  },
  {
    field: 'standardDeviation',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    headerName: 'Standard Deviation',
    width: 100,
  },
  {
    field: 'last3MonthDuringProceeds',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    headerName: 'Same Campaign: Proceeds for last 3 available months[6month window]',
    width: 150,
  },
  {
    field: 'salesLiftDayOf',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    headerName: 'Same Campaign: Sales lift for last run date ',
    width: 100,
  },
  {
    field: 'CTRLastCampaignSameCamp',
    type: 'number',
    headerName: 'CTR - last campaign [Same Campaign Type]',
    width: 150,
  },
  {
    field: 'CPCLastCampaignSameCamp',
    type: 'number',
    headerName: 'CPC - last campaign [Same Campaign Type]',
    width: 150,
  },
  {
    field: 'UnitsLastCampaignSameCamp',
    type: 'number',
    headerName: 'Units during last campaign [Same Campaign Type]',
    width: 150,
  },
  {
    field: 'PostCampaignSalesLiftSameCamp',
    type: 'number',
    headerName: 'Post-campaign sales lift',
    width: 150,
  },
  {
    field: 'parentcamptype',
    headerName: 'Parent Promotion Type',
    width: 150,
    type: 'string',
    valueGetter: value => {
      if (value) {
        let cmp = campTypes.filter(ctype => ctype.value === value);
        return cmp[0]?.label;
      } else {
        return value;
      }
    },
  },
  {
    field: 'parentcampdate',
    headerName: 'Parent Promotion Date',
    ...dateColumnConfig,
  },
  {
    field: 'parentcampcountries',
    headerName: 'Country',
    width: 100,
    type: 'string',
    renderCell: ({ value }) => {
      if (value && value.length > 0) {
        return <Markup content={value.toString()} />;
      }
    },
  },
  {
    field: 'nextDate',
    headerName: 'Children Promotion Date',
    ...dateColumnConfig,
  },
  {
    field: 'flagged',
    headerName: 'Flag',
    width: 100,
    type: 'string',
    renderCell: ({ value }) => {
      if (value && value.length > 0) {
        return <Markup content={value.toString()} />;
      }
    },
  },
];

export const TITLE_FORMAT_COLUMNS = [
  { field: 'name', headerName: 'Name', flex: 1, type: 'string' },
  { field: 'campaigntypename', headerName: 'Campaign Type', flex: 1, type: 'string' },
  { field: 'startdate', headerName: 'Start Date', flex: 1, ...dateColumnConfig },
  { field: 'enddate', headerName: 'End Date', flex: 1, ...dateColumnConfig },
  { field: 'title', headerName: 'Title', flex: 1, type: 'string' },
  { field: 'authors', headerName: 'Authors', flex: 1, type: 'string' },
  { field: 'dlp', headerName: 'DLP', flex: 1, type: 'number', headerAlign: 'left', align: 'left' },
  { field: 'promoprice', headerName: 'Promo Price', flex: 1, type: 'number', headerAlign: 'left', align: 'left' },
  { field: 'countries', headerName: 'Countries', flex: 1, type: 'string' },
  { field: 'publisher', headerName: 'Publisher', flex: 1, type: 'string' },
  { field: 'batch', headerName: 'Batch', flex: 1, type: 'string' },
  { field: 'categories', headerName: 'Categories', flex: 1, type: 'string' },
  { field: 'retailers', headerName: 'Retailers', flex: 1, type: 'string' },
  { field: 'primary_isbn', headerName: 'ISBN', flex: 1, type: 'string' },
  { field: 'amazon_isbn13', headerName: 'Amazon ISBN', flex: 1, type: 'string' },
  { field: 'asin', headerName: 'ASIN', flex: 1, type: 'string' },
  { field: 'notes1', headerName: 'Notes 1', flex: 1, type: 'string' },
  { field: 'notes2', headerName: 'Notes 2', flex: 1, type: 'string' },
  { field: 'attribute', headerName: 'Attribute', flex: 1, type: 'string' },
  {
    field: 'tpid',
    headerName: 'Trigger Title',
    width: 100,
    renderCell: renderBooleanStatus,
  },
  { field: 'isFreeBook', headerName: 'Free', flex: 1, renderCell: renderBooleanStatus },
  {
    field: 'isActivation',
    headerName: 'Activation',
    flex: 1,
    renderCell: renderBooleanStatus,
  },
  {
    field: 'isBusinessPriority',
    headerName: 'Business Priority',
    flex: 1,
    renderCell: renderBooleanStatus,
  },
];

export const DELETE_SELECTED_CAMPAIGN_COLUMNS = [
  { field: 'name', headerName: 'Name', flex: 1, type: 'string' },
  { field: 'campaigntypename', headerName: 'Campaign Type', flex: 1, type: 'string' },
  { field: 'campaignsubtypename', headerName: 'Campaign Sub Type', flex: 1, type: 'string' },
  { field: 'startdate', headerName: 'Start Date', ...dateColumnConfig },
  { field: 'enddate', headerName: 'End Date', ...dateColumnConfig },
  { field: 'createdbyname', headerName: 'Created By', flex: 1, type: 'string' },
];

export const SEARCH_EXISTING_CAMPAIGN_COLUMNS = [
  { field: 'name', headerName: 'Name', flex: 1, type: 'string' },
  { field: 'campaigntypename', headerName: 'Campaign Type', flex: 1, type: 'string' },
  { field: 'campaignsubtypename', headerName: 'Campaign Sub Type', flex: 1, type: 'string' },
  {
    field: 'titlecount',
    headerName: 'Title Count',
    align: 'center',
    headerAlign: 'center',
    width: 100,
  },
  { field: 'startdate', headerName: 'Start Date', ...dateColumnConfig },
  {
    field: 'enddate',
    headerName: 'End Date',
    width: 150,
    renderCell: ({ value }) => {
      if (value === null || value === '') return <span></span>;

      let today = new Date();
      let enddate = new Date(value);
      today.setHours(0, 0, 0, 0);
      enddate.setHours(0, 0, 0, 0);
      enddate.setDate(enddate.getDate() + 1);

      let color;
      enddate >= today ? (color = 'green') : (color = 'red');

      let date = FormatDateString(value, 'MM/DD/YYYY');
      return <span style={{ color: color, fontWeight: 'bold' }}>{date}</span>;
    },
    ...dateColumnConfig,
  },
  { field: 'createdbyname', headerName: 'Created By', flex: 1, type: 'string' },
];

export const CAMPAIGN_WARNING_COLUMNS = [
  { field: 'name', headerName: 'Campaign', flex: 1, type: 'string' },
  { field: 'title', headerName: 'Book', flex: 1, type: 'string' },
  { field: 'isbn', headerName: 'ISBN', flex: 0.6, type: 'string' },
  {
    field: 'startdate',
    headerName: 'Start Date',
    ...dateColumnConfig,
  },
  {
    field: 'enddate',
    headerName: 'End Date',
    ...dateColumnConfig,
  },
  { field: 'message', headerName: 'Warning', flex: 1.5, type: 'string' },
];

export const CAMPAIGN_ERROR_COLUMNS = [
  { field: 'name', headerName: 'Campaign', flex: 1, type: 'string' },
  { field: 'title', headerName: 'Book', flex: 1, type: 'string' },
  { field: 'isbn', headerName: 'ISBN', flex: 0.6, type: 'string' },
  {
    field: 'startdate',
    headerName: 'Start Date',
    ...dateColumnConfig,
  },
  {
    field: 'enddate',
    headerName: 'End Date',
    ...dateColumnConfig,
  },
  { field: 'message', headerName: 'Error', flex: 1.5, type: 'string' },
];

export const GOOGLE_ALERT_COLUMNS = [
  { headerName: 'Date', field: 'date', ...dateColumnConfig },
  {
    headerName: 'Title',
    field: 'article_title',
    type: 'string',
    flex: 1,
    renderCell: ({ value, row }) => (
      <a href={row.article_url} rel='noreferrer' target='_blank'>
        {value}
      </a>
    ),
  },
  { headerName: 'Domain', field: 'article_domain', type: 'string', flex: 0.5 },
];

export const getExternalSubmissionMoveTitleColumns = campaignTypes => {
  return [
    {
      headerName: 'Submission Name',
      field: 'name',
      flex: 1,
      type: 'string',
      renderCell: ({ value }) => {
        return <div dangerouslySetInnerHTML={{ __html: value }} />;
      },
    },
    {
      headerName: 'Campaign Type',
      field: 'campaigntype',
      flex: 1,
      type: 'string',
      renderCell: ({ row }) => {
        let campaignType = campaignTypes.find(ct => ct.value === row.campaigntype);
        return campaignType.label ? campaignType.label : '';
      },
    },
    {
      headerName: 'Start Date',
      field: 'startdate',
      ...dateColumnConfig,
    },
    {
      headerName: 'End Date',
      field: 'enddate',
      ...dateColumnConfig,
    },
    { headerName: 'Created By', field: 'createdbyname', flex: 1, type: 'string' },
  ];
};

export const DELETE_CAMPAIGN_WARNING_COLUMNS = [
  { field: 'title', headerName: 'Title', flex: 1, type: 'string' },
  { field: 'primaryIsbn', headerName: 'ISBN', flex: 1, type: 'string' },
  { field: 'authors', headerName: 'Authors', flex: 1, type: 'string' },
  { field: 'clientInfo', headerName: 'Client', valueGetter: value => value.name, flex: 1, type: 'string' },
  { field: 'businessUnit', headerName: 'Business Unit', flex: 1, type: 'string' },
  {
    field: 'campaign',
    headerName: 'Campaign',
    type: 'string',
    renderCell: ({ row }) => {
      if (!row.campaignId || !row.campaign) return;
      return <div>{generateCampaignLinkNew(row?.campaign?._id, row?.campaign?.name)}</div>;
    },
    flex: 1,
  },
  {
    field: 'runDate',
    headerName: 'Run Date',
    flex: 1,
    ...dateColumnConfig,
  },
];

export const FIREBRAND_COLUMNS = [
  { field: 'primaryISBN', headerName: 'ISBN', width: 150, type: 'string' },
  {
    field: 'title',
    headerName: 'Title',
    flex: 1,
    minWidth: 200,
    type: 'string',
  },
  {
    field: 'format',
    headerName: 'Format',
    minWidth: 150,
    type: 'string',
  },
  {
    field: 'productType',
    headerName: 'Product Type',
    minWidth: 150,
    type: 'string',
  },
  {
    field: 'message',
    headerName: 'Message',
    flex: 1.5,
    minWidth: 200,
    type: 'string',
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 150,
    maxWidth: 150,
    type: 'string',
    renderCell: ({ value }) => {
      const displayValue = Array.isArray(value) ? value.join(', ') : value;
      return (
        <Typography color={textColorStatus(value)} variant='subtitle2'>
          {displayValue}
        </Typography>
      );
    },
  },
  {
    field: 'hasRetailerRestrictionChange',
    headerName: 'Retailer Restriction Change',
    width: 200,
    minWidth: 200,
    type: 'string',
    valueGetter: value => (value ? 'Yes' : 'No'),
  },
  {
    field: 'hasMetadataChange',
    headerName: 'Metadata Change',
    width: 160,
    minWidth: 160,
    type: 'string',
    valueGetter: value => (value ? 'Yes' : 'No'),
  },
  {
    field: 'sentBy',
    headerName: 'Sent By',
    width: 150,
    minWidth: 150,
  },
  {
    field: 'date_processed',
    headerName: 'Date',
    ...dateColumnWithTimeConfig,
  },
];

export const CREATE_CAMPAIGN_WARNING_COLUMNS = [
  { field: 'name', headerName: 'Name', flex: 1, type: 'string' },
  { field: 'campaigntype', headerName: 'Campaign Type', flex: 1, type: 'string' },
  { field: 'startdate', headerName: 'Start Date', ...dateColumnConfig },
  { field: 'enddate', headerName: 'End Date', ...dateColumnConfig },
  { field: 'title', headerName: 'Title', width: 150, type: 'string' },
  { field: 'isbn', headerName: 'ISBN', width: 130, type: 'string' },
  { field: 'message', headerName: 'Warning', flex: 2, type: 'string' },
];

export const CREATE_CAMPAIGN_ERROR_COLUMNS = [
  { field: 'name', headerName: 'Name', flex: 1, type: 'string' },
  { field: 'campaigntype', headerName: 'Campaign Type', flex: 1, type: 'string' },
  { field: 'conflictingCampaignTypeName', headerName: 'Conflicting Campaign Type', flex: 1, type: 'string' },
  { field: 'startdate', headerName: 'Start Date', ...dateColumnConfig, flex: 1 },
  { field: 'enddate', headerName: 'End Date', ...dateColumnConfig, flex: 1 },
  { field: 'title', headerName: 'Title', flex: 1, type: 'string' },
  { field: 'isbn', headerName: 'ISBN', flex: 1, type: 'string' },
  {
    field: 'asin',
    headerName: 'ASIN',
    flex: 1,
    type: 'string',
    valueGetter: (_, row) => (row?.asin && row.asin !== 'undefined' ? row.asin : ''),
  },
  { field: 'promoprice', headerName: 'Promo Price', flex: 1 },
  { field: 'message', headerName: 'Error', flex: 2, type: 'string' },
];

export const NOTIFY_CONFLICTING_CAMPAIGN_ERROR_TABLE_COLUMNS = [
  { field: 'name', headerName: 'Name', flex: 1, type: 'string' },
  { field: 'campaigntype', headerName: 'Campaign Type', flex: 1, type: 'string' },
  { field: 'startdate', headerName: 'Start Date', ...dateColumnConfig },
  { field: 'enddate', headerName: 'End Date', ...dateColumnConfig },
  { field: 'title', headerName: 'Title', width: 150, type: 'string' },
  { field: 'isbn', headerName: 'ISBN', width: 130, type: 'string' },
  { field: 'message', headerName: 'Error', flex: 1, type: 'string' },
  { field: 'sendTo', headerName: 'Sent to (Editable)', flex: 1, editable: true, type: 'string' },
  { field: 'note', headerName: 'Note (Editable)', flex: 1, editable: true, type: 'string' },
];

export const CLIENT_PROFILE_LANDING_COLUMNS = [
  { field: 'name', headerName: 'Client Name', flex: 1, type: 'string' },
  { field: 'publisher', headerName: 'Publisher', flex: 1, type: 'string' },
  { field: 'parentCompanyName', headerName: 'Parent Company', flex: 1, type: 'string' },
  { field: 'address', headerName: 'Address', flex: 1, type: 'string' },
  {
    field: 'countries',
    headerName: 'Countries',
    type: 'string',
    valueGetter: value => value?.join(', '),
    flex: 1,
  },
  { field: 'pricingModel', headerName: 'Pricing Model', flex: 1, type: 'string' },
  {
    field: 'createdbyname',
    headerName: 'Created By',
    flex: 1,
    type: 'string',
    valueGetter: displayUserName,
  },
];

export const PRIORITY_TITLE_COLUMNS = [
  {
    field: 'title',
    headerName: 'Title',
    width: 200,
    type: 'string',
    renderCell: ({ row }) => displayTitleLink(row.primaryIsbn, row.title),
  },
  {
    field: 'authordisplayname',
    headerName: 'Authors',
    type: 'string',
    width: 150,
  },
  {
    field: 'publisher',
    headerName: 'Publisher',
    type: 'string',
    width: 150,
  },
  {
    field: 'primaryIsbn',
    headerName: 'ISBN',
    hideable: false,
    type: 'string',
  },
  {
    field: 'asin',
    headerName: 'ASIN',
    hideable: false,
    type: 'string',
  },
  {
    field: 'batch',
    headerName: 'Batch #',
    hideable: false,
    type: 'string',
  },
  {
    field: 'bundle',
    headerName: 'Bundle',
    type: 'string',
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'frontlist',
    headerName: 'Front list',
    hideable: false,
    type: 'string',
  },
  {
    field: 'publicdomain',
    headerName: 'Public Domain',
    hideable: false,
    type: 'string',
  },
  {
    field: 'dlp',
    headerName: 'DLP',
    hideable: false,
    valueGetter: (_, row) => row.US.dlp,
  },
  {
    field: 'bisacs',
    headerName: 'Bisacs',
    hideable: false,
    type: 'string',
  },
  {
    field: 'customCategoriesList',
    headerName: 'Custom Categories',
    type: 'string',
    flex: 1,
    minWidth: 200,
  },
  {
    field: 'onsaledate',
    headerName: 'On Sale Date',
    ...dateColumnConfig,
  },
  {
    field: 'lastCampaign',
    headerName: 'Last campaign',
    width: 200,
    type: 'string',
    valueGetter: (_, row) => row?.lastCampaignTypeName + ' ' + row?.lastCampaignStartDate,
  },
  {
    field: 'upcomingCampaigns',
    headerName: 'Upcoming campaigns',
    width: 200,
    type: 'string',
  },
  {
    field: 'lastSixMonthTotalSaleExcludingBB',
    headerName: 'Last 6-months sales',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    width: 150,
    valueGetter: (_, row) => row.calculatedHistoricalData.lastSixMonthTotalSaleExcludingBB,
  },
  {
    field: 'priorToLastSixMonthTotalSaleExcludingBB',
    headerName: 'Prior to last 6-months sales',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    width: 150,
    valueGetter: (_, row) => row.calculatedHistoricalData.priorToLastSixMonthTotalSaleExcludingBB,
  },

  {
    field: 'differenceInNumberExcludingBB',
    headerName: 'Difference in number',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    width: 150,
    valueGetter: (_, row) => row.calculatedHistoricalData.differenceInNumberExcludingBB,
  },
  {
    field: 'differenceInPercentageExcludingBB',
    headerName: 'Difference in percentage',
    type: 'number',
    width: 150,
    valueFormatter: value => `${value} %`,
    align: 'left',
    headerAlign: 'left',
    valueGetter: (_, row) => row.calculatedHistoricalData.differenceInPercentageExcludingBB,
  },
  {
    field: 'maxSalesInLastTwelveMonthExcludingBB',
    headerName: 'Maximum sales in last 12 months',
    valueGetter: (_, row) => row.calculatedHistoricalData.maxSalesInLastTwelveMonthExcludingBB,
    hideable: false,
    type: 'string',
  },
  {
    field: 'minSalesInLastTwelveMonthExcludingBB',
    headerName: 'Minimum sales in last 12 months',
    valueGetter: (_, row) => row.calculatedHistoricalData.minSalesInLastTwelveMonthExcludingBB,
    hideable: false,
    type: 'string',
  },
  {
    field: 'reportDate',
    headerName: 'Last Run Date',
    ...dateColumnConfig,
  },
];

export const PRIORITY_AUTHOR_COLUMNS = itemtype => {
  let commonCol = [
    {
      field: 'lastSixMonthTotalSale',
      headerName: 'Last 6-months sales',
      type: 'number',
      align: 'left',
      headerAlign: 'left',
      width: 180,
      valueGetter: (_, row) => row.calculatedHistoricalData.lastSixMonthTotalSale,
    },
    {
      field: 'priorToLastSixMonthTotalSale',
      headerName: 'Prior to last 6-months sales',
      type: 'number',
      align: 'left',
      headerAlign: 'left',
      width: 180,
      valueGetter: (_, row) => row.calculatedHistoricalData.priorToLastSixMonthTotalSale,
    },
    {
      field: 'differenceInNumber',
      headerName: 'Difference in number',
      type: 'number',
      align: 'left',
      headerAlign: 'left',
      width: 180,
      valueGetter: (_, row) => row.calculatedHistoricalData.differenceInNumber,
    },
    {
      field: 'differenceInPercentage',
      headerName: 'Difference in percentage',
      type: 'number',
      width: 180,
      valueFormatter: value => (value ? `${value} %` : ''),
      align: 'left',
      headerAlign: 'left',
      valueGetter: (_, row) => row.calculatedHistoricalData.differenceInPercentage,
    },
    {
      field: 'averageMonthlySalesLast12Months',
      headerName: 'Average monthly sales for last 12-months',
      type: 'number',
      width: 180,
      align: 'left',
      headerAlign: 'left',
      valueGetter: (_, row) => row.calculatedHistoricalData.averageMonthlySalesLast12Months,
    },
    {
      field: 'title',
      headerName: 'Title count',
      type: 'number',
      align: 'left',
      headerAlign: 'left',
      width: 100,
      valueGetter: (_, row) => row.calculatedHistoricalData?.incBooks?.length,
    },
    {
      field: 'calculatedHistoricalData.incBooks',
      headerName: 'incBooks',
      flex: 1,
      valueGetter: (_, row) => row.calculatedHistoricalData?.incBooks,
    },
    {
      field: 'reportDate',
      headerName: 'Last Run Date',
      ...dateColumnConfig,
    },
  ];

  if (itemtype === 'authors') {
    return [
      {
        field: 'authorDisplayName',
        headerName: 'Author',
        type: 'string',
        flex: 1,
        minWidth: 150,
      },
      {
        field: 'customCategoriesList',
        headerName: 'Custom Categories',
        type: 'string',
        flex: 1.5,
        minWidth: 250,
      },
      {
        field: 'publisherName',
        headerName: 'Publishers',
        type: 'string',
        flex: 1,
        minWidth: 150,
      },
      ...commonCol,
    ];
  } else if (itemtype === 'publishers' || itemtype === 'batch') {
    const columns = [
      {
        field: 'publisherName',
        headerName: 'Name',
        type: 'string',
        flex: 1,
        minWidth: 150,
      },
      {
        field: 'batchNames',
        headerName: 'Batch',
        type: 'string',
        flex: 1.5,
        minWidth: 250,
      },
      ...commonCol,
    ];
    //As we need batch as link only for publishers
    if (itemtype === 'publishers') {
      columns[1].renderCell = ({ row }) => {
        const batchNamesArray = row && row.batchNames && row.batchNames.split(',');
        return (
          <div>
            {batchNamesArray &&
              batchNamesArray.map((batchName, index) => (
                <React.Fragment key={index}>
                  {index > 0 && ', '}
                  <Link
                    key={index}
                    to={{
                      pathname: `/reports/priority-report/batchdetail`,
                      search: `?pub=${encodeURIComponent(row.publisherName)}&itemType=batch&batch=${encodeURIComponent(
                        batchName
                      )}`,
                    }}
                    target={'_blank'}
                  >
                    {batchName}
                  </Link>
                </React.Fragment>
              ))}
          </div>
        );
      };
    }

    return columns;
  }
};

export const TITLE_FOR_AUTHOR_PUBLISHER_COLUMNS = [
  {
    field: 'title',
    headerName: 'Title',
    type: 'string',
    width: 200,
    renderCell: ({ row }) => displayTitleLink(row.primaryIsbn, row.title),
  },
  {
    field: 'authordisplayname',
    headerName: 'Authors',
    type: 'string',
  },
  {
    field: 'publisher',
    headerName: 'Publisher',
    type: 'string',
  },
  {
    field: 'primaryIsbn',
    headerName: 'ISBN',
    width: 140,
    type: 'string',
  },
  {
    field: 'asin',
    headerName: 'ASIN',
    hideable: false,
    type: 'string',
  },
  {
    field: 'batch',
    headerName: 'Batch #',
    hideable: false,
    type: 'string',
  },
  {
    field: 'bundle',
    headerName: 'Bundle',
    type: 'string',
    width: 100,
  },
  {
    field: 'frontlist',
    headerName: 'Front list',
    hideable: false,
    type: 'string',
  },
  {
    field: 'publicdomain',
    headerName: 'Public Domain',
    hideable: false,
    type: 'string',
  },
  {
    field: 'dlp',
    headerName: 'DLP',
    hideable: false,
    valueGetter: (_, row) => row.US.dlp,
  },
  {
    field: 'customCategoriesList',
    headerName: 'Custom Categories',
    type: 'string',
    flex: 1.5,
  },
  {
    field: 'bisacs',
    headerName: 'Bisacs',
    type: 'string',
  },
  {
    field: 'onsaledate',
    headerName: 'On Sale Date',
    ...dateColumnConfig,
  },
  {
    field: 'lastSixMonthTotalSale',
    headerName: 'Last 6-months sales',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    flex: 1,
    valueGetter: (_, row) => row.calculatedHistoricalData.lastSixMonthTotalSale,
  },
  {
    field: 'priorToLastSixMonthTotalSale',
    headerName: 'Prior to last 6-months sales',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    flex: 1,
    valueGetter: (_, row) => row.calculatedHistoricalData.priorToLastSixMonthTotalSale,
  },
  {
    field: 'differenceInNumber',
    headerName: 'Difference in number',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    flex: 1,
    valueGetter: (_, row) => row.calculatedHistoricalData.differenceInNumber,
  },
  {
    field: 'differenceInPercentage',
    headerName: 'Difference in percentage',
    type: 'number',
    flex: 1,
    valueFormatter: value => (value ? `${value} %` : ''),
    align: 'left',
    headerAlign: 'left',
    valueGetter: (_, row) => row.calculatedHistoricalData.differenceInPercentage,
  },
  {
    field: 'averageMonthlySalesLast12Months',
    headerName: 'Average monthly sales for last 12-months',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    flex: 1,
    valueGetter: (_, row) => row.calculatedHistoricalData.averageMonthlySalesLast12Months,
  },
  {
    field: 'maxSalesInLastTwelveMonthExcludingBB',
    headerName: 'Maximum sales in last 12 months excluding bookbub deals',
    valueGetter: (_, row) => row.calculatedHistoricalData.maxSalesInLastTwelveMonthExcludingBB,
    hideable: false,
  },
  {
    field: 'minSalesInLastTwelveMonthExcludingBB',
    headerName: 'Minimum sales in last 12 months excluding bookbub deals',
    valueGetter: (_, row) => row.calculatedHistoricalData.minSalesInLastTwelveMonthExcludingBB,
    hideable: false,
  },
];

export const AGGREGATED_HISTORICAL_DATA_LOG_COLUMNS = [
  {
    field: 'itemType',
    headerName: 'Item Type',
    flex: 1,
    type: 'string',
    valueGetter: value => capitalize(value),
  },
  {
    field: 'identifier',
    headerName: 'Identified',
    flex: 1,
    type: 'string',
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 1,
    type: 'string',
  },
  {
    field: 'message',
    headerName: 'Message',
    flex: 1,
    type: 'string',
  },
  {
    field: 'updateDate',
    headerName: 'Updated Date',
    ...dateColumnWithTimeConfig,
  },
];

export const TRAFFIC_LIGHT_REPORT_COLUMNS = [
  { field: 'title', headerName: 'Job', flex: 1, type: 'string' },
  { field: 'frequency', headerName: 'Frequency', flex: 1, type: 'string' },
  {
    field: 'status',
    headerName: 'status',
    flex: 1,
    type: 'string',
    renderCell: renderStatus,
  },
  {
    field: 'startDate',
    headerName: 'Job Start',
    ...dateColumnWithTimeConfig,
  },
  {
    field: 'endDate',
    headerName: 'Job End',
    ...dateColumnWithTimeConfig,
  },
  { field: 'runBy', headerName: 'Job Run By', flex: 1, type: 'string' },
  {
    field: 'runDate',
    headerName: 'Run Date',
    ...dateColumnConfig,
  },
  {
    field: 'emailSentTo',
    headerName: 'Email Sent To',
    flex: 1,
    type: 'string',
  },
  {
    field: 'emailStatus',
    headerName: 'Email Status',
    flex: 1,
    type: 'string',
    renderCell: renderStatus,
  },
  { field: 'logs', headerName: 'Log', flex: 1, disableExport: true, filterable: false, type: 'string' },
];

export const BODHI_METADATA_COLUMNS = [
  { field: 'initialQuestion', headerName: 'Question', flex: 1, type: 'string' },
  { field: 'emailId', headerName: 'Run By', flex: 0.3, type: 'string' },
  { field: 'feedback', headerName: 'Feedback', width: 130, type: 'string', renderCell: renderStatus },
  {
    field: 'startTime',
    headerName: 'Date',
    flex: 0.2,
    ...dateColumnWithTimeConfig,
  },
  { field: 'searchType', headerName: 'Search Type', width: 130, type: 'string' },
  { field: 'llmModel', headerName: 'Model', width: 100, type: 'string' },
  { field: 'isQueryAudioInput', headerName: 'Audio Input', width: 120, renderCell: renderBooleanStatus },
];

const scoreColumnConfig = { type: 'number', headerAlign: 'left', align: 'left' };

export const BOOK_METADATA_SCORING_COLUMNS = [
  {
    field: 'title',
    headerName: 'Title',
    minWidth: 200,
    flex: 1,
    renderCell: ({ row }) => displayTitleLink(row.primary_isbn, row.title),
    type: 'string',
  },
  { field: 'primary_isbn', headerName: 'ISBN', width: 130, type: 'string' },
  { field: 'priorityScore', headerName: 'Priority Score', width: 110, ...scoreColumnConfig },
  { field: 'priorityTier', headerName: 'Priority Tier', width: 100, type: 'string' },
  { field: 'sortOrder', headerName: 'Rank', width: 80, ...scoreColumnConfig },
  { field: 'metadataQualityScore', headerName: 'Metadata Quality Score', width: 110, ...scoreColumnConfig },
  { field: 'metadataQualityTier', headerName: 'Metadata Quality Tier', width: 110, type: 'string' },
  { field: 'bisacScore', headerName: 'Bisac Score', width: 100, ...scoreColumnConfig },
  { field: 'keywordScore', headerName: 'Keyword Score', width: 100, ...scoreColumnConfig },
  { field: 'copyScore', headerName: 'Copy Score', width: 100, ...scoreColumnConfig },
  { field: 'opportunityScore', headerName: 'Opportunity Score', width: 110, ...scoreColumnConfig },
  { field: 'visibilityScoreAdjusted', headerName: 'Visibility Score', width: 110, ...scoreColumnConfig },
  { field: 'visibilityTier', headerName: 'Visibility Tier', width: 100, type: 'string' },
  { field: 'priorityScoreBase', headerName: 'Priority Score Base', width: 110, ...scoreColumnConfig },
  { field: 'promoBoost', headerName: 'Promo Boost', width: 100, ...scoreColumnConfig },
  { field: 'gv12mTotal', headerName: 'GV 12M Total', width: 110, ...scoreColumnConfig },
  { field: 'promoFlag', headerName: 'Promo Flag', width: 100, type: 'string' },
  { field: 'daysUntilPromo', headerName: 'Days Until Promo', width: 100, ...scoreColumnConfig },
  { field: 'nextPromoCampaign', headerName: 'Next Promo Campaign', width: 160, type: 'string' },
  { field: 'nextPromoType', headerName: 'Next Promo Type', width: 130, type: 'string' },
  { field: 'nextPromoDate', headerName: 'Next Promo Date', width: 110, ...dateColumnConfig },
  { field: 'campaignRank', headerName: 'Campaign Rank', width: 100, ...scoreColumnConfig },
  { field: 'dormantFlag', headerName: 'Dormant', width: 80, ...scoreColumnConfig },
  { field: 'newTitleFlag', headerName: 'New Title', width: 80, ...scoreColumnConfig },
  {
    field: 'scoredAt',
    headerName: 'Scored At',
    width: 160,
    ...dateColumnWithTimeConfig,
  },
];

export const TRIGGER_TITLE_CONFIGURATION_COLUMNS = [
  { field: 'name', headerName: 'Trigger Name', flex: 1, minWidth: 150, type: 'string' },
  {
    field: 'minTitleCount',
    headerName: 'Minimum Title Count',
    width: 65,
  },
  {
    field: 'maxTitleCount',
    headerName: 'Maximum Title Count',
    width: 65,
  },
  {
    field: 'destinations',
    headerName: 'Destinations',
    flex: 1,
    type: 'string',
    minWidth: 300,
    valueGetter: (_, row) => {
      const data =
        row.destinations?.map(destination => {
          if (destination.destinationType === 'dlp') {
            return getDLPDestinationInfoText(destination, row.schedule);
          } else {
            return getDestinationInfoText(
              destination,
              row.schedule,
              row.minTitleCount,
              row.maxTitleCount,
              row.distributeTitleEvenly
            );
          }
        }) || [];
      if (row.distributeTitleEvenly) {
        data.push('<b>Titles will be distributed evenly across each campaign destination</b>');
      }
      return Array.isArray(data) ? data.join('<br />') : '';
    },
    renderCell: ({ row }) => {
      const data =
        row.destinations?.map(destination => {
          if (destination.destinationType === 'dlp') {
            return getDLPDestinationInfoText(destination, row.schedule);
          } else {
            return getDestinationInfoText(
              destination,
              row.schedule,
              row.minTitleCount,
              row.maxTitleCount,
              row.distributeTitleEvenly
            );
          }
        }) || [];
      if (row.distributeTitleEvenly) {
        data.push('<b>Titles will be distributed evenly across each campaign destination</b>');
      }
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: Array.isArray(data) ? data.join('<br />') : '',
          }}
        />
      );
    },
  },
  {
    field: 'schedule',
    headerName: 'Trigger Schedule',
    flex: 1,
    minWidth: 150,
    type: 'string',
    valueGetter: value => getFrequencyInfoText(value),
  },
  {
    field: 'lastRunDate',
    headerName: 'Last Run Date',
    ...dateColumnWithTimeConfig,
    width: 120,
    minWidth: 120,
  },
  {
    field: 'nextRunDate',
    headerName: 'Next Run Date',
    ...dateColumnWithTimeConfig,
    width: 120,
    minWidth: 120,
  },
  {
    field: 'user',
    headerName: 'Created By',
    flex: 1,
    minWidth: 120,
    type: 'string',
    valueGetter: value => value?.email,
  },
  {
    field: 'version',
    headerName: 'Version',
    minWidth: 60,
    type: 'number',
    align: 'center',
    headerAlign: 'center',
  },
  {
    field: 'approvers',
    headerName: 'Approvers',
    flex: 1,
    minWidth: 150,
    valueGetter: value => value?.map(approver => approver.label)?.join(', '),
  },
  {
    field: 'status',
    headerName: 'Approver Status',
    minWidth: 100,
    renderCell: ({ value }) => {
      return (
        <Typography variant='caption' color={textColorStatus(value)}>
          {value}
        </Typography>
      );
    },
  },
];

export const TRIGGER_TITLE_RESULT_PARENT_COLUMNS = [
  {
    field: 'name',
    headerName: 'Trigger Name',
    flex: 1,
    minWidth: 150,
    type: 'string',
    valueGetter: (_, row) => row?.triggerName,
  },
  {
    field: 'minTitleCount',
    headerName: 'Minimum Title Count',
    width: 160,
    valueGetter: (_, row) => row?.minTitleCount,
  },
  {
    field: 'maxTitleCount',
    headerName: 'Maximum Title Count',
    width: 160,
    valueGetter: (_, row) => row?.maxTitleCount,
  },
  {
    field: 'count',
    headerName: 'Trigger Result Count',
    width: 160,
    valueGetter: (_, row) => row?.triggerTitlesCount || 0,
  },
  {
    field: 'createdAt',
    headerName: 'Last Run Date',
    ...dateColumnWithTimeConfig,
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 130,
    type: 'string',
  },
  {
    field: 'titlesUpdatedInCampaign',
    headerName: 'Total Titles Updated In Campaign',
    width: 180,
    valueGetter: (_, row) => row?.titlesUpdatedInCampaign || 0,
  },
];

export const TRIGGER_TITLE_RESULT_CHILD_COLUMNS = [
  { field: 'primary_isbn', headerName: 'ISBN', width: 130, type: 'string' },
  { field: 'title', headerName: 'Title', flex: 1, type: 'string' },
  { field: 'publisher', headerName: 'Publisher', flex: 0.5, type: 'string' },
  {
    field: 'customcategories',
    headerName: 'ORM Categories',
    flex: 1,
    type: 'string',
    valueGetter: (_, row) => row?.customcategories?.map(value => value?.Name)?.join(', ') || '',
  },
  {
    field: 'primaryAuthorNames',
    headerName: 'Author',
    flex: 0.5,
    type: 'string',
    valueGetter: (_, row) => row.authordisplayname || row.primaryAuthorNames,
  },
  {
    field: 'campaign',
    headerName: 'Is Part Of Campaign',
    flex: 0.5,
    valueGetter: (_, row) => (row?.campaignId ? true : false),
  },
];

export const TRIGGER_TITLE_DESTINATION_RESULT_COLUMNS = [
  {
    field: 'campaignName',
    headerName: 'Campaign Name',
    flex: 1,
    minWidth: 150,
    renderCell: ({ value, row }) => {
      if (value) {
        return (
          <Link to={`/campaign/edit/${row.campaignId}`} target={'_blank'}>
            {value}
          </Link>
        );
      } else {
        return value;
      }
    },
  },
  {
    field: 'campaignTypeName',
    headerName: 'Campaign Type',
    flex: 1,
    minWidth: 150,
    type: 'string',
  },
  {
    field: 'updatedTitlesCount',
    headerName: 'Updated titles count',
    flex: 1,
    minWidth: 150,
  },
  {
    field: 'campaignStartDate',
    headerName: 'Campaign start date',
    ...dateColumnConfig,
    flex: 1,
  },
  {
    field: 'campaignEndDate',
    headerName: 'Campaign end date',
    ...dateColumnConfig,
    flex: 1,
  },
];

export const BOOKBUB_COST_CONFIGURATION_COLUMNS = [
  {
    headerName: 'Bookbub Custom Category',
    field: 'bookbubcat',
    type: 'string',
    flex: 1,
    valueGetter: (_, row) => (row?.bookbubcat?.[0]?.vendorcategory ? row.bookbubcat[0].vendorcategory?.join(',') : ''),
  },
  { headerName: 'Minimum Price', field: 'minimumPrice', flex: 1 },
  { headerName: 'Maximum Price', field: 'maximumPrice', flex: 1 },
  { headerName: 'Cost', field: 'cost', flex: 1 },
  {
    headerName: 'Country',
    field: 'country',
    type: 'string',
    flex: 1,
  },
];

export const BOOKBUB_PAGE_COUNT_CONFIGURATION_COLUMNS = [
  {
    headerName: 'Bookbub Custom Category',
    field: 'bookbubcat',
    type: 'string',
    flex: 1,
    valueGetter: value => {
      if (value && value.length) {
        return value.map(v => `${v.vendorcategory}`).join(',\n');
      } else {
        return '';
      }
    },
  },
  { headerName: 'Group Name', field: 'groupName', flex: 1, type: 'string' },
  { headerName: 'Page Count', field: 'pageCount', flex: 1 },
];

export const BOOKBUB_PRIORITY_CONFIGURATION_COLUMNS = [
  {
    headerName: 'Priority',
    field: 'priority',
    flex: 1,
    type: 'string',
  },
  {
    headerName: 'Publishers',
    field: 'publishers',
    flex: 1.5,
    type: 'string',
    valueGetter: value => {
      return value?.join(',');
    },
  },
  {
    headerName: 'Publisher Operator',
    field: 'publishersoperator',
    flex: 0.5,
    type: 'string',
    valueGetter: value => {
      const operator = STRING_OPERATOR.find(item => item.value === value);
      return operator ? operator.label : '';
    },
  },
  { headerName: 'Public Domain', field: 'publicdomain', flex: 0.5, type: 'string' },
  {
    headerName: 'Ignition',
    field: 'ignition',
    flex: 0.5,
    type: 'string',
  },
  { headerName: 'On Sale Date Start Date ', field: 'onsalestartdate', flex: 1, ...dateColumnConfig },
  { headerName: 'On Sale Date End Date ', field: 'onsaleenddate', flex: 1, ...dateColumnConfig },
];

export const SDS_BOOKBUB_CATEGORY_DATA_COLUMNS = [
  {
    field: 'category',
    headerName: 'Bookbub Category',
    type: 'string',
    flex: 1,
  },
  {
    field: 'count',
    headerName: 'Title Count',
    type: 'number',
    flex: 1,
    align: 'left',
    headerAlign: 'left',
  },
];

export const SDS_CUT_RATE_DATA_COLUMNS = [
  {
    field: 'cutrate',
    headerName: 'Orim Cut Rate',
    type: 'string',
    flex: 1,
  },
  {
    field: 'sumofcost',
    headerName: 'SUM of Cost',
    type: 'number',
    flex: 1,
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'percentage',
    headerName: 'Percentage',
    type: 'string',
    flex: 1,
  },
];

export const SDS_PRIORITY_DATA_COLUMNS = [
  {
    field: 'priority',
    headerName: 'Bookbub Priority',
    type: 'string',
    flex: 1,
  },
  {
    field: 'sumofcost',
    headerName: 'SUM of Cost',
    type: 'number',
    flex: 1,
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'percentage',
    headerName: 'Percentage',
    type: 'string',
    flex: 1,
  },
];

export const SDS_GRAND_TOTAL_DATA_COLUMNS = [
  {
    field: 'name',
    headerName: 'Grand Total',
    type: 'string',
    flex: 1,
  },
  {
    field: 'value',
    headerName: '',
    type: 'number',
    flex: 1,
    align: 'left',
    headerAlign: 'left',
  },
];

export const DLP_PRICE_UPDATE_VIEW_COLUMNS = [
  {
    field: 'title',
    headerName: 'Title',
    flex: 1,
    minWidth: 150,
    type: 'string',
    valueGetter: (_, row) => row.bookInfo?.title || row.parentBook?.title,
    renderCell: ({ row }) => generateBookDetailLink(row.primaryisbn, row.bookInfo?.title || row.parentBook?.title),
  },
  {
    field: 'primaryisbn',
    headerName: 'Primary ISBN',
    minWidth: 140,
    type: 'string',
    renderCell: ({ value, row }) => {
      if (value && (row.status?.toUpperCase() === 'QUEUE' || row.status?.toUpperCase() === 'DONE')) {
        return (
          <Link to={`/pricelog-update-log?isbn=${value}`} target={'_blank'}>
            {value}
          </Link>
        );
      } else {
        return value;
      }
    },
  },
  { field: 'parentIsbn', headerName: 'Prent ISBN', minWidth: 140, type: 'string' },
  {
    field: 'allowedCountriesForDlp',
    headerName: 'Allowed Countries',
    minWidth: 150,
    type: 'string',
    valueGetter: value => value?.join(', '),
  },
  {
    field: 'disallowedCountriesForDlp',
    headerName: 'Disallowed Countries',
    minWidth: 150,
    type: 'string',
    valueGetter: value => value?.join(', '),
  },
  { field: 'startdate', headerName: 'Start date', ...dateColumnConfig },
  { field: 'price', headerName: 'New Dlp', minWidth: 100 },
  { field: 'format', headerName: 'Book Format', minWidth: 150 },
  {
    field: 'status',
    headerName: 'Status',
    minWidth: 120,
    type: 'string',
    renderCell: ({ value }) => {
      return (
        <Typography variant='caption' color={textColorStatus(value)}>
          {capitalize(value)}
        </Typography>
      );
    },
  },
  {
    field: 'message',
    headerName: 'Message',
    flex: 1.5,
    minWidth: 150,
    type: 'string',
    renderCell: ({ row }) => {
      return (
        <Typography variant='caption' color={textColorStatus(row.status)} style={{ whiteSpace: 'pre-line' }}>
          {row.reason ? row.reason + ', ' + formattedMessageForPricelog(row) : formattedMessageForPricelog(row)}
        </Typography>
      );
    },
  },
];

export const ALWAYS_FREE_BOOKS = [
  { field: 'primary_isbn', headerName: 'Primary_Isbn', flex: 1 },
  {
    field: 'title',
    headerName: 'Title',
    flex: 1,
    renderCell: ({ row }) => generateBookDetailLink(row.primary_isbn, row.title || row.parentBook?.title),
  },
  { field: 'authordisplayname', headerName: 'Author', flex: 1 },
  { field: 'publisher', headerName: 'Publisher', flex: 1 },
];

export const TOP_100_TITLES = [
  { field: 'primary_isbn', headerName: 'Primary_Isbn', flex: 1 },
  {
    field: 'title',
    headerName: 'Title',
    flex: 1,
    renderCell: ({ row }) => generateBookDetailLink(row.primary_isbn, row.title || row.parentBook?.title),
  },
  { field: 'authordisplayname', headerName: 'Author', flex: 1 },
  { field: 'publisher', headerName: 'Publisher', flex: 1 },
];

export const ERROR_COLUMNS_FOR_MANUAL_PRICELOG = [
  { field: 'index', headerName: 'Index', flex: 1 },
  { field: 'Isbn', headerName: 'Primary_Isbn', flex: 1, renderCell: displayError },
  { field: 'PriceType', headerName: 'Price Type', flex: 1, renderCell: displayError },
  { field: 'Currency', headerName: 'Currency', flex: 1, renderCell: displayError },
  { field: 'Price', headerName: 'Price', flex: 1, renderCell: displayError },
  { field: 'EffectiveDate', headerName: 'Effective Date', flex: 1, renderCell: displayError },
];

export const PRICELOG_VIEW_COLUMNS = [
  {
    field: 'title',
    headerName: 'Title',
    minWidth: 170,
    flex: 1,
    type: 'string',
    sortable: false,
    valueGetter: (_, row) => row.bookInfo?.title || row.parentBook?.title,
    renderCell: ({ row }) => generateBookDetailLink(row.primaryisbn, row.bookInfo?.title || row.parentBook?.title),
  },
  {
    field: 'primaryisbn',
    headerName: 'Primary ISBN',
    minWidth: 120,
    type: 'string',
    renderCell: ({ value, row }) => {
      if (value && (row.status?.toUpperCase() === 'QUEUE' || row.status?.toUpperCase() === 'DONE')) {
        return (
          <Link to={`/pricelog-update-log?isbn=${value}`} target={'_blank'}>
            {value}
          </Link>
        );
      } else {
        return value;
      }
    },
  },
  { field: 'parentIsbn', headerName: 'Parent ISBN', minWidth: 120, type: 'string' },

  {
    field: 'name',
    headerName: 'Campaign Name',
    minWidth: 170,
    flex: 1,
    type: 'string',
    sortable: false,
    valueGetter: (_, row) => row.campaigndetail?.name,
    renderCell: ({ row }) => {
      if (row.campaigndetail?.name) {
        return (
          <Link to={`/pricelog-viewer?campaignid=${row.campaignId}`} target={'_blank'}>
            {row.campaigndetail?.name}
          </Link>
        );
      }
    },
  },
  {
    field: 'country',
    headerName: 'Country',
    minWidth: 80,
    type: 'string',
    renderCell: ({ row }) => {
      if (row.country) {
        return row.country;
      } else {
        return (
          <Box>
            <Box>
              <Typography variant='caption'>
                Allowed: <b>{row.allowedCountriesForDlp?.join(',')}</b>
              </Typography>
            </Box>
            <Box>
              <Typography variant='caption'>
                Disallowed: <b>{row.disallowedCountriesForDlp?.join(',')}</b>
              </Typography>
            </Box>
          </Box>
        );
      }
    },
  },
  {
    field: 'retailers',
    headerName: 'Retailers',
    minWidth: 120,
    valueGetter: value => value?.map(retailer => retailer)?.join(', '),
  },
  { field: 'price', headerName: 'Price', minWidth: 80 },
  {
    field: 'format',
    headerName: 'Book Format',
    width: 100,
    valueGetter: (_, row) => row.format || row.bookInfo?.format,
  },
  {
    field: 'priceTypeCode',
    headerName: 'Price Type',
    minWidth: 120,
    type: 'string',
  },
  {
    field: 'currency',
    headerName: 'Currency',
    minWidth: 120,
    type: 'string',
  },
  {
    field: 'stages',
    headerName: 'Stages',
    minWidth: 400,
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    renderCell: ({ row }) => {
      return <PricelogStatusStepper key={row.primaryisbn} row={row} />;
    },
  },
  {
    field: 'finalStatus',
    headerName: 'Status',
    minWidth: 120,
    type: 'string',
    renderCell: ({ value, row }) => {
      return <PopoverWithStatus value={value} row={row} />;
    },
  },
  {
    field: 'message',
    headerName: 'Message',
    flex: 1,
    minWidth: 350,
    type: 'string',
    sortable: false,
    renderCell: renderPricelogEntryMessage,
    valueGetter: (_, row) => pricelogEntryMessage(row),
  },
  {
    field: 'status',
    headerName: 'FITHub Status',
    minWidth: 120,
    renderCell: ({ value }) => {
      return (
        <Typography variant='caption' color={textColorStatus(value)}>
          {value}
        </Typography>
      );
    },
  },
  {
    field: 'eloquenceStatus',
    headerName: 'Eloquence Status',
    minWidth: 120,
    renderCell: ({ value }) => {
      return (
        <Typography variant='caption' color={textColorStatus(value)}>
          {value}
        </Typography>
      );
    },
  },
  {
    field: 'retailerStatus',
    headerName: 'Retailer Status',
    minWidth: 220,
    type: 'string',
    sortable: false,
    valueGetter: (_, row) => row.priceCheckCampops?.map(value => value.status)?.join(', '),
    renderCell: ({ row }) => {
      return (
        <List dense={true}>
          {row.priceCheckCampops?.map(value => (
            <ListItem sx={{ padding: 0 }}>
              <b>{value.retailer}</b> :
              <Typography
                sx={{ ml: 1 }}
                variant='caption'
                color={textColorStatus(value?.status)}
                onClick={() => value.retailerURL && window.open(value.retailerURL, '_blank')}
              >
                {value.status}
              </Typography>
            </ListItem>
          ))}
        </List>
      );
    },
  },
  { field: 'startdate', headerName: 'Start date', ...dateColumnConfig, minWidth: 60 },
  { field: 'enddate', headerName: 'End date', ...dateColumnConfig, minWidth: 60 },

  { field: 'createdat', headerName: 'Created At', ...dateColumnWithTimeConfig, minWidth: 60 },
  { field: 'sentToFirebrandDate', headerName: 'Sent To Fithub Date', ...dateColumnConfig, minWidth: 60 },
  {
    field: 'updatedOnFirebrandDate',
    headerName: 'Updated On Fithub Date',
    ...dateColumnConfig,
    minWidth: 60,
  },
  {
    field: 'batchId',
    headerName: 'Batch Id',
    minWidth: 100,
    flex: 1,
    type: 'string',
    renderCell: ({ value }) => {
      if (value) {
        return (
          <Link to={`/pricelog-update-log?batchid=${value}`} target={'_blank'}>
            {value}
          </Link>
        );
      }
    },
  },
];

/**
 * CampOps Reports — server-side grid over the PriceCheckCampops collection.
 *
 * Sorting/filtering is done by the API, so every column maps to a real stored field.
 * `campaignName` is resolved server-side from campaignId, so it is not sortable.
 */
export const CAMPOPS_REPORTS_COLUMNS = [
  {
    field: 'primaryisbn',
    headerName: 'Primary ISBN',
    minWidth: 130,
    type: 'string',
    renderCell: ({ value }) =>
      value ? (
        <Link to={`/book/${value}`} target={'_blank'}>
          {value}
        </Link>
      ) : (
        ''
      ),
  },
  {
    field: 'campaignName',
    headerName: 'Campaign',
    minWidth: 200,
    flex: 1,
    type: 'string',
    // Joined in from campaigngrid on the server, not stored on the document.
    sortable: false,
    filterable: false,
    // An empty name means the campaigngrid document no longer exists — CampOps rows live
    // for 90 days (TTL) and outlast deleted campaigns. Show that instead of a raw ObjectId,
    // but keep the link so the id is still reachable.
    renderCell: ({ value, row }) =>
      row.campaignId ? (
        <Link to={`/campaign/edit/${row.campaignId}`} target={'_blank'}>
          {value || 'Campaign unavailable'}
        </Link>
      ) : (
        ''
      ),
  },
  {
    field: 'status',
    headerName: 'Status',
    minWidth: 150,
    type: 'string',
    renderCell: ({ value }) => (
      <Typography variant='caption' color={textColorStatus(value)}>
        {value}
      </Typography>
    ),
  },
  { field: 'retailer', headerName: 'Retailer', minWidth: 130, type: 'string' },
  { field: 'country', headerName: 'Country', minWidth: 90, type: 'string' },
  {
    field: 'promoPrice',
    headerName: 'Promo Price',
    minWidth: 110,
    type: 'number',
    valueFormatter: value => (value || value === 0 ? `$${value}` : ''),
  },
  { field: 'startdate', headerName: 'Start Date', ...dateColumnConfig },
  { field: 'enddate', headerName: 'End Date', ...dateColumnConfig },
  { field: 'crawlTime', headerName: 'Crawl Time', ...dateColumnWithTimeConfig },
  {
    field: 'external_title',
    headerName: 'External Title',
    minWidth: 120,
    type: 'string',
  },
  { field: 'itemId', headerName: 'Item ID', minWidth: 130, type: 'string' },
  {
    field: 'retailerURL',
    headerName: 'Retailer URL',
    minWidth: 130,
    type: 'string',
    sortable: false,
    renderCell: ({ value }) =>
      value ? (
        <a href={value} target='_blank' rel='noopener noreferrer'>
          View
        </a>
      ) : (
        ''
      ),
  },
  { field: 'createdAt', headerName: 'Created At', ...dateColumnWithTimeConfig },
];

export const CAMPAIGN_HOME_COLUMNS = [
  { field: 'name', headerName: 'Name', flex: 1, minWidth: 100, type: 'string' },
  { field: 'campaigntypename', headerName: 'Campaign Type', flex: 1, minWidth: 100, type: 'string' },
  { field: 'campaignsubtypename', headerName: 'Campaign Sub Type', flex: 1, minWidth: 100, type: 'string' },
  {
    field: 'titlecount',
    headerName: 'Title Count',
    type: 'number',
    flex: 0.5,
    minWidth: 100,
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'startdate',
    headerName: 'Start Date',
    flex: 0.5,
    ...dateColumnConfig,
  },
  {
    field: 'enddate',
    headerName: 'End Date',
    flex: 0.5,
    renderCell: ({ value }) => {
      if (value === null || value === '') return <span></span>;

      let today = new Date();
      let enddate = new Date(value);
      today.setHours(0, 0, 0, 0);
      enddate.setHours(0, 0, 0, 0);
      enddate.setDate(enddate.getDate() + 1);

      let color;
      enddate >= today ? (color = 'green') : (color = 'red');

      let date = _formatDate(value, 'MM/dd/yyyy');
      return <span style={{ color: color, fontWeight: 'bold' }}>{date}</span>;
    },

    ...dateColumnConfig,
  },
  { field: 'schedulercode', headerName: 'Scheduler Code', flex: 1, type: 'string' },
];

export const MONTHLY_REPORT_COLUMNS = handleTransactionItemClick => [
  {
    field: 'type',
    headerName: 'Type',
    flex: 1,
    type: 'string',
  },
  {
    field: 'source',
    headerName: 'Source',
    flex: 1,
    type: 'string',
  },
  {
    field: 'invoiceSentDate',
    headerName: 'Invoice Sent Date',
    flex: 1,
    ...dateColumnConfig,
  },
  {
    field: 'businessUnit',
    headerName: 'Class',
    flex: 1,
    type: 'string',
    formatter: (cell, row) => {
      if (row.businessUnit && row.businessUnit.length > 0) {
        return row.businessUnit.join(', ');
      }
    },
  },
  {
    field: 'item',
    headerName: 'Item',
    flex: 1,
    type: 'string',
  },
  {
    field: 'clientInfoName',
    headerName: 'PO #',
    flex: 1,
    type: 'string',
    valueGetter: (_, row) => row?.clientInfo?.contactInfo?.map(contact => contact.name)?.join(','),
  },
  {
    field: 'clientInfoEmail',
    headerName: 'Contact Email',
    flex: 1,
    type: 'string',
    valueGetter: (_, row) => row?.clientInfo?.contactInfo?.map(contact => contact.email)?.join(','),
  },
  {
    field: 'cost',
    headerName: 'Amount',
    flex: 1,
    renderCell: ({ row, value }) => (
      <TransactionTableItem
        transactionId={row._id}
        handleTransactionItemClick={transactionId => handleTransactionItemClick(transactionId)}
      >
        {value}
      </TransactionTableItem>
    ),
  },
  {
    field: 'paymentStatus',
    headerName: 'Payment Status',
    flex: 1,
    type: 'string',
  },
  {
    field: 'clientInfo',
    headerName: 'Description',
    flex: 1,
    type: 'string',
    valueGetter: value => {
      const info = value.contactInfo?.length > 0 && value.contactInfo[0];
      if (info) {
        return info.name || info.email;
      }
    },
  },
];

export const SERVICE_REQUEST_EDITABLE = (businessUnitOptions, displayAdsTypeOptions) => [
  {
    field: 'serviceType',
    headerName: 'Service Type',
    width: 130,
  },
  {
    field: 'title',
    headerName: 'Title',
    width: 200,
    type: 'string',
  },
  {
    field: 'primaryIsbn',
    headerName: 'ISBN',
    width: 140,
  },
  {
    field: 'authors',
    headerName: 'Authors',
    type: 'string',
    width: 150,
  },
  {
    field: 'dlp',
    headerName: 'DLP',
    width: 100,
    editable: true,
    type: 'number',
  },
  {
    field: 'saleDlp',
    headerName: 'Sale DLP',
    editable: true,
    type: 'number',
  },

  {
    field: 'businessUnit',
    headerName: 'Business Unit',
    editable: true,
    valueOptions: businessUnitOptions,
    type: 'singleSelect',
  },
  {
    field: 'campaign',
    headerName: 'Campaign',
    type: 'string',
    renderCell: ({ row }) => (
      <div>{row?.campaign?.name ? generateCampaignLinkNew(row?.campaign?._id, row?.campaign?.name) : ''}</div>
    ),
  },
  {
    field: 'url',
    headerName: 'Url',
    type: 'text',
    width: 300,
    editable: true,
  },
  {
    field: 'displayAdsType',
    headerName: 'Display Ads Type',
    width: 150,
    valueOptions: displayAdsTypeOptions,
    type: 'singleSelect',
    valueGetter: value => value || '',
  },
  {
    field: 'runDate',
    headerName: 'Run Date',
    editable: true,
    ...dateColumnConfig,
  },
  {
    field: 'startDate',
    headerName: 'Start Date',
    editable: true,
    ...dateColumnConfig,
  },
  {
    field: 'endDate',
    headerName: 'End Date',
    editable: true,
    ...dateColumnConfig,
  },
  {
    field: 'serviceStatus',
    headerName: 'Service Status',
    type: 'string',
    width: 120,
  },
];

export const SERVICE_REQUEST_TABLE = (handleTransactionItemClick, generateBookDetailLink) => [
  {
    field: 'clientInfo',
    headerName: 'Client',
    width: 150,
    valueGetter: value => value?.name,
    type: 'string',
    renderCell: ({ row }) => (
      <TransactionTableItem
        transactionId={row.transactionId}
        handleTransactionItemClick={transactionId => handleTransactionItemClick(transactionId)}
      >
        {row.clientInfo?.name}
      </TransactionTableItem>
    ),
  },
  {
    field: 'serviceType',
    headerName: 'Service Type',
    width: 110,
    type: 'string',
  },
  {
    field: 'title',
    headerName: 'Title',
    width: 250,
    type: 'string',
    renderCell: ({ row }) => generateBookDetailLink(row.primaryIsbn, row.title),
  },
  {
    field: 'primaryIsbn',
    headerName: 'ISBN',
    width: 140,
    type: 'string',
  },
  {
    field: 'asin',
    headerName: 'ASIN',
    width: 130,
    type: 'string',
  },
  {
    field: 'audible_asin',
    headerName: 'Audible ASIN',
    width: 130,
    type: 'string',
  },
  {
    field: 'authors',
    headerName: 'Authors',
    width: 230,
    type: 'string',
  },
  {
    field: 'campaign',
    headerName: 'Campaign',
    type: 'string',
    valueGetter: value => value?.name,
    renderCell: ({ row }) => generateCampaignLinkNew(row?.campaign?._id, row?.campaign?.name),
  },
  {
    field: 'runDate',
    headerName: 'Run Date',
    ...dateColumnConfig,
  },

  {
    field: 'dlp',
    headerName: 'DLP',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'saleDlp',
    headerName: 'Sale DLP',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'cost',
    headerName: 'Cost',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    renderCell: ({ row, value }) => (
      <TransactionTableItem
        transactionId={row.transactionId}
        handleTransactionItemClick={transactionId => handleTransactionItemClick(transactionId)}
      >
        {value}
      </TransactionTableItem>
    ),
    filterOperators: getNumericOperators(),
  },
  {
    field: 'businessUnit',
    headerName: 'Business Unit',
    type: 'string',
  },
  {
    field: 'countries',
    headerName: 'Countries',
    width: 150,
    type: 'string',
    valueGetter: value => {
      if (Array.isArray(value)) {
        return value.join(', ');
      }
      return value || '';
    },
  },

  {
    field: 'url',
    headerName: 'Url',
    width: 250,
    renderCell: renderURLCell,
  },
  {
    field: 'displayAdsType',
    headerName: 'Display Ads Type',
    width: 100,
  },
  {
    field: 'startDate',
    headerName: 'Start Date',
    ...dateColumnConfig,
  },
  {
    field: 'endDate',
    headerName: 'End Date',
    ...dateColumnConfig,
  },
  {
    field: 'pubDate',
    headerName: 'Pub Date',
    ...dateColumnConfig,
  },
  {
    field: 'source',
    headerName: 'Source',
    width: 85,
    type: 'string',
  },
  {
    field: 'paymentStatus',
    headerName: 'Payment Status',
    type: 'string',
  },

  {
    field: 'serviceStatus',
    headerName: 'Service Status',
    type: 'string',
  },

  {
    field: 'transactionName',
    headerName: 'Transaction Name',
    width: 300,
    type: 'string',
  },

  {
    field: 'createdbyname',
    headerName: 'Created By',
    width: 150,
    type: 'string',
    valueGetter: value => {
      if (value) {
        if (value.first_name || value.last_name) {
          return value.first_name + ' ' + value.last_name;
        } else return value.email;
      } else return '';
    },
  },
];

export const SOLD_SLOT_CONFIG_COLUMNS = campaignTypes => [
  {
    field: 'campaigntype',
    headerName: 'Campaign Type',
    flex: 1,
    type: 'string',
    minWidth: 150,
    valueGetter: value => {
      if (value) {
        let ct = campaignTypes.find(campaignType => campaignType.value === value);
        return ct?.label;
      }
    },
  },
  {
    field: 'campaignsubtype',
    headerName: 'Campaign Sub Type',
    flex: 1,
    type: 'string',
    minWidth: 150,
    valueGetter: value => value?.name || '',
  },
  { field: 'campaignname', headerName: 'Campaign Name', flex: 1, minWidth: 150, type: 'string' },
  {
    field: 'createdbyname',
    headerName: 'Created By',
    flex: 1,
    type: 'string',
    minWidth: 150,
    valueGetter: displayUserName,
  },
  {
    field: 'updatedbyname',
    headerName: 'Updated By',
    flex: 1,
    type: 'string',
    minWidth: 150,
    valueGetter: displayUserName,
  },
];

export const TITLE_ERROR_COLUMN = {
  field: 'title',
  headerName: 'Title',
  width: 130,
  type: 'string',
};

export const BOOK_META_DATA_COLUMNS = [
  { field: 'primary_isbn', headerName: 'ISBN', width: 130, type: 'string' },
  { field: 'title', headerName: 'Title', flex: 0.5, type: 'string' },
  { field: 'newsletter_copy', headerName: 'Existing Strapline', flex: 1, type: 'string' },
  { field: 'chatgpt', headerName: 'ChatGPT Strapline', flex: 1.5, type: 'string' },
];

export const BLOCK_LIST_COLUMNS = [
  {
    field: 'clients',
    headerName: 'Blocked Clients',
    valueGetter: value => value?.join(', '),
    type: 'string',
    minWidth: 120,
  },
  {
    field: 'publishers',
    headerName: 'Blocked Publishers',
    valueGetter: value => value?.join(', '),
    type: 'string',
    minWidth: 120,
  },
  {
    field: 'publishersBatch',
    headerName: 'Blocked Publisher & Batch',
    valueGetter: value => value?.join(', '),
    type: 'string',
    minWidth: 120,
  },
  {
    field: 'title',
    headerName: 'Blocked Title',
    flex: 1,
    renderCell: ({ row }) => {
      const priamryIsbn = row.primary_isbn;
      const title = row.Books[0]?.title || row.title;
      return displayTitleLink(priamryIsbn, title);
    },
    type: 'string',
    minWidth: 150,
  },
  { field: 'primary_isbn', headerName: 'ISBN', width: 150, type: 'string' },
  {
    field: 'publisher',
    headerName: 'Publisher',
    type: 'string',
    renderCell: ({ row }) => {
      return row?.Books?.[0]?.publisher;
    },
    valueGetter: (_, row) => row?.Books?.[0]?.publisher,
  },
  {
    field: 'Batch',
    headerName: 'Batch',
    type: 'string',
    renderCell: ({ row }) => {
      return row?.Books?.[0]?.bookData?.[0]?.batch;
    },
    valueGetter: (_, row) => row?.Books?.[0]?.bookData?.[0]?.batch,
  },
  { field: 'campaigntypeexceptionsName', headerName: 'Allowed Campaign Type', minWidth: 150, type: 'string' },
  { field: 'blockedCampaignTypesName', headerName: 'Blocked Campaign Type', minWidth: 150, type: 'string' },
  { field: 'countries', headerName: 'Blocked Territory', width: 100, type: 'string' },
  {
    field: 'start_date',
    headerName: 'Start Date',
    ...dateColumnConfig,
  },
  {
    field: 'end_date',
    headerName: 'End Date',
    ...dateColumnConfig,
  },
];

export const BOOK_DETAIL_AMAZON_QUOTE_COLUMNS = [
  {
    field: 'review',
    headerName: 'Review',
    flex: 1,
    type: 'string',
  },
  {
    field: 'source',
    headerName: 'Source',
    flex: 1,
    type: 'string',
  },
];

export const BOOK_DETAIL_COLUMNS = [
  {
    field: 'awardname',
    headerName: 'Name',
    flex: 1,
    type: 'string',
  },
  {
    field: 'awardstatus',
    headerName: 'Status',
    flex: 1,
    type: 'string',
  },
  {
    field: 'awardnote',
    headerName: 'Note',
    flex: 1,
    type: 'string',
  },
];

export const AMAZON_TABLE_COULMN = [
  {
    field: 'country',
    headerName: 'Country',
    flex: 1,
    type: 'string',
  },
  {
    field: 'amazon_rank',
    headerName: 'Rank',
    flex: 1,
  },
  {
    field: 'amazon_review',
    headerName: 'Rating',
    flex: 1,
  },
  {
    field: 'amazon_review_count',
    headerName: 'Review Count',
    flex: 1,
    type: 'string',
  },
];

export const SEARCH_RESULTS_TABLE_COUMNS = bookColumnFormatter => [
  {
    field: 'title',
    headerName: 'Title',
    flex: 1,
    renderCell: ({ value, row }) => bookColumnFormatter(value, row, 'title'),
  },
  {
    field: 'authors',
    headerName: 'Authors',
    flex: 1,
    renderCell: ({ value, row }) => bookColumnFormatter(value, row, 'authordisplayname'),
  },
];

export const ADD_EVENT_POST_DATA_COLUMNS = postColumnFormatter => [
  {
    field: 'title',
    headerName: 'Title',
    flex: 1,
    renderCell: ({ value, row }) => postColumnFormatter(value, row, 'title'),
  },
  {
    field: 'site_id',
    headerName: 'Site Name',
    flex: 1,
    renderCell: ({ value, row }) => postColumnFormatter(value, row, 'siteName'),
  },
];

export const CAMPAIGN_TYPE_TABLE_COLUMNS = [
  {
    headerName: 'Campaign Type',
    field: 'text',
    type: 'string',
    flex: 1,
  },
  {
    headerName: 'Type',
    field: 'typevalue',
    type: 'string',
    flex: 1,
  },
  {
    headerName: 'Site',
    field: 'site',
    type: 'string',
    flex: 1,
  },
  {
    headerName: 'Priority',
    field: 'priority',
    type: 'Number',
    flex: 1,
  },

  {
    headerName: 'End Date Optional',
    field: 'optionalenddate',
    type: 'string',
    align: 'center',
    headerAlign: 'center',
    valueGetter: value => (value ? 'Yes' : 'No'),
    flex: 1,
  },
  {
    headerName: 'Exclude from TSD Report',
    field: 'excludeFromTSD',
    type: 'string',
    align: 'center',
    headerAlign: 'center',
    valueGetter: value => (value ? 'Yes' : 'No'),
    flex: 1,
  },
  {
    headerName: 'Allowed Product Type',
    field: 'allowProductTypes',
    flex: 1,
    minWidth: 180,
  },
  {
    headerName: 'Notify Team Members',
    field: 'notify',
    type: 'string',
    flex: 1,
  },
  {
    headerName: 'Notify Campaign Error',
    field: 'campaignErrorNotify',
    type: 'string',
    flex: 1,
  },
];

export const CAMPAIGN_TYPE_EDIT_COLUMNS = (setSelectedDraftColumn, setDraftColumnMode) => [
  {
    field: 'column',
    headerName: 'Column Name',
    flex: 1.5,
    type: 'string',
    valueGetter: (_, row) => row.column.label,
  },
  {
    field: 'excludeExport',
    headerName: 'Exclude Country Data from Customized Draft Export',
    flex: 1,
    renderCell: ({ row }) => {
      return (
        <div style={{ textAlign: 'center' }}>
          <input
            style={{ cursor: 'pointer' }}
            type='checkbox'
            checked={row.excludeExport}
            onChange={e => {
              setSelectedDraftColumn({
                column: row.column,
                excludeCountryData: row.excludeCountryData,
                excludeExport: e.target.checked,
              });
              setDraftColumnMode('edit');
            }}
          />
        </div>
      );
    },
  },
  {
    field: 'excludeCountryData',
    headerName: 'Exclude Country Data from Draft',
    flex: 1,
    renderCell: ({ row }) => {
      return (
        <div style={{ textAlign: 'center' }}>
          <input
            style={{ cursor: 'pointer' }}
            type='checkbox'
            disabled={(row.column && row.column.value && !row.column.value.isCountryBasedData) || row.excludeExport}
            checked={row.excludeCountryData}
            onChange={e => {
              setSelectedDraftColumn({
                column: row.column,
                excludeExport: row.excludeExport,
                excludeCountryData: e.target.checked,
              });
              setDraftColumnMode('edit');
            }}
          />
        </div>
      );
    },
  },
];

export const FACEBOOK_AD_COLUMNS = [
  {
    field: 'awardname',
    headerName: 'Name',
    flex: 1,
    type: 'string',
  },
  {
    field: 'awardstatus',
    headerName: 'Status',
    flex: 1,
    type: 'string',
  },
];

export const FACEBOOK_AD_MANAGER_COLUMNS = [
  {
    headerName: 'Ad Name',
    field: 'adName',
    flex: 2,
    type: 'string',
  },
  { headerName: 'Budget ($)', field: 'dailyBudget', flex: 1, type: 'string' },
  { headerName: 'Spend', field: 'spend', flex: 1, type: 'string' },
  { headerName: 'Frequency', field: 'frequency', flex: 1, type: 'string' },
  { headerName: 'Impressions', field: 'impressions', flex: 1, type: 'string' },
  { headerName: 'Link Clicks', field: 'linkClicks', flex: 1, type: 'string' },
  { headerName: 'CTR Pct', field: 'ctrPct', flex: 1, type: 'string' },
  { headerName: 'CPC', field: 'cpc', flex: 1, type: 'string' },
  { headerName: 'During Proceeds', field: 'duringProceeds', flex: 1, type: 'string' },
  { headerName: 'SalesLift', field: 'salesLift', flex: 1, type: 'string' },
];

export const FACEBOOK_AD_SET_COLUMNS = campaignStatus => [
  { headerName: 'AdSet Name', field: 'adsetName', flex: 1, type: 'string' },
  { headerName: 'AdSet Country', field: 'country', flex: 1, type: 'string' },
  { headerName: 'Budget ($)', field: 'dailyBudget', flex: 1 },
  { headerName: 'Spend', field: 'adsetSpend', flex: 1 },
  { headerName: 'CTRPct', field: 'adsetCtrPct', flex: 1 },
  { headerName: 'CPC', field: 'adsetCpc', flex: 1 },
  { headerName: 'During Proceeds', field: 'adsetDuringProceeds', flex: 1, type: 'string' },
  { headerName: 'SalesLift', field: 'adsetSalesLift', flex: 1, type: 'string' },
  {
    field: '_id',
    headerName: 'Actions',
    headerAlign: 'center',
    align: 'center',
    type: 'string',
    renderCell: ({ row }) => {
      let campaignStatusArray = ['ACTIVE'];
      if (campaignStatusArray.includes(campaignStatus)) {
        return (
          <div style={{ textAlign: 'center' }}>
            <Tooltip title='Clone'>
              <IconButton size='small' onClick={() => this.handleCloneAdSet(row, 'adset')}>
                <ExpandCircleDown color='error' />
              </IconButton>
            </Tooltip>
          </div>
        );
      }
    },
  },
];

export const FACEBOOK_AD_CAMPAIGN_TABLE_COLUMN = [
  {
    headerName: 'Title',
    field: 'title',
    flex: 1.5,
    type: 'string',
  },
  {
    headerName: 'Campaign',
    field: 'campaignName',
    flex: 1.5,
    type: 'string',
    renderCell: ({ row }) => (
      <a
        target='__blank'
        href={`${process.env.REACT_APP_FACEBOOK_BUSINESS_URL}/adsmanager/manage/campaigns/edit?${process.env.REACT_APP_FACEBOOK_ACCOUNT_ID}&business_id=${process.env.REACT_APP_FACEBOOK_BUSINESS_ID}&selected_campaign_ids=${row.campaignID}`}
      >
        {row.campaignName}
      </a>
    ),
  },
  {
    headerName: 'Start Date',
    field: 'startDate',
    flex: 1,
    ...dateColumnConfig,
  },
  {
    headerName: 'End Date',
    field: 'endDate',
    flex: 1,
    ...dateColumnConfig,
  },
  {
    headerName: 'Budget ($)',
    field: 'budget',
    flex: 1,
  },
  { headerName: 'Spend', field: 'spend', flex: 1 },
  { headerName: 'CTRPct', field: 'ctrpct', flex: 1 },
  { headerName: 'CPC', field: 'cpc', flex: 1 },
  { headerName: 'During Proceeds', field: 'duringProceeds', flex: 1 },
  {
    headerName: 'ORIM Proceeds',
    field: 'orimProceeds',
    flex: 1,
    type: 'string',
  },
  { headerName: 'SalesLift', field: 'saleslift', flex: 1, type: 'string' },
  { headerName: 'Campaign Status', field: 'campaignStatus', flex: 1, type: 'string' },
];

export const CC_MAPPING_COLUMNS = [
  {
    headerName: 'Custom Category',
    field: 'custcat',
    type: 'string',
    flex: 1,
    valueGetter: value => value.map(x => x.Name)?.join(', '),
  },
  {
    headerName: 'Bisacs',
    field: 'bisacs',
    type: 'string',
    flex: 1,
    valueGetter: value => value?.join(', '),
  },
  { headerName: 'Vendor', field: 'vendor', flex: 0.5 },
  {
    headerName: 'Vendor Category',
    field: 'vendorcategory',
    type: 'string',
    flex: 1,
    valueGetter: value => value?.join(', '),
  },
  {
    headerName: 'Countries',
    field: 'countries',
    type: 'string',
    flex: 1,
    valueGetter: value => value?.join(', '),
  },
];

export const PROMO_PRICE_COLUMNS = [
  {
    field: 'range',
    headerName: 'Name',
    flex: 0.5,
    type: 'string',
    valueGetter: value => value?.join('-'),
  },
  { field: 'minDLP', headerName: 'Minimum DLP(range)', flex: 0.5 },
  {
    field: 'maxDLP',
    headerName: 'Maximum DLP(range)',
    flex: 0.5,
  },
  {
    field: 'promoprice',
    headerName: 'Promo Price',
    flex: 0.5,
  },
  { field: 'bookTypes', headerName: 'Book Type', flex: 0.5, type: 'string' },
  {
    field: 'countries',
    headerName: 'Countries',
    flex: 0.5,
    type: 'string',
    valueGetter: value => value?.join(', '),
  },
  {
    field: 'author_name',
    headerName: 'Author',
    flex: 0.5,
    type: 'string',
    valueGetter: (_, row) => {
      let displayName = [];
      if (row?.author_name) {
        row.author_name.forEach(authors_list => {
          displayName.push(authors_list.display_name);
        });
        return displayName.toString();
      }
    },
  },
  {
    field: 'amazonRankString',
    headerName: 'Amazon Rank',
    flex: 0.5,
    type: 'string',
    valueGetter: value => value || '',
  },
  {
    field: 'campaigntypenames',
    headerName: 'Campaign Type',
    flex: 1,
    type: 'string',
  },
  {
    field: 'bookbubcategorynames',
    headerName: 'Bookbub Category',
    flex: 1,
    type: 'string',
  },
  {
    field: 'followerCountString',
    headerName: 'Bookbub Follower Count',
    flex: 1,
    type: 'string',
  },
];

export const UPLOAD_BOOK_COLUMNS = [
  { field: 'title', headerName: 'Title', flex: 1, type: 'string' },
  { field: 'multipleAuthors', headerName: 'Authors', flex: 1, type: 'string' },
  { field: 'publisher', headerName: 'Publisher', flex: 1, type: 'string' },
  { field: 'primary_isbn', headerName: 'Primary ISBN', width: 130, type: 'string' },
  { field: 'asin', headerName: 'ASIN', width: 130, type: 'string' },
  { field: 'image', headerName: 'Book Cover', flex: 1.5 },
  { field: 'sale_dlp', headerName: 'Sale DLP', flex: 0.5 },
  { field: 'price', headerName: 'Price', flex: 0.5 },
  { field: 'google_id', headerName: 'Google Id', flex: 0.5, type: 'string' },
  { field: 'bn_primary_isbn', headerName: 'B&N ISBN', flex: 1, type: 'string' },
  { field: 'bisacs', headerName: 'BISAC', flex: 1, type: 'string' },
  { field: 'countries', headerName: 'Countries', flex: 0.8, type: 'string' },
  { field: 'newsletter_copy', headerName: 'EBB Newsletter Description', flex: 1, type: 'string' },
];

export const MILE_STONE_COLUMNS = [
  {
    field: 'title',
    headerName: 'Event Name',
    type: 'string',
    renderCell: ({ row }) => {
      if (!row.active) return <s>{row.title}</s>;
      return <span>{row.title}</span>;
    },
    flex: 1,
  },
  { field: 'type', headerName: 'Type', type: 'string', flex: 1 },
  {
    field: 'frequency',
    headerName: 'Frequency',
    type: 'string',
    flex: 1,
  },
  {
    field: 'allDay',
    headerName: 'All Day',
    type: 'bool',
    flex: 1,
  },
  {
    field: 'contentSite',
    headerName: 'Site',
    sort: true,
    valueGetter: value => value.join(', '),
    flex: 1,
  },
  {
    field: 'start',
    headerName: 'Start Date',
    flex: 1,
    ...dateColumnConfig,
  },
  {
    field: 'end',
    headerName: 'End Date',
    flex: 1,
    ...dateColumnConfig,
  },
];

export const CUSTOM_CATEGORIES_MODAL_COLUMNS = [
  {
    field: 'category',
    headerName: 'Category',
    type: 'string',
    flex: 1,
  },
  {
    field: 'count',
    headerName: 'Title Count',
    type: 'number',
    flex: 1,
    align: 'left',
    headerAlign: 'left',
  },
];

export const LOAD_PERFERENCE_MODAL_COLUMNS = togglePreferenceDefault => [
  { headerName: 'Name', field: 'name', type: 'string', flex: 1 },
  {
    headerName: 'Is Default',
    field: 'isDefault',
    flex: 0.5,
    renderCell: ({ value, row }) => {
      return <Switch value={value} checked={value} onChange={() => togglePreferenceDefault(row)} id='default-switch' />;
    },
  },
];

export const NOMINATION_FILTER_TRACKING_COLUMNS = [
  { field: '_id', headerName: 'Filters', flex: 2, type: 'string' },
  { field: 'count', headerName: 'Count', flex: 1 },
];

const formatAsyncTrackingElapsedDuration = value => {
  const totalSeconds = Math.max(0, Math.round((Number(value) || 0) / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return `${hours} Hour ${minutes} Min ${seconds} Sec`;
  }

  if (minutes > 0) {
    return `${minutes} Min ${seconds} Sec`;
  }

  return `${seconds} Sec`;
};

const renderAsyncTrackingMetricCell = (value, color, backgroundColor) => (
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      px: 1.25,
      py: 0.5,
      borderRadius: 2,
      fontWeight: 700,
      color,
      backgroundColor,
    }}
  >
    {value}
  </Box>
);

export const ASYNC_FILTER_TRACKING_COLUMNS = [
  { field: '_id', headerName: 'Filters', flex: 2, type: 'string' },
  {
    field: 'count',
    headerName: 'Count',
    flex: 0.7,
    type: 'number',
    renderCell: ({ value }) => renderAsyncTrackingMetricCell(value, '#7C2D12', '#FFF1EB'),
  },
  {
    field: 'minElapsedMs',
    headerName: 'Min',
    flex: 0.7,
    type: 'number',
    renderCell: ({ value }) =>
      renderAsyncTrackingMetricCell(formatAsyncTrackingElapsedDuration(value), '#0F766E', '#E6F7F2'),
  },
  {
    field: 'maxElapsedMs',
    headerName: 'Max',
    flex: 0.7,
    type: 'number',
    renderCell: ({ value }) =>
      renderAsyncTrackingMetricCell(formatAsyncTrackingElapsedDuration(value), '#B42318', '#FEECEB'),
  },
  {
    field: 'avgElapsedMs',
    headerName: 'Average',
    flex: 0.8,
    type: 'number',
    renderCell: ({ value }) =>
      renderAsyncTrackingMetricCell(formatAsyncTrackingElapsedDuration(value), '#1D4ED8', '#E8F0FF'),
  },
];

export const NOMINATION_RESULTS_FIXED_COLUMNS = isInPersonalDraft => [
  { field: 'primary_isbn', headerName: 'Primary_ISBN', type: 'string', hideable: false },
  { field: 'amazon_isbn13', headerName: 'Amazon_ISBN', type: 'string', hideable: false },
  { field: 'asin', headerName: 'ASIN', type: 'string', hideable: false },
  {
    field: 'drafts',
    headerName: 'Personal/Shared Draft Name',
    type: 'string',
    hideable: false,
    valueGetter: (value, row) => {
      let data = value;
      if (isInPersonalDraft(row.primary_isbn)) {
        data = 'Personal Draft' + data;
      }
      return data;
    },
    width: 200,
  },
];

export const NOMINATION_PARENT_COLUMNS = [
  { field: 'name', headerName: 'Name', flex: 1, type: 'string' },
  {
    field: 'colCount',
    headerName: 'Column Count',
    headerAlign: 'center',
    align: 'center',
    flex: 0.5,
  },
];

export const ORDER_COLUMNS = [
  {
    field: 'order',
    headerName: 'Order',
    flex: 0.5,
    align: 'center',
    type: 'number',
    headerAlign: 'center',
    valueGetter: value => value + 1,
  },
  {
    field: 'title',
    flex: 1,
    headerName: 'Column Name',
    type: 'string',
  },
];

export const CHILD_COLUMNS = [{ field: 'title', headerName: 'Column Name', flex: 1, type: 'string' }];

export const RESTRICTED_TERRITORY_COLUMNS = [
  {
    field: 'publishers',
    headerName: 'Publisher',
    flex: 1,
    valueGetter: value => value?.join(', ') || 'NA',
    type: 'string',
  },
  {
    field: 'title',
    headerName: 'Title',
    flex: 1,
    renderCell: ({ row }) => displayTitleLink(row.primary_isbn, row.title),
    type: 'string',
  },
  {
    field: 'primary_isbn',
    headerName: 'ISBN',
    width: 150,
    type: 'string',
  },
  {
    field: 'countries',
    headerName: 'Country',
    valueGetter: value => value?.join(', ') || 'NA',
    type: 'string',
    flex: 1,
  },
  {
    field: 'groups',
    headerName: 'User group which has rights',
    valueGetter: value => value?.join(', ') || 'NA',
    type: 'string',
    flex: 1,
  },
];

export const PREFERENCE_TYPE_COLUMNS = [
  { field: 'name', headerName: 'Preference Type', flex: 1, type: 'string' },
  { field: 'isDefault', headerName: 'Default', flex: 0.75, type: 'string' },
];

export const ADD_EDIT_SHARED_DRAFT_COLUMNS = [
  { field: 'name', headerName: 'Name', flex: 1, type: 'string' },
  {
    field: 'totalDraftTitles',
    headerName: 'Title Count',
    flex: 1,
  },
  {
    field: 'draftLock',
    headerName: 'Draft Locked By',
    width: 100,
    valueGetter: value => {
      if (value) {
        if (value.lockedByUser.first_name || value.lockedByUser.last_name) {
          return value.lockedByUser.first_name + ' ' + value.lockedByUser.last_name;
        } else return value.lockedByUser.email;
      } else return '';
    },
    type: 'string',
    flex: 1,
    renderCell: params => {
      const value = params.value;
      return <span style={{ color: 'red' }}>{value}</span>;
    },
  },
  {
    field: 'createdbyname',
    headerName: 'Created By',
    width: 100,
    valueGetter: value => {
      if (value) {
        if (value.first_name || value.last_name) {
          return value.first_name + ' ' + value.last_name;
        } else return value.email;
      } else return '';
    },
    type: 'string',
    flex: 1,
  },
];

export const BOOK_SEARCH_RESULTS_COLUMNS = bookColumnFormatter => [
  {
    field: 'title',
    headerName: 'Title',
    flex: 1,
    type: 'string',
    renderCell: ({ value, row }) => bookColumnFormatter(value, row, 'title'),
  },
  {
    field: 'authordisplayname',
    headerName: 'Authors',
    flex: 1,
    type: 'string',
    renderCell: ({ value, row }) => bookColumnFormatter(value, row, 'authordisplayname'),
  },
];

export const VALIDATE_LIST_COLUMNS = [
  { field: 'title', headerName: 'Title', flex: 1, type: 'string' },
  { field: 'primary_isbn', headerName: 'ISBN', flex: 1, type: 'string' },
  { field: 'promoprice', headerName: 'Promoprice', flex: 1 },
  { field: 'authors', headerName: 'Authors', flex: 1, type: 'string' },
  { field: 'campaigntypeexceptionsName', headerName: 'Campaign Type Exceptions', flex: 1, type: 'string' },
  {
    field: 'start_date',
    headerName: 'Start Date',
    flex: 1,
    ...dateColumnConfig,
  },
  {
    field: 'end_date',
    headerName: 'End Date',
    flex: 1,
    ...dateColumnConfig,
  },
];

export const DRAFT_EDITABLE_COLUMNS = [
  {
    field: 'campaignStartDate',
    headerName: 'Start Date',
    editable: true,
    width: 120,
  },
  {
    field: 'campaignEndDate',
    headerName: 'End Date',
    editable: true,
    width: 120,
  },
  {
    field: 'schedulercode',
    headerName: 'Scheduler Code',
    editable: true,
    width: 120,
  },

  {
    field: 'campaignName',
    headerName: 'Campaign Name',
    editable: true,
    width: 150,
    type: 'string',
  },
  {
    field: 'campaignType',
    headerName: 'Campaign Type',
    editable: true,
    width: 150,
    type: 'string',
  },
  {
    field: 'campaignSubType',
    headerName: 'Campaign Sub Type',
    editable: true,
    width: 170,
    type: 'string',
  },
];

export const CAMPAIGN_TYPE_GROUP_COLUMNS = [
  {
    field: 'parentCampaignTypeDetails',
    headerName: 'Parent Campaign Type Group',
    flex: 1,
    type: 'string',
    valueGetter: params => {
      //Concatenate the text values of parentCampaignTypeDetails for search
      return params.length ? params?.map(parentDetail => parentDetail.text).join(', ') : '';
    },
    renderCell: params => (
      <Box>
        {params.value.split(', ').map((text, index) => (
          <div key={index}>{text}</div>
        ))}
      </Box>
    ),
  },
  {
    field: 'childCampaignTypeDetails',
    headerName: 'Child Campaign Type Groups',
    flex: 1,
    type: 'string',
    valueGetter: params => {
      // Concatenate the text values of childCampaignTypeDetails for search
      return params.length ? params?.map(childDetail => childDetail.text).join(', ') : '';
    },
    renderCell: params => (
      <Box>
        {params.value.split(', ').map((text, index) => (
          <div key={index}>{text}</div>
        ))}
      </Box>
    ),
  },
  {
    field: 'name',
    headerName: 'Custom Name For Campaign Type Group',
    flex: 1,
    type: 'string',
  },
];

export const LENDING_DEALS_TABLE_COLUMNS = [
  { field: 'primary_isbn', headerName: 'ISBN', width: 130 },
  {
    field: 'priority',
    headerName: 'Priority',
    width: 200,
    valueGetter: (_, row) => {
      const value = row.priority;
      if (!value) return '';
      const priorities = value.split(',');
      const labels = priorities
        .map(p => LENDING_DEALS_PRIORITY_TYPE_OPTIONS.find(opt => opt.value === p)?.label)
        .filter(Boolean);
      return labels.join(', ');
    },
  },
  {
    field: 'title',
    headerName: 'Title',
    width: 150,
    renderCell: params => generateBookDetailLink(params.row.primary_isbn, params.row.title),
  },
  {
    field: 'authordisplayname',
    headerName: 'Authors',
    width: 150,
  },
  { field: 'asin', headerName: 'Asin', width: 130 },
  { field: 'publisher', headerName: 'Publisher', width: 150 },
  { field: 'batch', headerName: 'Batch', width: 150, valueGetter: (_, row) => row?.bookdata?.batch },
  {
    field: 'bookScore',
    headerName: 'Book Score',
    flex: 1,
    minWidth: 80,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'firstHalfAvg',
    headerName: '1st Half Avg',
    flex: 1,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'secondHalfAvg',
    headerName: '2nd Half Avg',
    flex: 1,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'series_name',
    headerName: 'Series Name',
    width: 150,
    renderCell: displayHtmlContent,
  },
  {
    field: 'series',
    headerName: 'Series',
    width: 80,
    valueGetter: (_, row) => (row.series_name ? 'Yes' : 'No'),
  },
  { field: 'volume', headerName: 'Series Volume', width: 100, type: 'number', headerAlign: 'center', align: 'center' },
  {
    field: 'totalNumberOfTitlesInSeriesWithSameAuthor',
    headerName: 'Total Books in the series by the same author',
    width: 150,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'isAllTitlesRecommendedForAuthorWithSameSeries',
    headerName: 'With this nomination will all series books being in the results by same author',
    width: 150,
  },
  {
    field: 'totalTitlesRunningInKUBySameAuthor',
    headerName: 'Total number of titles in KU by same Author',
    width: 150,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'totalTitlesRunningInKUBySameAuthorAndSameSeries',
    headerName: 'Total number of titles in KU by same author and same series',
    width: 150,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  { field: 'bundle', headerName: 'Bundle', width: 150 },
  {
    field: 'customcategories',
    headerName: 'ORM Categories',
    width: 200,
    type: 'string',
    valueGetter: (_, row) => row?.customcategories?.map(value => value?.Name)?.join(', ') || '',
  },
  { field: 'bisacs', headerName: 'Bisacs', width: 300, valueGetter: value => value?.join(', ') || '' },
  { field: 'pub_date', headerName: 'Pub Date', ...dateColumnConfig },
  { field: 'onsaledate', headerName: 'On SaleDate', ...dateColumnConfig },
  { field: 'frontlist', headerName: 'FrontList', width: 80 },
  {
    field: 'awards',
    headerName: 'Awards',
    flex: 1,
    minWidth: 130,
    valueGetter: value => value?.map(value => value.awardname),
  },
  {
    field: 'dlp',
    headerName: 'US DLP',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    width: 100,
    valueGetter: (_, row) => row?.bookdata?.US?.dlp,
  },
  {
    field: 'last30Units',
    headerName: 'Amazon Units sold last 30 days',
    type: 'number',
    width: 150,
    align: 'left',
    headerAlign: 'left',
    valueGetter: (_, row) => row.bookdata?.US?.salesByRetailer?.Amazon?.last30Units,
  },
  {
    field: 'last30Proceeds',
    headerName: 'Amazon Proceeds last 30 days ',
    type: 'number',
    width: 150,
    align: 'left',
    headerAlign: 'left',
    valueGetter: (_, row) => row.bookdata?.US?.salesByRetailer?.Amazon?.last30Proceeds,
  },

  {
    field: 'last90GVDaily',
    headerName: 'Amazon GV last 90 days',
    type: 'number',
    width: 150,
    align: 'left',
    headerAlign: 'left',
    valueGetter: (_, row) => row.bookdata?.US?.araTraffic?.last90GVDaily,
  },
  {
    field: 'last90Units',
    headerName: 'Amazon Units sold last 90 days',
    type: 'number',
    width: 150,
    align: 'left',
    headerAlign: 'left',
    valueGetter: (_, row) => row.bookdata?.US?.salesByRetailer?.Amazon?.last90Units,
  },
  {
    field: 'last90Proceeds',
    headerName: 'Amazon Proceeds last 90 days',
    type: 'number',
    width: 150,
    align: 'left',
    headerAlign: 'left',
    valueGetter: (_, row) => row.bookdata?.US?.salesByRetailer?.Amazon?.last90Proceeds,
  },
  {
    field: 'last30consumerPrice',
    headerName: 'Average Consumer Price over the previous 30 days',
    type: 'number',
    width: 150,
    align: 'left',
    headerAlign: 'left',
    valueGetter: (_, row) => row.bookdata?.US?.consumerPrice?.last30consumerPrice,
  },
  {
    field: 'latestRating',
    headerName: 'Amazon Rating',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    width: 120,
    valueGetter: (_, row) => row.bookdata?.US?.latestRating,
  },
  {
    field: 'latestReviews',
    headerName: 'Amazon Reviews',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    width: 120,
    valueGetter: (_, row) => row.bookdata?.US?.latestReviews,
  },
  {
    field: 'lastCampaignTypeName',
    headerName: 'Last Campaign type',
    width: 150,
    valueGetter: (_, row) => row?.bookdata?.campaignInfo?.lastCampaignTypeName,
    type: 'string',
  },
  {
    field: 'lastCampaignEndDate',
    headerName: 'Last Campaign End Date',
    width: 150,
    valueGetter: (_, row) => row?.bookdata?.campaignInfo?.lastCampaignEndDate,
  },
  {
    field: 'nextCampaignTypeName',
    headerName: 'Next Campaign Type',
    width: 150,
    valueGetter: (_, row) => row?.bookdata?.campaignInfo?.nextCampaignTypeName,
  },
  {
    field: 'nextCampaignStartDate',
    headerName: 'Next Campaign Start Date',
    width: 150,
    valueGetter: (_, row) => row?.bookdata?.campaignInfo?.nextCampaignStartDate,
  },
  {
    field: 'lastBookBubCampaignStartDate',
    headerName: 'Title in last BookBub Campaign start date',
    width: 150,
    valueGetter: (_, row) => {
      const bookbubFeaturedDealsCampaign = row?.bookdata?.campaignInfo?.byCampaignType?.find(
        campaign => campaign?.campaignTypeId === 3
      );
      return (
        getComparableCampaignDate(bookbubFeaturedDealsCampaign?.lastCampaignStartDate) ||
        getComparableCampaignDate(bookbubFeaturedDealsCampaign?.nextCampaignStartDate)
      );
    },
  },
  {
    field: 'previouslyInKU',
    headerName: 'Previously in KU',
    width: 150,
    valueGetter: (_, row) =>
      isValidDateFormat(row?.kindleUnlimitedCampaign?.enddate) ? new Date(row?.kindleUnlimitedCampaign?.enddate) : null,
    valueFormatter: value => FormatDateString(value, 'MM/DD/YYYY'),
    type: 'date',
  },
  {
    field: 'isAvailableInPrimeCampaign',
    headerName: 'Availability in Prime',
    width: 150,
    valueGetter: (_, row) => row?.activePrimeReadingCampaign?.name,
  },
  {
    field: 'reason',
    headerName: 'Reason',
    width: 250,
  },
];

export const TSD_REPORT_COLUMNS = [
  { headerName: 'Title', field: 'title', type: 'string', width: 150 },
  { headerName: 'Primary Isbn', field: 'primary_isbn', width: 150 },
  { headerName: 'Asin', field: 'asin', type: 'string', width: 150 },
  {
    headerName: 'Author',
    field: 'author',
    width: 150,
    type: 'string',
    renderCell: ({ row }) => generateAuthorSocialDataLink(row.authorFirebrandId, row.author),
  },
  {
    headerName: 'Series Name',
    field: 'seriesName',
    width: 150,
    type: 'string',
    renderCell: ({ value }) => {
      return <Markup content={value} />;
    },
  },
  {
    headerName: 'Milestone Event Name',
    field: 'milestone',
    type: 'string',
    width: 150,
  },
  { headerName: 'Publisher Name', field: 'publisher', type: 'string', width: 100 },
  { headerName: 'Top Opportunity Title', field: 'isTopOpportunityTitle', width: 100, type: 'bool' },
  {
    headerName: 'Revenue',
    field: 'orderedRevenue',
    width: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    headerName: 'Change in Revenue over Prior Period',
    field: 'orderedRevenuePriorDay',
    width: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    valueFormatter: value => {
      return `${value}`;
    },
  },
  { headerName: 'Units', field: 'orderedUnits', width: 100, type: 'number', align: 'left', headerAlign: 'left' },
  {
    headerName: 'Change in Units over Prior Period',
    field: 'orderedUnitsPriorDay',
    width: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    valueFormatter: value => {
      return `${value}`;
    },
  },
  {
    headerName: 'Average Sales Price',
    field: 'avgSalesPrice',
    width: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    headerName: 'Average Sales Price - Prior Period',
    field: 'avgSalesPricePriorDay',
    width: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    headerName: 'Change in Glance View – Prior Period',
    field: 'GVChangePriorDay',
    width: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    valueFormatter: value => {
      return `${value}`;
    },
    classes: (cell, row) => {
      if (row.GVChangePriorDay) {
        const data = !Object.is(Number(row.GVChangePriorDay), NaN) ? Number(row.GVChangePriorDay) : '';
        if (!data) return;
        if (data >= 20 && data < 60) {
          return 'colorClassOne';
        } else if (data >= 60 && data < 100) {
          return 'colorClassTwo';
        } else if (data >= 100) {
          return 'colorClassThree';
        }
      }
      return;
    },
  },
  {
    headerName: '% Of total Glance Views',
    field: 'GVPct',
    width: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    classes: (cell, row) => {
      if (row.GVPct) {
        const data = !Object.is(Number(row.GVPct), NaN) ? Number(row.GVPct) : '';
        if (!data) return;
        if (data >= 0.18) {
          return 'colorClassFour';
        }
      }
    },
  },
  {
    headerName: 'Current Consumer Price',
    field: 'CurrentConsumerPrice',
    width: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    headerName: 'GlanceView',
    field: 'lastGVDaily',
    width: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    headerName: 'Conversion Rate',
    field: 'lastConversionRateDaily',
    width: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    headerName: 'Change In Conversion Rate - Prior Period',
    field: 'changeConversionPriorPeriod',
    width: 150,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    valueFormatter: value => {
      return `${value}`;
    },
  },
  { headerName: 'Last Campaign Type', field: 'lastCampaignType', type: 'string', width: 150 },
  {
    headerName: 'Last Campaign Start Date',
    field: 'lastCampaignStartDate',
    ...dateColumnConfig,
  },
  {
    headerName: 'Last Campaign End Date',
    field: 'lastCampaignEndDate',
    ...dateColumnConfig,
  },
  {
    headerName: 'Last Campaign Promo Price',
    field: 'lastCampaignPromoPrice',
    width: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  { headerName: 'Last Campaign Type for Author', field: 'lastAuthorCampaignType', type: 'string', width: 150 },
  {
    headerName: 'Last Campaign Start date for Author',
    field: 'lastAuthorCampaignStartDate',
    ...dateColumnConfig,
  },
  {
    headerName: 'Last Campaign End Date for Author',
    field: 'lastAuthorCampaignEndDate',
    ...dateColumnConfig,
  },
  {
    headerName: 'Campaign by Author on Same Date',
    field: 'islastAuthorCampaignDateEqRepDate',
    width: 150,
    type: 'bool',
  },
];

export const SUBMITED_SUBMISSION_COLUMNS = [
  { field: 'name', headerName: 'Submission Name', flex: 1, type: 'string' },
  {
    field: 'campaigntype',
    headerName: 'Campaign Type',
    flex: 1,
    type: 'string',

    renderCell: ({ row }) => {
      return row.campaigntypename ? row.campaigntypename : '';
    },
    valueGetter: (_, row) => row.campaigntypename,
  },
  {
    field: 'startdate',
    headerName: 'Start Date',
    width: 100,
    ...dateColumnConfig,
  },
  {
    field: 'enddate',
    headerName: 'End Date',
    width: 100,
    ...dateColumnConfig,
  },
  { field: 'createdbyname', headerName: 'Created By', flex: 1, type: 'string' },
];

export const SUBMISSION_ERROR_COLUMNS = [
  { field: 'name', headerName: 'Submission Name', flex: 1, type: 'string' },
  { field: 'title', headerName: 'Title', flex: 1, type: 'string' },
  {
    field: 'startdate',
    headerName: 'Start Date',
    width: 100,
    ...dateColumnConfig,
  },
  {
    field: 'enddate',
    headerName: 'End Date',
    width: 100,
    ...dateColumnConfig,
  },
  { field: 'errorMessage', headerName: 'Error', flex: 1, type: 'string' },
];

export const SUBMISSION_MOVE_TITLE_ERROR_COLUMNS = [
  { field: 'title', headerName: 'Title', flex: 1, type: 'string' },
  { field: 'primary_isbn', headerName: 'Primary Isbn', flex: 1, type: 'string' },
  { field: 'authors', headerName: 'Authors', flex: 1, type: 'string' },
];
export const USER_LIST_COLUMNS = [
  {
    headerName: 'First Name',
    field: 'first_name',
    minWidth: 150,
  },
  {
    headerName: 'Last Name',
    field: 'last_name',
    minWidth: 150,
  },
  {
    headerName: 'Email',
    field: 'email',
    flex: 1,
  },
  {
    headerName: 'Role',
    field: 'userrole',
    width: 150,
    valueGetter: value => value?.role,
  },
  {
    headerName: 'Group',
    field: 'groups',
    minWidth: 150,
    valueGetter: value => value?.join(','),
  },
  {
    headerName: 'Last login',
    field: 'last_login',
    minWidth: 150,
    ...dateColumnWithTimeConfig,
  },
  {
    headerName: 'Last Verified',
    field: 'last_verified_date',
    minWidth: 150,
    ...dateColumnWithTimeConfig,
  },
];

export const USER_ROLE_COLUMNS = allRoutePermission => {
  return [
    {
      headerName: 'Role',
      field: 'role',
      flex: 1,
      minWidth: 150,
    },
    {
      headerName: 'Action based Permissions',
      field: 'rolepermission',
      type: 'string',
      flex: 1,
      minWidth: 150,
      valueGetter: value => {
        if (value && value.length) {
          return value.map(v => `${v.name}`).join(',\n');
        } else {
          return '';
        }
      },
    },
    {
      headerName: 'Excluded Routes',
      field: 'routepermissions',
      type: 'string',
      flex: 1,
      minWidth: 150,
      valueGetter: params => {
        // Ensure params.value is an array, or initialize it as an empty array
        const includedRouteIds = Array.isArray(params) ? params : [];

        // Filter out the routes that are not included in routepermissions
        const excludedRoutes = allRoutePermission
          .filter(route => !includedRouteIds.includes(route._id.toString())) // Exclude included routes
          .map(route => route.title) // Map the remaining (excluded) routes to their titles
          .join(',\n'); // Join the titles with a newline character

        return excludedRoutes || 'Full Permission';
      },
    },
  ];
};

export const TRIGGER_TITLE_HISTORY_COLUMNS = [
  {
    field: 'name',
    headerName: 'Label',
    minWidth: 150,
    flex: 1,
  },
  {
    field: 'previous',
    headerName: 'Previous value',
    flex: 1,
    renderCell: renderTriggerHistoryCell,
  },
  {
    field: 'updated',
    headerName: 'Updated value',
    flex: 1,
    renderCell: renderTriggerHistoryCell,
  },
  {
    field: 'approvedBy',
    headerName: 'Approved By',
    flex: 0.5,
    minWidth: 120,
  },
  {
    field: 'updatedBy',
    headerName: 'Updated By',
    flex: 0.5,
    minWidth: 120,
  },
  {
    field: 'version',
    headerName: 'Version',
    minWidth: 80,
  },
];

export const BULK_DELETE_CREATED_CAMPAIGN_COLUMNS = [
  {
    field: 'name',
    headerName: 'name',
    minWidth: 150,
    flex: 1,
    renderCell: ({ row }) => generateCampaignLinkNew(row?._id, row?.name),
  },
  {
    field: 'startdate',
    headerName: 'Start Date',
    flex: 1,
    ...dateColumnConfig,
  },
  {
    field: 'enddate',
    headerName: 'End Date',
    flex: 1,
    ...dateColumnConfig,
  },
];

export const BULK_DELETE_INVALID_TITLE_COLUMNS = [
  { field: 'isbn', headerName: 'Primary ISBN', flex: 1, type: 'string', renderCell: displayError },
  { field: 'asin', headerName: 'ASIN', flex: 1, type: 'string', renderCell: displayError },
  {
    field: 'start_date',
    headerName: 'Upload Start Date',
    flex: 1,
    ...dateColumnConfig,
  },
  {
    field: 'end_date',
    headerName: 'Upload End Date',
    flex: 1,
    ...dateColumnConfig,
  },
  { field: 'countries', headerName: 'Countries', flex: 1, type: 'string' },
];

export const BULK_DELETE_COLUMNS = [
  {
    field: 'title',
    headerName: 'Title',
    minWidth: 150,
    flex: 1,
  },
  { field: 'isbn', headerName: 'Primary ISBN', flex: 1, type: 'string' },
  { field: 'asin', headerName: 'ASIN', flex: 1, type: 'string' },
  { field: 'active', headerName: 'Active', flex: 1, renderCell: renderBooleanStatus },
  {
    field: 'start_date',
    headerName: 'Upload Start Date',
    flex: 1,
    type: 'date',
    valueGetter: value => (isValidDateFormat(value) ? new Date(value) : null),
    valueFormatter: value => FormatDateString(value, 'MM/DD/YYYY'),
  },
  {
    field: 'end_date',
    headerName: 'Upload End Date',
    flex: 1,
    type: 'date',
    valueGetter: value => (isValidDateFormat(value) ? new Date(value) : null),
    valueFormatter: value => FormatDateString(value, 'MM/DD/YYYY'),
  },
  {
    field: 'campaign',
    headerName: 'Current Campaign Name',
    flex: 1,
    renderCell: ({ row }) => generateCampaignLinkNew(row?.campaign?._id, row?.campaign?.name),
    valueGetter: (_, row) => {
      return row?.campaign?.name;
    },
  },
  {
    field: 'campaignstartdate',
    headerName: 'Start Date',
    flex: 1,
    valueGetter: (_, row) => {
      return isValidDateFormat(row?.campaign?.startdate) ? new Date(row?.campaign?.startdate) : null;
    },
    valueFormatter: value => FormatDateString(value, 'MM/DD/YYYY'),
  },
  {
    field: 'campaignenddate',
    headerName: 'End Date',
    flex: 1,
    valueGetter: (_, row) => {
      return isValidDateFormat(row?.campaign?.enddate) ? new Date(row?.campaign?.enddate) : null;
    },
    valueFormatter: value => FormatDateString(value, 'MM/DD/YYYY'),
  },
];

export const KU_DEACTIVATION_PREVIEW_COLUMNS = [
  { field: 'asin', headerName: 'ASIN', flex: 1, type: 'string' },
  {
    field: 'enddate',
    headerName: 'Requested Deactivation Date',
    flex: 1,
    type: 'string',
    valueFormatter: value => FormatDateString(value, 'MM/DD/YYYY'),
  },
];

export const KU_DEACTIVATION_RESULT_COLUMNS = [
  { field: 'asin', headerName: 'ASIN', flex: 1, type: 'string' },
  {
    field: 'status',
    headerName: 'Status',
    flex: 0.8,
    renderCell: ({ value }) => (
      <Typography variant='body2' color={value === 'success' ? 'success.main' : 'error.main'}>
        {value}
      </Typography>
    ),
  },
  {
    field: 'originalCampaignName',
    headerName: 'Original Campaign',
    flex: 1.5,
    renderCell: ({ row }) =>
      row.originalCampaignId ? generateCampaignLinkNew(row.originalCampaignId, row.originalCampaignName) : null,
  },
  {
    field: 'newCampaignName',
    headerName: 'Created Campaign',
    flex: 1.5,
    renderCell: ({ row }) =>
      row.newCampaignId ? generateCampaignLinkNew(row.newCampaignId, row.newCampaignName) : null,
  },
  { field: 'message', headerName: 'Message', flex: 2, type: 'string' },
];

export const TAG_GENERATION_COLUMNS = [
  {
    field: 'image',
    headerName: 'Book Image',
    renderCell: ({ row }) => {
      let bookCoverUrl = BuildServerlessBookCoverImageUrl(IMAGESIZES.BC_THUMBNAIL, row.image);
      return (
        <a href={`/book/${row.primary_isbn}`} rel='noreferrer' target='_blank'>
          <img style={{ width: '50px' }} alt='' src={bookCoverUrl} />
        </a>
      );
    },
    width: 80,
  },
  {
    field: 'title',
    headerName: 'Title',
    width: 170,
    renderCell: ({ row }) => displayTitleLink(row.primary_isbn, row.title),
    type: 'string',
  },
  { headerName: 'Author', field: 'author', minWidth: 150, valueGetter: (_, row) => row.bookInfo?.authordisplayname },
  // { headerName: 'Pubisher', field: 'pubisher', minWidth: 150, valueGetter: (_, row) => row.bookInfo?.publisher },
];

export const TAG_SUMMARY_COLUMNS = [
  { field: 'tag', headerName: 'Tag', flex: 1 },
  { field: 'occurrenceCountInImageTags', headerName: 'Occurrence Count in Image Tags', flex: 1 },
  { field: 'occurrenceCountInOpenAiTags', headerName: 'Occurrence Count in OpenAI Tags', flex: 1 },
];

const showPricelogError = row => {
  if (row.finalprice === 0) {
    return 'error';
  } else if (new Date(row.effectivedate) > new Date(row.expirationdate)) {
    return 'error';
  } else {
    return '';
  }
};
export const PRICELOG_UPDATE_PAYLOAD_COLUMNS = [
  {
    field: 'ean13',
    headerName: 'ISBN',
    flex: 1,
    type: 'string',
    valueGetter: (value, row) => (showPricelogError(row) === 'error' ? `${value} (Error)` : value),
    renderCell: ({ value, row }) => {
      return (
        <Typography color={showPricelogError(row)} variant='subtitle2'>
          {value}
        </Typography>
      );
    },
  },
  { field: 'pricetype_desc', headerName: 'Price Type', flex: 1, type: 'string' },
  { field: 'currencytype_desc', headerName: 'Currency', flex: 1, type: 'string' },
  { field: 'finalprice', headerName: 'Price', flex: 1, type: 'string' },
  {
    field: 'effectivedate',
    headerName: 'Effective Date',
    ...dateColumnConfig,
  },
  {
    field: 'expirationdate',
    headerName: 'Expiration Date',
    ...dateColumnConfig,
  },
  { field: 'pricekey', headerName: 'Price Key', flex: 1, type: 'string' },
  { field: 'activeind', headerName: 'Active', flex: 1, type: 'string' },
  { field: 'deleteind', headerName: 'Delete', flex: 1, type: 'string' },
  { field: 'createdAt', headerName: 'Created At', flex: 1, ...dateColumnWithTimeConfig },
  { field: 'distributiontemplate', headerName: 'Template', flex: 1, type: 'string' },
];

export const PRICELOG_UPDATE_LOGS_COLUMNS = [
  { field: 'batchId', headerName: 'BatchId', flex: 1, type: 'string' },
  {
    field: 'pricelogEntries',
    headerName: 'Total pricelog entries',
    flex: 1,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    valueGetter: value => value?.length,
  },
  { field: 'createdAt', headerName: 'Created At', flex: 1, type: 'string', ...dateColumnWithTimeConfig },
  { field: 'feedtype', headerName: 'Feed Type', flex: 1, type: 'string' },
  { field: 'feedsubtype', headerName: 'Feed Sub Type', flex: 1, type: 'string' },
];

export const SHARED_DRAFT_INVALID_TITLE_COLUMNS = [
  { field: 'index', headerName: 'Index', flex: 1 },
  { field: 'ISBN', headerName: 'Primary ISBN', flex: 1, type: 'string', renderCell: displayError },
];

export const SHARED_DRAFT_INVALID_INACTIVE_TITLE_COLUMNS = [
  { field: 'primaryisbn', headerName: 'Primary ISBN', flex: 1, type: 'string', renderCell: displayError },
  { field: 'title', headerName: 'Title', flex: 1, type: 'string' },
  { field: 'reason', headerName: 'Reason', flex: 1, type: 'string' },
];

export const EDIT_TITLE_FOR_CAMPAIGN_CREATION_COLUMNS = [
  { field: 'sequence', headerName: 'Seq', width: 20, type: 'number', align: 'left', headerAlign: 'left' },
  // { field: 'primaryisbn', headerName: 'Primary ISBN', type: 'string', width: 150 },
  { field: 'title', headerName: 'Book Title', type: 'string', minWidth: 200, flex: 1 },

  { field: 'dlp', headerName: 'Price', type: 'number', align: 'left', headerAlign: 'left' },
  {
    field: 'promoprice',
    headerName: 'Promo Price',
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    width: 100,
    editable: true,
  },
  { field: 'retailers', headerName: 'Retailers', type: 'string', width: 200, editable: true },
  { field: 'countries', headerName: 'Countries', type: 'string', width: 200, editable: true },

  {
    field: 'titleLevelMonthlyBaseline',
    headerName: 'Monthly Title Level Baseline',
    width: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'titleLevelMonthlyProratedUplift',
    headerName: 'Prorated Monthly Title-Level Uplift',
    width: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  { field: 'notes1', headerName: 'Notes1', type: 'string', width: 100, editable: true },
  { field: 'notes2', headerName: 'Notes2', type: 'string', width: 100, editable: true },
  { field: 'attribute', headerName: 'Attribute', width: 100, editable: true },
  {
    field: 'adUnit',
    headerName: 'Ad Unit',
    width: 80,
    type: 'singleSelect',
    valueOptions: [true, false],
    editable: true,
  },
  {
    field: 'isFreeBook',
    headerName: 'Free',
    type: 'singleSelect',
    valueOptions: [true, false],
    width: 80,
    editable: true,
  },
  {
    field: 'isActivation',
    headerName: 'Activation',
    type: 'singleSelect',
    valueOptions: [true, false],
    width: 80,
    editable: true,
  },
  {
    field: 'isBusinessPriority',
    headerName: 'Business Priority',
    type: 'singleSelect',
    valueOptions: [true, false],
    width: 80,
    editable: true,
  },
];

export const PRICE_BAND_POST_PROCESSING_COLUMNS = [
  { field: 'primaryIsbn', headerName: 'ISBN', flex: 1, type: 'string' },
  { field: 'priceBandDLP', headerName: 'Price Band DLP', flex: 1, type: 'number', align: 'left', headerAlign: 'left' },
  { field: 'currentDLP', headerName: 'Current DLP', flex: 1, type: 'number', align: 'left', headerAlign: 'left' },
  {
    field: 'last90MostRecentFullPrice',
    headerName: 'Last 90 most Recent full price',
    flex: 1,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
];

export const DLP_UPDATE_PREVIEW = [
  ...PRICE_BAND_POST_PROCESSING_COLUMNS,
  { field: 'newDLP', headerName: 'Final DLP', flex: 1, type: 'number', align: 'left', headerAlign: 'left' },
];

export const CAMPAIGN_UPDATE_PREVIEW = [
  ...PRICE_BAND_POST_PROCESSING_COLUMNS,
  { field: 'consumerPrice', headerName: 'Promoprice', flex: 1, type: 'number', align: 'left', headerAlign: 'left' },
];

export const EDIT_BOOK_DETAIL_COLUMNS = onInternalEditChange => {
  return [
    {
      field: 'image',
      headerName: 'Book Image',
      renderCell: ({ row }) => {
        let bookCoverUrl = BuildServerlessBookCoverImageUrl(IMAGESIZES.BC_THUMBNAIL, row.image);
        return (
          <a href={`/book/${row.primaryisbn}`} rel='noreferrer' target='_blank'>
            <img style={{ width: '50px' }} alt='' src={bookCoverUrl} />
          </a>
        );
      },
      width: 80,
    },
    {
      field: 'title',
      headerName: 'Title',
      width: 250,
      editable: false,
      renderCell: ({ row }) => displayTitleLink(row.primaryisbn, row.title),
    },
    { field: 'primaryisbn', headerName: 'Primary ISBN', width: 180, editable: false },
    {
      field: 'newsletter_copy',
      headerName: 'EBB Newsletter Description',
      flex: 1.5,
      editable: true,
      renderEditCell: params => <RichTextEditorCell params={params} onInternalEditChange={onInternalEditChange} />,
      renderCell: params => (
        <Box
          sx={{
            width: '100%',
            whiteSpace: 'normal',
            overflowWrap: 'anywhere',
            wordBreak: 'break-word',
            '& p': { m: 0 },
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: params.value || '' }} />
        </Box>
      ),
    },
    {
      field: 'alternative_copy',
      headerName: 'Alternative Copy',
      flex: 1.25,
      editable: true,
      renderEditCell: params => <RichTextEditorCell params={params} onInternalEditChange={onInternalEditChange} />,
      renderCell: params => (
        <Box
          sx={{
            width: '100%',
            whiteSpace: 'normal',
            overflowWrap: 'anywhere',
            wordBreak: 'break-word',
            '& p': { m: 0 },
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: params.value || '' }} />
        </Box>
      ),
    },
    {
      field: 'newsletter_copy_content_sites',
      headerName: 'Content Copy for Newsletter',
      flex: 1.25,
      editable: true,
      renderEditCell: params => <RichTextEditorCell params={params} onInternalEditChange={onInternalEditChange} />,
      renderCell: params => (
        <Box
          sx={{
            width: '100%',
            whiteSpace: 'normal',
            overflowWrap: 'anywhere',
            wordBreak: 'break-word',
            '& p': { m: 0 },
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: params.value || '' }} />
        </Box>
      ),
    },
  ];
};
export const PRICE_INFORMATION_COLUMNS = [
  {
    field: 'priceType',
    headerName: 'Price Type',
    flex: 1,
  },
  {
    field: 'priceTypeDescription',
    headerName: 'Price Type Name',
    flex: 1,
  },

  {
    field: 'amount',
    headerName: 'Amount',
    flex: 1,
  },
  {
    field: 'currency',
    headerName: 'Currency',
    flex: 1,
  },
  {
    field: 'startDate',
    headerName: 'Start Date',
    ...dateColumnConfig,
    flex: 1,
  },
  {
    field: 'endDate',
    headerName: 'End Date',
    ...dateColumnConfig,
    flex: 1,
  },
];

export const ONIX_PRODUCTS_COLUMNS = [
  { field: 'title', headerName: 'Title', flex: 1, type: 'string' },
  { field: 'isbn', headerName: 'Primary Isbn', flex: 1, type: 'string' },
  {
    field: 'authors',
    headerName: 'Authors',
    flex: 1,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    valueGetter: value => value?.map(data => data.name)?.join(', ') || '',
  },
  { field: 'publisher', headerName: 'Publisher', flex: 1, type: 'string' },
  { field: 'series_name', headerName: 'Series', flex: 1, type: 'string' },
  { field: 'pub_date', headerName: 'Pub Date', flex: 1, type: 'string', ...dateColumnConfig },
  { field: 'processedAt', headerName: 'Created At', flex: 1, type: 'string', ...dateColumnWithTimeConfig },
  { field: 'onixFileId', headerName: 'Onix File Id', flex: 1, type: 'string' },
];

export const ONIX_PRODUCT_PRICES_COLUMNS = [
  { field: 'priceTypeDescription', headerName: 'Price Type', flex: 1, type: 'string' },
  { field: 'currency', headerName: 'Currency', flex: 1, type: 'string' },
  { field: 'amount', headerName: 'Amount', flex: 1, type: 'string' },
  { field: 'effectiveDate', headerName: 'Effective Date', flex: 1, type: 'string', ...dateColumnConfig },
  { field: 'expirationDate', headerName: 'Expiration Date', flex: 1, type: 'string', ...dateColumnConfig },
];

const synchronizerPromoTextColor = str => {
  return getPromotionLabelTextColor(str);
};

const formatFixedNumber = (value, decimals = 2) => {
  if (value === undefined || value === null) return '';
  if (typeof value === 'string' && value.trim() === '') return '';
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue.toFixed(decimals) : '';
};

const normalizeNullableNumber = value => {
  if (value === undefined || value === null) return '';
  if (typeof value === 'string' && value.trim() === '') return '';
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : '';
};

const normalizeStatusText = value => {
  if (typeof value !== 'string') return '';
  return value.trim();
};

const normalizeCampaignDecisionStatusToken = value =>
  normalizeStatusText(value)
    .toLowerCase()
    .replace(/[_\s-]+/g, '_');

const getPredictionConfidenceStatus = value => {
  const normalizedValue = normalizeStatusText(value);
  if (!normalizedValue) return null;
  const normalizedToken = normalizedValue.toLowerCase().replace(/[_\s-]+/g, ' ');
  if (normalizedToken.includes('low') || normalizedToken.includes('review')) return 'low';
  if (normalizedToken === 'normal' || normalizedToken === 'normal confidence') return 'normal';
  return 'unknown';
};

const renderSynchronizerPromo = ({ value, row, field }) => {
  const definition = row?.[`${field}Definition`] || null;
  const configuredHexColor = row?.[`${field}HexColor`] || null;
  const textColor = configuredHexColor
    ? getPromotionLabelHexColor(configuredHexColor)
    : synchronizerPromoTextColor(value);
  const labelNode = (
    <Typography
      variant='subtitle2'
      sx={{ color: textColor, whiteSpace: 'pre-line', cursor: definition ? 'help' : 'default' }}
    >
      {value}
    </Typography>
  );

  if (!definition) {
    return labelNode;
  }

  return (
    <Tooltip title={definition} arrow placement='top'>
      <Box component='span'>{labelNode}</Box>
    </Tooltip>
  );
};

const renderPredictionConfidence = ({ value }) => {
  const normalizedValue = normalizeStatusText(value);
  if (!normalizedValue) return '';
  const status = getPredictionConfidenceStatus(normalizedValue);
  const color = status === 'low' ? 'warning' : status === 'normal' ? 'success' : 'default';
  const variant = status === 'low' ? 'filled' : 'outlined';
  return (
    <Chip size='small' label={normalizedValue} color={color} variant={variant} sx={getWarningChipSx(color, variant)} />
  );
};

const toFiniteCampaignDecisionNumber = value => {
  if (value === null || value === undefined) return null;
  if (typeof value === 'boolean') return null;
  if (typeof value === 'string' && value.trim() === '') return null;
  if (typeof value === 'object') return null;
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};

const formatCampaignDecisionScore = value => {
  const numericValue = toFiniteCampaignDecisionNumber(value);
  if (numericValue === null) return '';
  return numericValue.toLocaleString(undefined, { maximumFractionDigits: 2 });
};

const normalizeCampaignDecisionDisplayScore = (value, { treatAsModelScore = false } = {}) => {
  const numericValue = toFiniteCampaignDecisionNumber(value);
  if (numericValue === null) return null;
  const displayValue = treatAsModelScore || numericValue < 0 ? numericValue + 100 : numericValue;
  return Math.max(0, Math.min(100, displayValue));
};

const getCampaignDecisionDisplayScore = decision => {
  const explicitDisplayScore = toFiniteCampaignDecisionNumber(
    decision?.displayDecisionScore ?? decision?.decisionScoreDisplay
  );
  if (explicitDisplayScore !== null) return normalizeCampaignDecisionDisplayScore(explicitDisplayScore);

  const decisionScore = normalizeCampaignDecisionDisplayScore(decision?.decisionScore);
  if (decisionScore !== null) return decisionScore;

  return normalizeCampaignDecisionDisplayScore(
    decision?.modelRankerScore ??
      decision?.rankerCalibration?.rankerScore ??
      decision?.ranker?.selected?.modelRankerScore ??
      decision?.ranker?.selected?.rankerScore ??
      decision?.rankingScore,
    { treatAsModelScore: true }
  );
};

const formatCampaignDecisionAction = value => {
  const normalizedValue = normalizeStatusText(value);
  if (!normalizedValue) return '';
  return normalizedValue.replace(/_/g, ' ').replace(/\b\w/g, letter => letter.toUpperCase());
};

const getCampaignDecisionWarningCount = decision => {
  const readinessWarnings = Array.isArray(decision?.dataReadiness?.warnings) ? decision.dataReadiness.warnings : [];
  const missingWarnings = Array.isArray(decision?.missingDataWarnings) ? decision.missingDataWarnings : [];
  const warningCount = toFiniteCampaignDecisionNumber(decision?.dataReadiness?.warningCount);
  const recommendedWarningCount = toFiniteCampaignDecisionNumber(
    decision?.dataReadiness?.recommendedCandidateWarningCount
  );
  return Math.max(readinessWarnings.length, missingWarnings.length, warningCount ?? 0, recommendedWarningCount ?? 0);
};
const hasCampaignDecisionContent = decision =>
  Boolean(
    decision &&
      typeof decision === 'object' &&
      !Array.isArray(decision) &&
      (normalizeStatusText(decision.recommendedCampaignLabel) ||
        formatCampaignDecisionAction(decision.recommendedAction) ||
        normalizeStatusText(decision.confidence) ||
        getCampaignDecisionDisplayScore(decision) !== null ||
        (Array.isArray(decision.candidates) && decision.candidates.length > 0) ||
        (Array.isArray(decision.reasonCodes) && decision.reasonCodes.length > 0) ||
        getCampaignDecisionWarningCount(decision) > 0)
  );
const getCampaignDecision = row => (hasCampaignDecisionContent(row?.campaignDecision) ? row.campaignDecision : null);
const getCampaignDecisionCandidateByRank = (decision, rank) => {
  const candidates = Array.isArray(decision?.candidates) ? decision.candidates : [];
  const rankedCandidate = candidates.find(candidate => Number(candidate?.rank) === rank);
  return rankedCandidate || candidates[rank - 1] || null;
};
const formatCampaignDecisionCandidateFilterToken = value => {
  if (typeof value === 'number') return Number.isFinite(value) ? String(value) : '';
  if (typeof value !== 'string') return '';
  return String(value).trim();
};
const getCampaignDecisionCandidateDisplayLabel = candidate => {
  if (!candidate || typeof candidate !== 'object') return '';

  return (
    formatCampaignDecisionCandidateFilterToken(candidate.label) ||
    formatCampaignDecisionCandidateFilterToken(candidate.campaignType) ||
    formatCampaignDecisionCandidateFilterToken(candidate.campaignTypeTypeValue) ||
    formatCampaignDecisionCandidateFilterToken(candidate.campaignTypeCategory) ||
    formatCampaignDecisionAction(candidate.recommendedAction) ||
    ''
  );
};
const getCampaignDecisionCandidateFilterValue = candidate => {
  if (!candidate || typeof candidate !== 'object') return '';
  const campaignTypeValue = toFiniteCampaignDecisionNumber(candidate.campaignTypeValue);

  if (campaignTypeValue !== null) return String(campaignTypeValue);

  return (
    getCampaignDecisionCandidateDisplayLabel(candidate) ||
    formatCampaignDecisionCandidateFilterToken(candidate.portfolioGroup) ||
    formatCampaignDecisionCandidateFilterToken(candidate.rankerCalibration?.portfolioGroup)
  );
};
const formatCampaignDecisionCandidateSummary = candidate => {
  if (!candidate || typeof candidate !== 'object') return '';

  const summary = [
    candidate.label,
    candidate.campaignType,
    candidate.campaignTypeValue,
    candidate.campaignTypeTypeValue,
    candidate.campaignTypeCategory,
    candidate.portfolioGroup,
    candidate.rankerCalibration?.portfolioGroup,
    candidate.recommendedAction && formatCampaignDecisionAction(candidate.recommendedAction),
  ]
    .map(formatCampaignDecisionCandidateFilterToken)
    .filter(Boolean)
    .join(' | ');

  return summary || getCampaignDecisionCandidateDisplayLabel(candidate);
};
const CAMPAIGN_DECISION_CAPACITY_STATUS_LABELS = {
  pending: 'Pending capacity',
  allocated: 'Within capacity',
  capacity_reached: 'Capacity reached',
  no_capacity_limit_configured: 'No capacity configured',
  no_available_campaign_capacity: 'No capacity available',
  not_eligible: 'Not eligible',
  not_applicable: '',
};
const normalizeCampaignDecisionCapacityStatus = value => {
  if (typeof value !== 'string') return null;
  const status = normalizeCampaignDecisionStatusToken(value);
  return Object.prototype.hasOwnProperty.call(CAMPAIGN_DECISION_CAPACITY_STATUS_LABELS, status) ? status : null;
};

const getCampaignDecisionCapacityNumber = value => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  const normalizedValue = normalizeStatusText(value);
  if (!normalizedValue) return null;
  const numericValue = Number(normalizedValue);
  return Number.isFinite(numericValue) ? numericValue : null;
};

const getCampaignDecisionCandidateCapacityAllocation = candidate => {
  const capacityAllocation =
    candidate?.capacityAllocation &&
    typeof candidate.capacityAllocation === 'object' &&
    !Array.isArray(candidate.capacityAllocation)
      ? candidate.capacityAllocation
      : {};
  return {
    status:
      normalizeCampaignDecisionCapacityStatus(capacityAllocation.status) ||
      normalizeCampaignDecisionCapacityStatus(candidate?.campaignCapacityStatus),
    position:
      getCampaignDecisionCapacityNumber(capacityAllocation.position) ??
      getCampaignDecisionCapacityNumber(candidate?.campaignCapacityPosition),
    limit:
      getCampaignDecisionCapacityNumber(capacityAllocation.limit) ??
      getCampaignDecisionCapacityNumber(candidate?.campaignCapacityLimit),
  };
};
const formatCampaignDecisionCapacityPosition = allocation => {
  const status = normalizeCampaignDecisionCapacityStatus(allocation?.status);
  if (status === 'pending') return 'Allocation not finalized yet';
  if (status === 'no_capacity_limit_configured') return 'No capacity limit configured';
  const position = getCampaignDecisionCapacityNumber(allocation?.position);
  const limit = getCampaignDecisionCapacityNumber(allocation?.limit);
  if (position !== null && limit !== null) {
    return `Ranked ${position.toLocaleString()} of ${limit.toLocaleString()}`;
  }
  if (limit !== null) return `Limit ${limit.toLocaleString()}`;
  return '';
};
const getCampaignDecisionRankCapacityAllocation = (decision, candidate, rank) => {
  const candidateAllocation = getCampaignDecisionCandidateCapacityAllocation(candidate);
  const rankPrefix = `rank${rank}Capacity`;
  return {
    status:
      normalizeCampaignDecisionCapacityStatus(candidateAllocation.status) ||
      normalizeCampaignDecisionCapacityStatus(decision?.[`${rankPrefix}Status`]),
    position:
      getCampaignDecisionCapacityNumber(candidateAllocation.position) ??
      getCampaignDecisionCapacityNumber(decision?.[`${rankPrefix}Position`]),
    limit:
      getCampaignDecisionCapacityNumber(candidateAllocation.limit) ??
      getCampaignDecisionCapacityNumber(decision?.[`${rankPrefix}Limit`]),
  };
};

const getCampaignDecisionCapacityChip = allocation => {
  const status = normalizeCampaignDecisionCapacityStatus(allocation?.status);
  const label = CAMPAIGN_DECISION_CAPACITY_STATUS_LABELS[status];
  if (!label || status === 'allocated') return null;

  return {
    label,
    color: status === 'capacity_reached' || status === 'no_available_campaign_capacity' ? 'warning' : 'default',
    detail: formatCampaignDecisionCapacityPosition(allocation),
    ariaLabel: [label, formatCampaignDecisionCapacityPosition(allocation)].filter(Boolean).join(': '),
  };
};
const getCampaignDecisionRankFilterValue = (row, rank) =>
  getCampaignDecisionCandidateFilterValue(getCampaignDecisionCandidateByRank(getCampaignDecision(row), rank));

const renderCampaignDecisionRankCandidate = rank => params => {
  const decision = getCampaignDecision(params?.row);
  const candidate = getCampaignDecisionCandidateByRank(decision, rank);
  const label = getCampaignDecisionCandidateDisplayLabel(candidate);

  if (!label) {
    return (
      <Typography
        variant='caption'
        sx={{
          color: 'text.secondary',
        }}
      >
        -
      </Typography>
    );
  }

  const secondary = [
    candidate?.campaignTypeTypeValue,
    candidate?.campaignTypeCategory,
    candidate?.portfolioGroup || candidate?.rankerCalibration?.portfolioGroup,
  ]
    .map(formatCampaignDecisionCandidateFilterToken)
    .filter(Boolean)
    .join(' - ');

  const capacityChip = getCampaignDecisionCapacityChip(
    getCampaignDecisionRankCapacityAllocation(decision, candidate, rank)
  );
  const tooltip = [formatCampaignDecisionCandidateSummary(candidate), capacityChip?.detail].filter(Boolean).join(' | ');

  return (
    <Tooltip title={tooltip} arrow placement='top'>
      <Box sx={{ minWidth: 0, width: '100%', py: 0.25 }}>
        <Typography
          variant='body2'
          sx={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        >
          {label}
        </Typography>
        {capacityChip && (
          <Chip
            size='small'
            label={capacityChip.label}
            color={capacityChip.color}
            variant='outlined'
            aria-label={capacityChip.ariaLabel || capacityChip.label}
            sx={{
              mt: 0.25,
              maxWidth: '100%',
              ...getWarningChipSx(capacityChip.color),
            }}
          />
        )}
        {secondary && (
          <Typography
            variant='caption'
            sx={{
              color: 'text.secondary',
              display: 'block',
              maxWidth: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {secondary}
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
};

export const SYNCHRONIZER_CAMPAIGN_DECISION_RANK_FILTER_FIELDS = [
  'campaignDecisionRank1Campaign',
  'campaignDecisionRank2Campaign',
  'campaignDecisionRank3Campaign',
];
export const SYNCHRONIZER_CAMPAIGN_DECISION_COLUMN_FIELDS = [
  'campaignDecisionSummary',
  ...SYNCHRONIZER_CAMPAIGN_DECISION_RANK_FILTER_FIELDS,
];
export const SYNCHRONIZER_CAMPAIGN_DECISION_DEFAULT_FILTER_OPTIONS = [{ value: 'No Campaign', label: 'No Campaign' }];

const renderCampaignDecision = params => {
  const decision = getCampaignDecision(params?.row);
  const canOpen = decision && typeof params?.colDef?.onCampaignDecisionClick === 'function';

  if (!decision) {
    return (
      <Typography
        variant='caption'
        sx={{
          color: 'text.secondary',
        }}
      >
        Not decided
      </Typography>
    );
  }

  const label =
    normalizeStatusText(decision.recommendedCampaignLabel) ||
    formatCampaignDecisionAction(decision.recommendedAction) ||
    'Decision available';
  const action = formatCampaignDecisionAction(decision.recommendedAction);
  const score = formatCampaignDecisionScore(getCampaignDecisionDisplayScore(decision));
  const confidence = normalizeStatusText(decision.confidence);
  const confidenceToken = confidence.toLowerCase().replace(/[_\s-]+/g, ' ');
  const hasWarnings = getCampaignDecisionWarningCount(decision) > 0;

  return (
    <Tooltip title='Open campaign decision details' arrow placement='top'>
      <Box
        component={canOpen ? 'button' : 'span'}
        type={canOpen ? 'button' : undefined}
        onClick={event => {
          if (!canOpen) return;
          event.stopPropagation();
          params.colDef.onCampaignDecisionClick(params.row);
        }}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          gap: 0.35,
          width: '100%',
          minHeight: 52,
          p: 0,
          border: 0,
          bgcolor: 'transparent',
          color: 'inherit',
          textAlign: 'left',
          cursor: canOpen ? 'pointer' : 'default',
        }}
      >
        <Typography
          variant='body2'
          sx={{ maxWidth: '100%', fontWeight: 700, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        >
          {label}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, maxWidth: '100%', flexWrap: 'wrap' }}>
          {action && <Chip size='small' label={action} variant='outlined' />}
          {score && (
            <Typography variant='caption' sx={{ color: 'text.secondary', fontWeight: 700 }}>
              Score {score}
            </Typography>
          )}
          {confidence && (
            <Chip size='small' label={confidence} color={confidenceToken.includes('low') ? 'warning' : 'default'} />
          )}
          {hasWarnings && (
            <Chip size='small' label='Warnings' variant='outlined' color='warning' sx={getWarningChipSx('warning')} />
          )}
        </Box>
      </Box>
    </Tooltip>
  );
};

export const SIMILAR_TITLES_COLUMNS = [
  {
    field: 'title',
    headerName: 'Title',
    flex: 1,
    minWidth: 200,
    renderCell: ({ row }) => displayTitleLink(row?.primary_isbn, row?.title),
  },
  {
    field: 'authordisplayname',
    headerName: 'Authors',
    flex: 1,
    minWidth: 180,
  },
  {
    field: 'publisher',
    headerName: 'Publisher',
    flex: 1,
    minWidth: 160,
  },
  {
    field: 'category',
    headerName: 'Category',
    flex: 1,
    minWidth: 220,
    valueGetter: (_, row) => {
      const customcategories = row?.customcategories;
      if (Array.isArray(customcategories) && customcategories.length > 0)
        return customcategories
          .map(value => value?.Name || value)
          .filter(Boolean)
          .join(', ');
      return '';
    },
  },
  {
    field: 'avgProceedsLast6FullMonths',
    headerName: 'Avg Proceeds (Last 6 Full Months)',
    flex: 1,
    minWidth: 140,
    type: 'number',
    valueGetter: normalizeNullableNumber,
  },
  {
    field: 'originalBaselineMonthly',
    headerName: 'Baseline (Current Month)',
    flex: 1,
    minWidth: 140,
    type: 'number',
    valueGetter: normalizeNullableNumber,
  },
  {
    field: 'latestRating',
    headerName: 'Rating',
    flex: 1,
    minWidth: 120,
    type: 'number',
    valueGetter: (_, row) => normalizeNullableNumber(row?.bookdata?.US?.latestRating),
  },
  {
    field: 'latestReviews',
    headerName: 'Reviews',
    flex: 1,
    minWidth: 120,
    type: 'number',
    valueGetter: (_, row) => normalizeNullableNumber(row?.bookdata?.US?.latestReviews),
  },
  {
    field: 'promoRecoOrganic',
    headerName: 'Promo Recommendation',
    flex: 1,
    minWidth: 160,
    renderCell: renderSynchronizerPromo,
    sortComparator: (v1, v2) => String(v1 || '').localeCompare(String(v2 || ''), undefined, { sensitivity: 'base' }),
  },
];

export const SYNCHRONIZER_COLUMNS = [
  { field: 'isbn', headerName: 'Isbn', flex: 1, minWidth: 180 },
  {
    field: 'title',
    headerName: 'Title',
    flex: 1,
    minWidth: 250,
    renderCell: ({ row }) => displayTitleLink(row.isbn, row.title),
    valueGetter: (_, row) => row?.title || '',
  },
  {
    field: 'titleJourney',
    headerName: 'Title Journey',
    flex: 1,
    minWidth: 120,
    sortable: false,
    filterable: false,
    renderCell: params => (
      <Box
        component='button'
        type='button'
        onClick={event => {
          event.stopPropagation();
          params?.colDef?.onTitleJourneyClick?.(params.row);
        }}
        sx={{
          color: 'primary.main',
          textDecoration: 'underline',
          background: 'none',
          border: 0,
          p: 0,
          cursor: 'pointer',
          font: 'inherit',
        }}
      >
        View
      </Box>
    ),
  },
  {
    field: 'avgGvLast6FullMonths',
    headerName: 'Avg GV (Last 6 Full Months)',
    flex: 1,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  // {
  //   field: 'baselineCurrentMonthMonthly',
  //   headerName: 'Baseline Current Month (Monthly)',
  //   flex: 1,
  //   minWidth: 150,
  //   type: 'number',
  //   align: 'left',
  //   headerAlign: 'left',
  // },
  {
    field: 'avgProceedsLast6FullMonths',
    headerName: 'Avg Proceeds (Last 6 Full Months)',
    flex: 1,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'MTD_promoRecoOrganic',
    headerName: 'MTD Promo Recommendation',
    flex: 1,
    minWidth: 100,
    renderCell: renderSynchronizerPromo,
  },
  {
    field: '1_promoRecoOrganic',
    headerName: '1 year Promo Recommendation',
    flex: 1,
    minWidth: 125,
    renderCell: renderSynchronizerPromo,
  },
  {
    field: '2_promoRecoOrganic',
    headerName: '2 years Promo Recommendation',
    flex: 1,
    minWidth: 125,
    renderCell: renderSynchronizerPromo,
  },
  {
    field: '3_promoRecoOrganic',
    headerName: '3 years Promo Recommendation',
    flex: 1,
    minWidth: 125,
    renderCell: renderSynchronizerPromo,
  },
];

export const TITLE_LEVEL_BUDGET_COLUMNS = [
  { field: 'primaryIsbn', headerName: 'ISBN', minWidth: 100, flex: 1 },
  {
    field: 'title',
    headerName: 'Title',
    minWidth: 150,
    flex: 2,
    renderCell: ({ row }) => displayTitleLink(row?.primaryIsbn, row?.title),
    valueGetter: (_, row) => row?.bookInfo?.title || '',
  },
  { field: 'year', headerName: 'Year', minWidth: 80, flex: 0.6 },
  { field: 'type', headerName: 'Type', minWidth: 80, flex: 0.8 },
  { field: 'jan', headerName: 'JAN', minWidth: 85, flex: 0.5 },
  { field: 'feb', headerName: 'FEB', minWidth: 85, flex: 0.5 },
  { field: 'mar', headerName: 'MAR', minWidth: 85, flex: 0.5 },
  { field: 'apr', headerName: 'APR', minWidth: 85, flex: 0.5 },
  { field: 'may', headerName: 'MAY', minWidth: 85, flex: 0.5 },
  { field: 'jun', headerName: 'JUN', minWidth: 85, flex: 0.5 },
  { field: 'jul', headerName: 'JUL', minWidth: 85, flex: 0.5 },
  { field: 'aug', headerName: 'AUG', minWidth: 85, flex: 0.5 },
  { field: 'sep', headerName: 'SEP', minWidth: 85, flex: 0.5 },
  { field: 'oct', headerName: 'OCT', minWidth: 85, flex: 0.5 },
  { field: 'nov', headerName: 'NOV', minWidth: 85, flex: 0.5 },
  { field: 'dec', headerName: 'DEC', minWidth: 85, flex: 0.5 },
];

export const SYNCHRONIZER_RESULT_COLUMNS = [
  {
    field: 'title',
    headerName: 'Title',
    flex: 1,
    minWidth: 180,
    renderCell: ({ value, row }) => displayTitleLink(row?.isbn, value),
  },
  {
    field: 'isbn',
    headerName: 'Isbn',
    flex: 1,
    minWidth: 120,
    // renderCell: ({ value }) => <Link to={`/synchronizer?isbn=${value}`}>{value}</Link>,
  },
  {
    field: 'publisher',
    headerName: 'Publisher Name',
    description: 'Publisher of the title.',
    flex: 1,
    minWidth: 140,
  },
  {
    field: 'client',
    headerName: 'Client Name',
    description: 'Client of the title.',
    flex: 1,
    minWidth: 140,
  },
  {
    field: 'batch',
    headerName: 'Batch',
    description: 'Batch the title belongs to.',
    flex: 1,
    minWidth: 120,
  },
  {
    field: 'onsaledate',
    headerName: 'On Sale Date',
    description: 'On sale date of the title.',
    type: 'date',
    flex: 1,
    minWidth: 120,
    valueGetter: value => {
      if (!value) return null;
      const d = new Date(value);
      if (isNaN(d.getTime())) return null;
      return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    },
    valueFormatter: value => (value instanceof Date && !isNaN(value.getTime()) ? _formatDate(value, 'MM/dd/yyyy') : ''),
  },

  {
    field: 'titleJourney',
    headerName: 'Title Journey',
    flex: 1,
    minWidth: 120,
    sortable: false,
    filterable: false,
    renderCell: params => (
      <Box
        component='button'
        type='button'
        onClick={event => {
          event.stopPropagation();
          params?.colDef?.onTitleJourneyClick?.(params.row);
        }}
        sx={{
          color: 'primary.main',
          textDecoration: 'underline',
          background: 'none',
          border: 0,
          p: 0,
          cursor: 'pointer',
          font: 'inherit',
        }}
      >
        View
      </Box>
    ),
  },
  {
    field: 'trendDirection',
    headerName: 'Trend',
    description: 'Recent 3 completed months vs prior 3: target hit rate plus average performance relative to target.',
    flex: 1,
    minWidth: 150,
    type: 'singleSelect',
    valueOptions: SYNCHRONIZER_TREND_FILTER_OPTIONS,
    getOptionValue: getTrendFilterOptionValue,
    getOptionLabel: getTrendFilterOptionLabel,
    filterOperators: getSingleSelectIsOperator(),
    valueFormatter: value => TREND_LABEL_BY_DIRECTION.get(value) || 'Insufficient Data',
    renderCell: params => {
      const direction = params.value || 'insufficient_data';
      const visual = TREND_VISUALS[direction] || TREND_VISUALS.insufficient_data;
      const TrendIcon = visual.icon;
      const label = params.row?.trendLabel || params.row?.trendSummary?.trendLabel || 'Insufficient Data';
      return (
        <Tooltip title={buildTrendTooltip(params.row)}>
          <Box
            component='button'
            type='button'
            onClick={event => {
              event.stopPropagation();
              params?.colDef?.onTrendClick?.(params.row);
            }}
            sx={{
              background: 'none',
              border: 0,
              p: 0,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              maxWidth: '100%',
              color: visual.color,
            }}
          >
            <TrendIcon fontSize='small' sx={{ color: visual.color, flex: '0 0 auto' }} />
            <Typography
              component='span'
              variant='caption'
              noWrap
              sx={{ color: visual.color, maxWidth: 112, fontWeight: 600 }}
            >
              {label}
            </Typography>
          </Box>
        </Tooltip>
      );
    },
  },
  {
    field: 'timeframe',
    headerName: 'Timeframe',
    description:
      'Lookback window used by the model. MTD = current month-to-date. ' +
      'Hist18 = last 18 FULL completed months ending last month. ' +
      'Partial months are never used (except MTD).',
    flex: 1,
    minWidth: 100,
  },
  {
    field: 'avgGvLast6FullMonths',
    headerName: 'Avg GV (Last 6 Full Months)',
    description:
      'Average monthly Amazon Glance Views over the last 6 FULL completed months. ' +
      'Independent of selected timeframe. Used as a stability/context signal.',
    flex: 1,
    minWidth: 120,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'avgProceedsLast6FullMonths',
    headerName: 'Avg Proceeds (Last 6 Full Months)',
    description:
      'Average monthly proceeds ($) over the last 6 FULL completed months. ' +
      'Used as fallback baseline when original baseline is missing or zero.',
    flex: 1,
    minWidth: 120,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'marketingservices',
    headerName: 'Ignition',
    description:
      'Title type. Yes = Ignition (baseline from MySQL ignition_title_preformance). ' +
      'No = Publishing (baseline from Mongo titleLevelBudget).',
    flex: 1,
    minWidth: 80,
  },
  {
    field: 'nextCampaignName',
    headerName: 'Campaign Info',
    flex: 1,
    minWidth: 180,
    sortable: false,
    valueGetter: (_, row) => {
      const name = row?.nextCampaignName;
      if (!name || name === 'N/A') return '';
      const start = _formatDate(row.nextCampaignStartDate, 'MM/dd/yyyy') || '';
      const end = _formatDate(row.nextCampaignEndDate, 'MM/dd/yyyy') || '';
      return [name, start, end].filter(Boolean).join(' ');
    },
    renderCell: params => {
      const { nextCampaignName, nextCampaignStartDate, nextCampaignEndDate, nextCampaignId } = params?.row;
      const canReplace =
        params?.row?.isbn &&
        nextCampaignId &&
        nextCampaignName &&
        nextCampaignName !== 'N/A' &&
        typeof params?.colDef?.onReplaceTitleClick === 'function';

      // Hide completely when campaign is N/A
      const comparableNextCampaignEndDate = getComparableCampaignDate(nextCampaignEndDate);
      if (nextCampaignName === 'N/A' || !comparableNextCampaignEndDate || comparableNextCampaignEndDate < new Date()) {
        return null;
      }

      return (
        <div style={{ lineHeight: 1.25, whiteSpace: 'normal' }}>
          <div>
            <Link to={{ pathname: `/campaign/edit/${nextCampaignId}` }} target={'_blank'}>
              <strong>{nextCampaignName}</strong>
            </Link>
          </div>
          <div>Start: {_formatDate(nextCampaignStartDate, 'MM/dd/yyyy')}</div>
          <div>End: {_formatDate(nextCampaignEndDate, 'MM/dd/yyyy')}</div>
          {canReplace && (
            <Box
              component='button'
              type='button'
              sx={{
                display: 'block',
                mt: 0.5,
                fontWeight: 700,
                color: 'info.main',
                cursor: 'pointer',
                textDecoration: 'underline',
                background: 'none',
                border: 0,
                p: 0,
                font: 'inherit',
                textAlign: 'left',
              }}
              onClick={event => {
                event.stopPropagation();
                params.colDef.onReplaceTitleClick(params.row);
              }}
            >
              Swap with similar titles
            </Box>
          )}
        </div>
      );
    },
  },
  {
    field: 'promoRecoOrganic',
    headerName: 'Promo Recommendation',
    description: 'Promotion recommendation for the next-month decision.',
    flex: 1,
    minWidth: 150,
    renderCell: renderSynchronizerPromo,
  },
  {
    field: 'campaignDecisionSummary',
    headerName: 'Campaign Decision',
    description: 'Recommended campaign action and campaign path from Synchronizer Campaign Decision Engine.',
    flex: 1,
    minWidth: 230,
    sortable: false,
    filterable: false,
    renderCell: renderCampaignDecision,
  },
  {
    field: 'campaignDecisionRank1Campaign',
    headerName: 'Rank 1 Campaign',
    description: 'Top ranked Campaign Decision candidate. Use the column filter dropdown to choose a campaign type.',
    flex: 1,
    minWidth: 190,
    type: 'singleSelect',
    valueOptions: SYNCHRONIZER_CAMPAIGN_DECISION_DEFAULT_FILTER_OPTIONS,
    filterOperators: getSingleSelectIsOperator(),
    sortable: false,
    valueGetter: (_, row) => getCampaignDecisionRankFilterValue(row, 1),
    valueFormatter: value => (typeof value === 'string' ? value.trim() : ''),
    renderCell: renderCampaignDecisionRankCandidate(1),
  },
  {
    field: 'campaignDecisionRank2Campaign',
    headerName: 'Rank 2 Campaign',
    description: 'Second ranked Campaign Decision candidate. Use the column filter dropdown to choose a campaign type.',
    flex: 1,
    minWidth: 190,
    type: 'singleSelect',
    valueOptions: SYNCHRONIZER_CAMPAIGN_DECISION_DEFAULT_FILTER_OPTIONS,
    filterOperators: getSingleSelectIsOperator(),
    sortable: false,
    valueGetter: (_, row) => getCampaignDecisionRankFilterValue(row, 2),
    valueFormatter: value => (typeof value === 'string' ? value.trim() : ''),
    renderCell: renderCampaignDecisionRankCandidate(2),
  },
  {
    field: 'campaignDecisionRank3Campaign',
    headerName: 'Rank 3 Campaign',
    description: 'Third ranked Campaign Decision candidate. Use the column filter dropdown to choose a campaign type.',
    flex: 1,
    minWidth: 190,
    type: 'singleSelect',
    valueOptions: SYNCHRONIZER_CAMPAIGN_DECISION_DEFAULT_FILTER_OPTIONS,
    filterOperators: getSingleSelectIsOperator(),
    sortable: false,
    valueGetter: (_, row) => getCampaignDecisionRankFilterValue(row, 3),
    valueFormatter: value => (typeof value === 'string' ? value.trim() : ''),
    renderCell: renderCampaignDecisionRankCandidate(3),
  },
  {
    field: 'predictionConfidence',
    headerName: 'Prediction Confidence',
    description:
      'Review signal for model confidence. Low means the high-promote recommendation has a large positive prediction gap.',
    flex: 1,
    minWidth: 150,
    renderCell: renderPredictionConfidence,
  },
  {
    field: 'predictionGapFlag',
    headerName: 'Prediction Gap Flag',
    description:
      'Large residual flag generated when predicted proceeds are above recent actual proceeds by the configured MAE multiplier.',
    flex: 1,
    minWidth: 160,
    valueFormatter: value => (typeof value === 'string' ? value.trim() : ''),
  },
  {
    field: 'predictionGapMaeMultiplier',
    headerName: 'Prediction Gap MAE Multiplier',
    description: 'Signed gap used for review: (Predicted Proceeds - Recent Actual Proceeds) / segment MAE.',
    flex: 1,
    minWidth: 150,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    valueFormatter: value => formatFixedNumber(value, 3),
  },
  {
    field: 'recommendationReviewReason',
    headerName: 'Recommendation Review Reason',
    description: 'Human-readable reason attached to low-confidence review recommendations.',
    flex: 1,
    minWidth: 190,
    valueFormatter: value => (typeof value === 'string' ? value.trim() : ''),
  },
  {
    field: 'kuSegment',
    headerName: 'KU Type',
    description: 'KU bucket used to route the title to the correct segmented 2D model: Non-KU, Light KU, or Heavy KU.',
    flex: 1,
    minWidth: 140,
    type: 'singleSelect',
    valueOptions: ['Non-KU', 'Light KU', 'Heavy KU'],
    filterOperators: getSingleSelectIsOperator(),
  },
  {
    field: 'intercept',
    headerName: 'Intercept (β0)',
    description:
      'Applied Elastic Net intercept for the title’s KU segment. ' +
      'Represents background proceeds not explained by GV or Baseline.',
    flex: 1,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'incrementalProceedsPerGv',
    headerName: 'Incremental Proceeds per GV (β1)',
    description:
      'Applied Elastic Net GV coefficient for the title’s KU segment. Expected incremental proceeds generated by one unit of GV.',
    flex: 1,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },

  {
    field: 'baselineAnchorStrength',
    headerName: 'Baseline Anchor Strength (β2)',
    description:
      'Applied Elastic Net baseline coefficient for the title’s KU segment. ' +
      'Captures latent title strength anchored to the business target.',
    flex: 1,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },

  {
    field: 'baselineResolvedUsed',
    headerName: 'Fallback Baseline (Monthly)',
    description:
      'Final baseline used by the model. ' +
      'If original baseline > 0 → use it. Else → average proceeds over up to last 6 FULL completed months.',
    flex: 1,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'originalBaselineMonthly',
    headerName: 'Original Baseline (Monthly)',
    description:
      'Raw business baseline before fallback. ' +
      'Ignition: MySQL ignition_title_preformance. Can be zero' +
      'Publishing: Mongo titleLevelBudget. Can be zero.',
    flex: 1,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },

  // {
  //   field: 'baselineCurrentMonthProrated',
  //   headerName: 'Baseline Current Month (Prorated)',
  //   description:
  //     'Resolved baseline prorated by days elapsed in the current month: ' +
  //     'baselineMonthly × (days_elapsed / days_in_month). Used for MTD evaluation.',
  //   flex: 1,
  //   minWidth: 80,
  //   type: 'number',
  //   align: 'left',
  //   headerAlign: 'left',
  // },
  // {
  //   field: 'baselineUsedLastMonth',
  //   headerName: 'Baseline Used Last Month',
  //   flex: 1,
  //   minWidth: 150,
  //   type: 'number',
  //   align: 'left',
  //   headerAlign: 'left',
  // },
  {
    field: 'expectedGvNextMonthOrganic',
    headerName: 'Expected GV Next Month',
    flex: 1,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'rawPredictedProceedsOrganic',
    headerName: 'Raw Predicted Proceeds',
    description:
      'Unfloored model prediction before negative proceeds are capped at zero and before final downstream recommendation fields are displayed.',
    flex: 1,
    minWidth: 130,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    valueFormatter: value => formatFixedNumber(value, 2),
  },
  {
    field: 'interceptAdjustmentFactor',
    headerName: 'Intercept Adjustment Factor',
    description: 'Heavy KU low-GV intercept shrink factor. Blank means no intercept adjustment was applied.',
    flex: 1,
    minWidth: 145,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    valueFormatter: value => formatFixedNumber(value, 4),
  },
  {
    field: 'interceptAdjustmentReason',
    headerName: 'Intercept Adjustment Reason',
    description: 'Reason code for the Heavy KU low-GV intercept shrink or smoothing ramp.',
    flex: 1,
    minWidth: 180,
    valueFormatter: value => (typeof value === 'string' ? value.trim() : ''),
  },
  {
    field: 'predictedProceedsOrganic',
    headerName: 'Predicted Proceeds',
    description:
      'Adjusted model-predicted proceeds used for recommendation labels. Negative predictions are capped at $0.',
    flex: 1,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'recentActualProceedsUsed',
    headerName: 'Recent Actual Proceeds Used',
    description:
      'Average proceeds over the last 6 full months, used as recentActualProceeds for the review gap signal.',
    flex: 1,
    minWidth: 150,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    valueFormatter: value => formatFixedNumber(value, 2),
  },
  {
    field: 'segmentMae',
    headerName: 'Segment MAE',
    description: 'Mean absolute error for the KU segment model used to normalize the prediction gap.',
    flex: 1,
    minWidth: 120,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    valueFormatter: value => formatFixedNumber(value, 2),
  },
  {
    field: 'kuUnitsInScope',
    headerName: 'Total KU Units In Scope',
    description: 'Total KindleUnlimited units used to assign the title into the Non-KU / Light KU / Heavy KU segment.',
    flex: 1,
    minWidth: 140,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    valueFormatter: value => formatFixedNumber(value, 2),
  },
  {
    field: 'target',
    headerName: 'Target',
    description: 'Business target used for comparison. Formula: Baseline Resolved Used × Promote Threshold.',
    flex: 1,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    valueFormatter: value => formatFixedNumber(value, 2),
  },
  {
    field: 'performanceRelativeToTarget',
    headerName: 'Performance Relative to Target',
    description:
      'Raw performance ratio used by Promotion Label Configuration. ' +
      'For titles with baseline: Predicted Proceeds ÷ (Baseline Resolved Used × configured ratio). ' +
      'For titles with zero baseline: Predicted Proceeds ÷ (0.9 × Avg Proceeds Last 6 Full Months).',
    flex: 1,
    minWidth: 140,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    valueFormatter: value => formatFixedNumber(value, 3),
  },

  {
    field: 'updatedAt',
    headerName: 'Last Calculated',
    description: 'Timestamp when this result was last computed.',
    flex: 1,
    minWidth: 140,
    ...dateColumnWithTimeConfig,
  },
];

export const RATIO_CONFIGURATION_COLUMNS = [
  {
    headerName: 'Baseline From',
    field: 'baselineFrom',
    flex: 1,
  },
  { headerName: 'Baseline To', field: 'baselineTo', flex: 1 },
  { headerName: 'Ratio', field: 'ratio', flex: 1 },
  { field: 'type', headerName: 'Type', flex: 1 },
];

export const MAJOR_CAMPAIGN_CONFIGURATION_COLUMNS = [
  { headerName: 'Campaign Type', field: 'campaignTypeName', flex: 1 },
];

export const PROMOTION_LABEL_CONFIGURATION_COLUMNS = [
  {
    headerName: 'Promotion Label',
    field: 'promotionLabel',
    flex: 1,
    minWidth: 180,
    renderCell: ({ value, row }) => (
      <Typography sx={{ color: getPromotionLabelHexColor(row?.hexColor), fontWeight: 600 }}>{value}</Typography>
    ),
  },
  {
    headerName: 'Hex Color',
    field: 'hexColor',
    flex: 0.8,
    minWidth: 140,
    renderCell: ({ value }) => {
      const hexColor = getPromotionLabelHexColor(value);
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            sx={{
              width: 16,
              height: 16,
              borderRadius: 0.75,
              bgcolor: hexColor,
              border: '1px solid',
              borderColor: 'divider',
              flexShrink: 0,
            }}
          />
          <Typography variant='body2'>{hexColor}</Typography>
        </Box>
      );
    },
  },
  { headerName: 'Definition', field: 'definition', flex: 1.2, minWidth: 220 },
  {
    headerName: 'Performance Relative to Target Min',
    field: 'performanceRelativeToTargetMin',
    flex: 1,
    minWidth: 180,
    type: 'number',
  },
  {
    headerName: 'Performance Relative to Target Max',
    field: 'performanceRelativeToTargetMax',
    flex: 1,
    minWidth: 180,
    type: 'number',
  },
  {
    headerName: 'Projected Proceeds Min',
    field: 'organicProceedsMin',
    flex: 1,
    minWidth: 150,
    type: 'number',
  },
  {
    headerName: 'Projected Proceeds Max',
    field: 'organicProceedsMax',
    flex: 1,
    minWidth: 150,
    type: 'number',
  },
  {
    headerName: 'Version',
    field: 'version',
    flex: 0.5,
    minWidth: 100,
    type: 'number',
  },
];

export const PROMOTION_LABEL_CONFIGURATION_HISTORY_COLUMNS = [
  { headerName: 'Version', field: 'version', flex: 0.5, minWidth: 100, type: 'number' },
  {
    headerName: 'Promotion Label',
    field: 'promotionLabel',
    flex: 1,
    minWidth: 180,
    renderCell: ({ value, row }) => (
      <Typography sx={{ color: getPromotionLabelHexColor(row?.hexColor), fontWeight: 600 }}>{value}</Typography>
    ),
  },
  {
    headerName: 'Hex Color',
    field: 'hexColor',
    flex: 0.8,
    minWidth: 140,
    renderCell: ({ value }) => {
      const hexColor = getPromotionLabelHexColor(value);
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box
            sx={{
              width: 16,
              height: 16,
              borderRadius: 0.75,
              bgcolor: hexColor,
              border: '1px solid',
              borderColor: 'divider',
              flexShrink: 0,
            }}
          />
          <Typography variant='body2'>{hexColor}</Typography>
        </Box>
      );
    },
  },
  { headerName: 'Definition', field: 'definition', flex: 1.2, minWidth: 220 },
  {
    headerName: 'Performance Relative to Target Min',
    field: 'performanceRelativeToTargetMin',
    flex: 1,
    minWidth: 180,
    type: 'number',
  },
  {
    headerName: 'Performance Relative to Target Max',
    field: 'performanceRelativeToTargetMax',
    flex: 1,
    minWidth: 180,
    type: 'number',
  },
  {
    headerName: 'Projected Proceeds Min',
    field: 'organicProceedsMin',
    flex: 1,
    minWidth: 150,
    type: 'number',
  },
  {
    headerName: 'Projected Proceeds Max',
    field: 'organicProceedsMax',
    flex: 1,
    minWidth: 150,
    type: 'number',
  },
  {
    field: 'createdByUser',
    headerName: 'Created By',
    flex: 1,
    minWidth: 180,
    renderCell: ({ value }) => displayUserName(value),
  },
  {
    field: 'updatedByUser',
    headerName: 'Updated By',
    flex: 1,
    minWidth: 180,
    renderCell: ({ value }) => displayUserName(value),
  },
  {
    field: 'createdAt',
    headerName: 'Created At',
    minWidth: 180,
    ...dateColumnWithTimeConfig,
  },
  {
    field: 'deletedAt',
    headerName: 'Deleted At',
    minWidth: 180,
    ...dateColumnWithTimeConfig,
  },
];

const createRetailerColumns = showNoPriceCrawled =>
  RETAILERS.map(({ key, label }) => ({
    field: key,
    headerName: `${label} (%)`,
    flex: 1,
    minWidth: 120,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    ...(showNoPriceCrawled && {
      valueGetter: (_, row) => row?.noPriceCrawled?.[key] || 0,
    }),
  }));

const BASE_COLUMNS = [
  { field: 'date', headerName: 'Date', flex: 1, minWidth: 100, type: 'string' },
  {
    field: 'distinctPrimaryIsbnCount',
    headerName: 'Distinct Primary ISBN Count',
    flex: 1,
    minWidth: 150,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
];

const SUCCESS_COLUMNS = [
  {
    field: 'totalSuccessCount',
    headerName: 'Total Success Entries',
    flex: 1,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'totalFailCount',
    headerName: 'Total Failed Entries',
    flex: 1,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'totalCount',
    headerName: 'Total Entries',
    flex: 1,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
];

const NO_PRICE_COLUMNS = [
  {
    field: 'totalNoPriceCrawledCount',
    headerName: 'Total No Price Crawled',
    flex: 1,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
    valueGetter: (_, row) => row?.noPriceCrawled?.totalNoPriceCrawledCount || 0,
  },
  {
    field: 'totalCount',
    headerName: 'Total Entries',
    flex: 1,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
];

export const getCampopsColumns = showNoPriceCrawled => [
  ...BASE_COLUMNS,
  ...createRetailerColumns(showNoPriceCrawled),
  ...(showNoPriceCrawled ? NO_PRICE_COLUMNS : SUCCESS_COLUMNS),
];

export const PRICE_LOG_STATUS_REPORT_COLUMNS = [
  { field: 'date', headerName: 'Date', flex: 1, minWidth: 100, type: 'string' },
  {
    field: 'distinctPrimaryIsbnCount',
    headerName: 'Distinct Primary ISBN Count',
    flex: 1,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'totalCount',
    headerName: 'Total Entries',
    flex: 1,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'fithubSuccessCount',
    headerName: 'FITHUB Success Count',
    flex: 1,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'eloquenceSuccessCount',
    headerName: 'Eloquence Success Count',
    flex: 1,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'fithubSuccessRate',
    headerName: 'FITHUB Success Rate (%)',
    flex: 1,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
  {
    field: 'eloquenceSuccessRate',
    headerName: 'Eloquence Success Rate (%)',
    flex: 1,
    minWidth: 100,
    type: 'number',
    align: 'left',
    headerAlign: 'left',
  },
];

// AUTO_MIN_WIDTH_APPLY_START
const DEFAULT_DATA_GRID_MIN_WIDTH = 100;

const applyDefaultMinWidthToColumns = columns => {
  if (!Array.isArray(columns)) return;

  columns.forEach(column => {
    if (!column || typeof column !== 'object' || Array.isArray(column)) return;
    if (column.minWidth === undefined) {
      column.minWidth = column.width ?? DEFAULT_DATA_GRID_MIN_WIDTH;
    }
  });
};

[
  AUDIO_CONTRACT_DEFAULT_COLUMNS,
  FAILED_TITLES_COLUMNS,
  MASTER_SERVICE_REQUEST_TABLE_COLUMNS,
  MASTER_SERVICE_REQUEST_CHILD_TABLE_COLUMNS,
  EXTERNAL_SUBMISSION_PARENT_COLUMNS,
  EXTERNAL_SUBMISSION_CHILD_COLUMNS,
  APPROVED_SUBMISSION_CHILD_COLUMNS,
  SCHEDULE_CAMPAIGN_CHILD_COLUMNS,
  SCHEDULE_CAMPAIGN_COLUMNS,
  FRONT_LIST_TITLE_WIDGET_COLUMNS,
  IGNITION_BATCH_WIDGET_COLUMNS,
  IGNITION_BATCH_WIDGET_CHILD_COLUMNS,
  TITLE_COUNT_WIDGET_COLUMNS,
  ORION_SCHEDULAR_CAMPAIGN_COLUMNS,
  CAMPAIGN_HOME_CHILD_COLUMNS,
  TOP_100_TITLES,
  BLAST_CONFIGURATION_COLUMN,
  AMAZON_ELIGIBILITY_CONFIGURATION_COLUMN,
  TITLE_FORMAT_COLUMNS,
  DELETE_SELECTED_CAMPAIGN_COLUMNS,
  SEARCH_EXISTING_CAMPAIGN_COLUMNS,
  CAMPAIGN_WARNING_COLUMNS,
  CAMPAIGN_ERROR_COLUMNS,
  GOOGLE_ALERT_COLUMNS,
  DELETE_CAMPAIGN_WARNING_COLUMNS,
  FIREBRAND_COLUMNS,
  CREATE_CAMPAIGN_WARNING_COLUMNS,
  CREATE_CAMPAIGN_ERROR_COLUMNS,
  NOTIFY_CONFLICTING_CAMPAIGN_ERROR_TABLE_COLUMNS,
  CLIENT_PROFILE_LANDING_COLUMNS,
  PRIORITY_TITLE_COLUMNS,
  TITLE_FOR_AUTHOR_PUBLISHER_COLUMNS,
  AGGREGATED_HISTORICAL_DATA_LOG_COLUMNS,
  TRAFFIC_LIGHT_REPORT_COLUMNS,
  BODHI_METADATA_COLUMNS,
  TRIGGER_TITLE_CONFIGURATION_COLUMNS,
  TRIGGER_TITLE_RESULT_PARENT_COLUMNS,
  TRIGGER_TITLE_RESULT_CHILD_COLUMNS,
  TRIGGER_TITLE_DESTINATION_RESULT_COLUMNS,
  BOOKBUB_COST_CONFIGURATION_COLUMNS,
  BOOKBUB_PAGE_COUNT_CONFIGURATION_COLUMNS,
  BOOKBUB_PRIORITY_CONFIGURATION_COLUMNS,
  SDS_BOOKBUB_CATEGORY_DATA_COLUMNS,
  SDS_CUT_RATE_DATA_COLUMNS,
  SDS_PRIORITY_DATA_COLUMNS,
  SDS_GRAND_TOTAL_DATA_COLUMNS,
  DLP_PRICE_UPDATE_VIEW_COLUMNS,
  PRICELOG_VIEW_COLUMNS,
  CAMPAIGN_HOME_COLUMNS,
  BOOK_META_DATA_COLUMNS,
  BLOCK_LIST_COLUMNS,
  BOOK_DETAIL_AMAZON_QUOTE_COLUMNS,
  BOOK_DETAIL_COLUMNS,
  CAMPAIGN_TYPE_TABLE_COLUMNS,
  FACEBOOK_AD_COLUMNS,
  FACEBOOK_AD_MANAGER_COLUMNS,
  FACEBOOK_AD_CAMPAIGN_TABLE_COLUMN,
  CC_MAPPING_COLUMNS,
  PROMO_PRICE_COLUMNS,
  UPLOAD_BOOK_COLUMNS,
  MILE_STONE_COLUMNS,
  CUSTOM_CATEGORIES_MODAL_COLUMNS,
  NOMINATION_FILTER_TRACKING_COLUMNS,
  ASYNC_FILTER_TRACKING_COLUMNS,
  NOMINATION_PARENT_COLUMNS,
  ORDER_COLUMNS,
  CHILD_COLUMNS,
  RESTRICTED_TERRITORY_COLUMNS,
  PREFERENCE_TYPE_COLUMNS,
  ADD_EDIT_SHARED_DRAFT_COLUMNS,
  VALIDATE_LIST_COLUMNS,
  DRAFT_EDITABLE_COLUMNS,
  CAMPAIGN_TYPE_GROUP_COLUMNS,
  LENDING_DEALS_TABLE_COLUMNS,
  TSD_REPORT_COLUMNS,
  SUBMITED_SUBMISSION_COLUMNS,
  SUBMISSION_ERROR_COLUMNS,
  SUBMISSION_MOVE_TITLE_ERROR_COLUMNS,
  USER_LIST_COLUMNS,
  TRIGGER_TITLE_HISTORY_COLUMNS,
  BULK_DELETE_CREATED_CAMPAIGN_COLUMNS,
  BULK_DELETE_INVALID_TITLE_COLUMNS,
  BULK_DELETE_COLUMNS,
  KU_DEACTIVATION_PREVIEW_COLUMNS,
  KU_DEACTIVATION_RESULT_COLUMNS,
  TAG_GENERATION_COLUMNS,
  TAG_SUMMARY_COLUMNS,
  PRICELOG_UPDATE_PAYLOAD_COLUMNS,
  PRICELOG_UPDATE_LOGS_COLUMNS,
  SHARED_DRAFT_INVALID_TITLE_COLUMNS,
  SHARED_DRAFT_INVALID_INACTIVE_TITLE_COLUMNS,
  EDIT_TITLE_FOR_CAMPAIGN_CREATION_COLUMNS,
  PRICE_BAND_POST_PROCESSING_COLUMNS,
  PRICE_INFORMATION_COLUMNS,
  ONIX_PRODUCTS_COLUMNS,
  ONIX_PRODUCT_PRICES_COLUMNS,
  SIMILAR_TITLES_COLUMNS,
  SYNCHRONIZER_COLUMNS,
  TITLE_LEVEL_BUDGET_COLUMNS,
  SYNCHRONIZER_RESULT_COLUMNS,
  RATIO_CONFIGURATION_COLUMNS,
  MAJOR_CAMPAIGN_CONFIGURATION_COLUMNS,
  PROMOTION_LABEL_CONFIGURATION_COLUMNS,
  PROMOTION_LABEL_CONFIGURATION_HISTORY_COLUMNS,
  PRICE_LOG_STATUS_REPORT_COLUMNS,
  serviceRequestErrorColumns,
].forEach(applyDefaultMinWidthToColumns);
// AUTO_MIN_WIDTH_APPLY_END

export const INVALID_PROMO_PRICE_TITLES_COLUMNS = [
  { field: 'title', headerName: 'Title', flex: 2, type: 'string' },
  { field: 'asin', headerName: 'ASIN', flex: 1, type: 'string' },
  { field: 'primary_isbn', headerName: 'ISBN', flex: 1, type: 'string' },
  { field: 'promo_price', headerName: 'Invalid Promo Price', flex: 1, type: 'string' },
];

const TITLE_REPORT_ARRAY_JOIN_FIELDS = new Set(['bisacs']);
const TITLE_REPORT_DATE_FIELDS = new Set(['onsaledate', 'pub_date', 'withdrawnfromsaledate']);
const TITLE_REPORT_BOOLEAN_FIELDS = new Set(['active', 'isAINarrated']);
const TITLE_REPORT_NUMBER_FIELDS = new Set(['agencyPrice']);

// Per-field minimum widths so columns don't get squeezed unreadably thin as more are added — once the
// total minWidth exceeds the viewport, ORMDataGridV2's horizontal scrollbar kicks in instead.
const TITLE_REPORT_MIN_WIDTHS = {
  title: 220,
  primary_isbn: 140,
  asin: 120,
  amazon_isbn13: 140,
  authors: 200,
  publisher: 160,
  imprint: 160,
  series_name: 160,
  language: 110,
  page_count: 110,
  active: 100,
  productType: 130,
  bisac_status: 130,
  bisacs: 220,
  format: 130,
  narratedBy: 160,
  editiontype: 130,
  duration: 130,
  isAINarrated: 120,
  agencyPrice: 120,
  withdrawnfromsaledate: 160,
  client: 150,
};
const DEFAULT_TITLE_REPORT_MIN_WIDTH = 140;

// Builds ORMDataGridV2 column defs from the checked/ordered rows produced by the Title Report column picker.
export const buildTitleReportResultColumns = selectedColumns => {
  const ordered = [...(selectedColumns || [])].sort((a, b) => a.order - b.order);

  return ordered.map(column => {
    const minWidth = TITLE_REPORT_MIN_WIDTHS[column.field] || DEFAULT_TITLE_REPORT_MIN_WIDTH;

    // Same book-cover thumbnail (linking to the book detail page) used by the Nomination results grid.
    if (column.field === 'image') {
      return {
        field: column.field,
        headerName: column.title,
        width: 60,
        sortable: false,
        filterable: false,
        renderCell: getBookImage,
      };
    }

    if (column.field === 'authors') {
      return {
        field: column.field,
        headerName: column.title,
        flex: 1,
        minWidth,
        type: 'string',
        valueGetter: value =>
          Array.isArray(value)
            ? value
                .map(author => author?.display_name)
                .filter(Boolean)
                .join(', ')
            : '',
      };
    }

    if (TITLE_REPORT_ARRAY_JOIN_FIELDS.has(column.field)) {
      return {
        field: column.field,
        headerName: column.title,
        flex: 1,
        minWidth,
        type: 'string',
        valueGetter: value => (Array.isArray(value) ? value.join(', ') : value ?? ''),
      };
    }

    if (TITLE_REPORT_DATE_FIELDS.has(column.field)) {
      return { field: column.field, headerName: column.title, flex: 1, minWidth, ...dateColumnConfig };
    }

    if (TITLE_REPORT_BOOLEAN_FIELDS.has(column.field)) {
      return { field: column.field, headerName: column.title, flex: 1, minWidth, type: 'boolean' };
    }

    // Stored in the books collection as a whole number of seconds — displayed/exported as hhh:mm:ss,
    // but kept as type 'number' so grid sorting stays numeric rather than lexicographic on the string.
    if (column.field === 'duration') {
      return {
        field: column.field,
        headerName: column.title,
        flex: 1,
        minWidth,
        type: 'number',
        headerAlign: 'left',
        align: 'left',
        valueFormatter: value => formatDuration(value) ?? '',
      };
    }

    if (TITLE_REPORT_NUMBER_FIELDS.has(column.field)) {
      return {
        field: column.field,
        headerName: column.title,
        flex: 1,
        minWidth,
        type: 'number',
        headerAlign: 'left',
        align: 'left',
      };
    }

    return { field: column.field, headerName: column.title, flex: 1, minWidth, type: 'string' };
  });
};

export const SCHEDULER_CODE_CONFLICT_COLUMNS = (decisions, handleDecisionChange) => [
  { field: 'name', headerName: 'Campaign Name', flex: 1 },
  { field: 'campaigntypename', headerName: 'Campaign Type', flex: 1 },
  { field: 'schedulercode', headerName: 'Existing Code', flex: 1 },
  {
    field: 'decision',
    headerName: 'Action',
    flex: 1,
    renderCell: ({ row }) => (
      <Select
        size='small'
        fullWidth
        value={decisions[row._id] || 'keep'}
        onChange={event => handleDecisionChange(row._id, event.target.value)}
      >
        <MenuItem value='keep'>Keep Existing</MenuItem>
        <MenuItem value='overwrite'>Overwrite</MenuItem>
      </Select>
    ),
  },
];

export const SCHEDULER_CODE_CSV_ERROR_COLUMNS = [
  'Campaign_Name',
  'Campaign_Type',
  'Start_Date',
  'End_Date',
  'Scheduler_Code',
].map(field => ({
  field,
  headerName: field.replace(/_/g, ' '),
  flex: 1,
  renderCell: displayError,
}));

export const SCHEDULER_CODE_CSV_NOT_MATCHED_COLUMNS = [
  { field: 'Campaign_Name', headerName: 'Campaign Name', flex: 1 },
  { field: 'Campaign_Type', headerName: 'Campaign Type', flex: 1 },
  { field: 'Start_Date', headerName: 'Start Date', flex: 1 },
  { field: 'End_Date', headerName: 'End Date', flex: 1 },
  { field: 'statusLabel', headerName: 'Issue', flex: 1.5 },
];

const renderSchedulerCodeCampaignNameCell = ({ value, row }) => {
  if (!value) return value;
  if (!row._id) return value;

  return (
    <Link to={`/campaign/edit/${row._id}`} target={'_blank'}>
      {value}
    </Link>
  );
};

export const SCHEDULER_CODE_CSV_READY_COLUMNS = [
  { field: 'Campaign_Name', headerName: 'Campaign Name', flex: 1, renderCell: renderSchedulerCodeCampaignNameCell },
  { field: 'Campaign_Type', headerName: 'Campaign Type', flex: 1 },
  { field: 'Start_Date', headerName: 'Start Date', flex: 1 },
  { field: 'End_Date', headerName: 'End Date', flex: 1 },
  { field: 'Scheduler_Code', headerName: 'New Scheduler Code', flex: 1 },
];

export const SCHEDULER_CODE_CSV_CONFLICT_COLUMNS = handleDecisionChange => [
  { field: 'Campaign_Name', headerName: 'Campaign Name', flex: 1, renderCell: renderSchedulerCodeCampaignNameCell },
  { field: 'Campaign_Type', headerName: 'Campaign Type', flex: 1 },
  { field: 'Start_Date', headerName: 'Start Date', flex: 1 },
  { field: 'End_Date', headerName: 'End Date', flex: 1 },
  { field: 'existingSchedulerCode', headerName: 'Existing Code', flex: 1 },
  { field: 'Scheduler_Code', headerName: 'New Code', flex: 1 },
  {
    field: 'decision',
    headerName: 'Action',
    flex: 1,
    renderCell: ({ row }) => (
      <Select
        size='small'
        fullWidth
        value={row.decision}
        onChange={event => handleDecisionChange(row.rowIndex, event.target.value)}
      >
        <MenuItem value='keep'>Keep Existing</MenuItem>
        <MenuItem value='overwrite'>Overwrite</MenuItem>
      </Select>
    ),
  },
];

export const UPLOAD_AUDIBLE_ASIN_ERROR_COLUMNS = [
  { field: 'ISBN', headerName: 'ISBN', flex: 1, renderCell: displayError },
  { field: 'Audible ASIN', headerName: 'Audible ASIN', flex: 1, renderCell: displayError },
  { field: 'Country', headerName: 'Country', flex: 1, renderCell: displayError },
  { field: 'reason', headerName: 'Reason', flex: 1, renderCell: displayError },
];

// Books not yet backfilled only have the US ASIN in audible_asin
const formatAudibleAsins = row => {
  const audibleAsins = row?.audible_asins?.length
    ? row.audible_asins
    : row?.audible_asin
    ? [{ country: 'US', asin: row.audible_asin }]
    : [];
  return audibleAsins.map(({ country, asin }) => `${country}: ${asin}`).join(', ');
};

export const UPLOAD_AUDIBLE_ASIN_AUDIO_TITLE_COLUMNS = [
  { field: 'primary_isbn', headerName: 'ISBN', minWidth: 140, flex: 1 },
  {
    field: 'title',
    headerName: 'Title',
    minWidth: 220,
    flex: 2,
    renderCell: ({ row }) => displayTitleLink(row.primary_isbn, row.title) || row.title,
  },
  { field: 'authordisplayname', headerName: 'Author', minWidth: 160, flex: 1 },
  { field: 'publisher', headerName: 'Publisher', minWidth: 160, flex: 1 },
  { field: 'isAINarrated', headerName: 'AI Narrated', minWidth: 110, type: 'boolean' },
  {
    field: 'audible_asins',
    headerName: 'Audible ASIN',
    minWidth: 200,
    flex: 1.5,
    valueGetter: (value, row) => formatAudibleAsins(row),
  },
  { field: 'asin', headerName: 'Amazon ASIN', minWidth: 130, flex: 1 },
];

export const UPLOAD_AUDIBLE_ASIN_UPDATED_COLUMNS = [
  {
    field: 'title',
    headerName: 'Title',
    flex: 1,
    renderCell: ({ row }) => displayTitleLink(row.primary_isbn, row.title) || row.primary_isbn,
  },
  { field: 'primary_isbn', headerName: 'Primary ISBN', flex: 1 },
  { field: 'country', headerName: 'Country', flex: 1 },
  { field: 'audible_asin', headerName: 'Audible ASIN', flex: 1 },
];
